/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 56);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(63);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(69)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return INIT_DICTIONARY; });
/* unused harmony export LIVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GET_STANDINGS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GET_STANDINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GET_STANDINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return GET_STATISTICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_LAST_MATCHES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_LAST_MATCHES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_LAST_MATCHES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GET_SQUAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GET_SQUAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_SQUAD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_CLUB_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_CLUB_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_CLUB_INFO_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_LINEUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_LINEUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_LINEUPS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_MATCHINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_LINEUPS_BASKET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_LINEUPS_BASKET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_LINEUPS_BASKET_ERROR; });
/* unused harmony export GET_PROBABILI_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_PROBABILI_SUCCESS; });
/* unused harmony export GET_PROBABILI_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_PROBABILI_HOME_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_PROBABILI_HOME_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_PROBABILI_HOME_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_PROBABILI_AWAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_PROBABILI_AWAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_PROBABILI_AWAY_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_HEADER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_HEADER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_HEADER_INFO_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_TEAM_CALENDAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GET_TEAM_CALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GET_TEAM_CALENDAR_ERROR; });
/* unused harmony export CLEAR_LOCAL_STORAGE */
/* unused harmony export SET_LOCAL_STORAGE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return UPDATE_LOCAL_STORAGE; });
/* unused harmony export TYPE_HUB */
/* unused harmony export TYPE_PREFERRED */
/* unused harmony export PREMATCH */
/* unused harmony export FULLTIME */
/* unused harmony export ABANDONED */
/* unused harmony export POSTPONED */
/* unused harmony export DELAYED */
/* unused harmony export SUSPENDED */
/* unused harmony export HALFTIME */
/* unused harmony export FIRSTHALF */
/* unused harmony export SECONDHALF */
/* unused harmony export EXTRAHALFTIME */
/* unused harmony export EXTRAFIRSTHALF */
/* unused harmony export EXTRASECONDHALF */
/* unused harmony export PREMATCH_STATUS */
/* unused harmony export POSTPONED_STATUS */
/* unused harmony export LIVE_STATUS */
// Redux Actions
// Dictionary
var INIT_DICTIONARY='dictionary/INIT_DICTIONARY';// Filter Bar
var LIVE='LIVE';// Get Standings
var GET_STANDINGS_REQUEST='api/GET_STANDINGS_REQUEST';var GET_STANDINGS_SUCCESS='api/GET_STANDINGS_SUCCESS';var GET_STANDINGS_ERROR='api/GET_STANDINGS_ERROR';// Get statistics
var GET_STATISTICS='stats/GET_STATISTICS';var GET_LAST_MATCHES_REQUEST='api/GET_LAST_MATCHES_REQUEST';var GET_LAST_MATCHES_SUCCESS='api/GET_LAST_MATCHES_SUCCESS';var GET_LAST_MATCHES_ERROR='api/GET_LAST_MATCHES_ERROR';// Get squad
var GET_SQUAD_REQUEST='api/GET_SQUAD_REQUEST';var GET_SQUAD_SUCCESS='api/GET_SQUAD_SUCCESS';var GET_SQUAD_ERROR='api/GET_SQUAD_ERROR';// Get Club Info
var GET_CLUB_INFO_REQUEST='api/GET_CLUB_INFO_REQUEST';var GET_CLUB_INFO_SUCCESS='api/GET_CLUB_INFO_SUCCESS';var GET_CLUB_INFO_ERROR='api/GET_CLUB_INFO_ERROR';// Get formazioni
var GET_LINEUPS_REQUEST='api/GET_LINEUPS_REQUEST';var GET_LINEUPS_SUCCESS='api/GET_LINEUPS_SUCCESS';var GET_LINEUPS_ERROR='api/GET_LINEUPS_ERROR';var GET_MATCHINFO_SUCCESS='api/GET_MATCHINFO_SUCCESS';var GET_LINEUPS_BASKET_REQUEST='api/GET_LINEUPS_BASKET_REQUEST';var GET_LINEUPS_BASKET_SUCCESS='api/GET_LINEUPS_BASKET_SUCCESS';var GET_LINEUPS_BASKET_ERROR='api/GET_LINEUPS_BASKET_ERROR';// Get Probabili formazioni
var GET_PROBABILI_REQUEST='api/GET_PROBABILI_REQUEST';var GET_PROBABILI_SUCCESS='api/GET_PROBABILI_SUCCESS';var GET_PROBABILI_ERROR='api/GET_PROBABILI_ERROR';// probabili request home
var GET_PROBABILI_HOME_REQUEST='api/GET_PROBABILI_HOME_REQUEST';var GET_PROBABILI_HOME_SUCCESS='api/GET_PROBABILI_HOME_SUCCESS';var GET_PROBABILI_HOME_ERROR='api/GET_PROBABILI_HOME_ERROR';// probabili request away
var GET_PROBABILI_AWAY_REQUEST='api/GET_PROBABILI_AWAY_REQUEST';var GET_PROBABILI_AWAY_SUCCESS='api/GET_PROBABILI_AWAY_SUCCESS';var GET_PROBABILI_AWAY_ERROR='api/GET_PROBABILI_AWAY_ERROR';// Get Global Info
var GET_HEADER_INFO_REQUEST='api/GET_HEADER_INFO_REQUEST';var GET_HEADER_INFO_SUCCESS='api/GET_HEADER_INFO_SUCCESS';var GET_HEADER_INFO_ERROR='api/GET_HEADER_INFO_ERROR';// Get Team Calendar
var GET_TEAM_CALENDAR_REQUEST='api/GET_TEAM_CALENDAR_REQUEST';var GET_TEAM_CALENDAR_SUCCESS='api/GET_TEAM_CALENDAR_SUCCESS';var GET_TEAM_CALENDAR_ERROR='api/GET_TEAM_CALENDAR_ERROR';//Local Storage
var CLEAR_LOCAL_STORAGE='localStorage/CLEAR_LOCAL_STORAGE';var SET_LOCAL_STORAGE_DATE='locaStorage/SET_LOCAL_STORAGE_DATE';var UPDATE_LOCAL_STORAGE='localStorage/UPDATE_LOCAL_STORAGE';// Table Types
var TYPE_HUB='HUB';var TYPE_PREFERRED='PREFERRED';// Timing Tag
var PREMATCH='PreMatch';var FULLTIME='FullTime';var ABANDONED='Abandoned';var POSTPONED='Postponed';var DELAYED='Delayed';var SUSPENDED='Suspended';var HALFTIME='HalfTime';var FIRSTHALF='FirstHalf';var SECONDHALF='SecondHalf';var EXTRAHALFTIME='ExtraHalfTime';var EXTRAFIRSTHALF='ExtraFirstHalf';var EXTRASECONDHALF='ExtraSecondHalf';// Match Status
var PREMATCH_STATUS='PREMATCH';var POSTPONED_STATUS='POSTPONED';var LIVE_STATUS='LIVE';

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(118);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_saga_core_effects__ = __webpack_require__(120);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__redux_saga_core_effects__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__redux_saga_core_effects__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__redux_saga_core_effects__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__redux_saga_core_effects__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__redux_saga_core_effects__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__redux_saga_core_effects__["f"]; });



/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetConsumer */
/* unused harmony export StyleSheetContext */
/* unused harmony export StyleSheetManager */
/* unused harmony export ThemeConsumer */
/* unused harmony export ThemeContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Le; });
/* unused harmony export __PRIVATE__ */
/* unused harmony export createGlobalStyle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Ae; });
/* unused harmony export isStyledComponent */
/* unused harmony export keyframes */
/* unused harmony export useTheme */
/* unused harmony export version */
/* unused harmony export withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_is__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_unitless__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_is_prop_valid__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!Object(__WEBPACK_IMPORTED_MODULE_0_react_is__["typeOf"])(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return"production"!=="production"&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"})&&(Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"}).REACT_APP_SC_ATTR||"header-team-page-sc")||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"})&&(void 0!==Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"}).REACT_APP_SC_DISABLE_SPEEDY&&""!==Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"}).REACT_APP_SC_DISABLE_SPEEDY?"false"!==Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"}).REACT_APP_SC_DISABLE_SPEEDY&&Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"}).REACT_APP_SC_DISABLE_SPEEDY:void 0!==Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"}).SC_DISABLE_SPEEDY&&""!==Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"}).SC_DISABLE_SPEEDY?"false"!==Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"}).SC_DISABLE_SPEEDY&&Object({"NODE_ENV":"production","SC_ATTR":"header-team-page-sc","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_SITE":"gazzetta"}).SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"}:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):new Error(R.apply(void 0,[O[e]].concat(n)).trim())}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return"production"!=="production"&&((0|t)<0||t>1<<30)&&D(16,""+t),T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:null},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"==="production"&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h,"production"!=="production"&&(u=ee(u,h+d));else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(),ue=ce.Consumer,le=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(ce)||de}function fe(){return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(le)||he}function me(e){var t=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])((function(){__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ce.Provider,{value:u},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(le.Provider,{value:l}, false?r.Children.only(e.children):e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return"production"!=="production"&&Object(__WEBPACK_IMPORTED_MODULE_0_react_is__["isElement"])(u)&&console.warn(b(e)+" is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."),_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in __WEBPACK_IMPORTED_MODULE_4__emotion_unitless__["a" /* default */]||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){var n="The component "+e+(t?' with the id of "'+t+'"':"")+" has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",r=console.error;try{var o=!0;console.error=function(e){if(Ce.test(e))o=!1,Ie.delete(n);else{for(var t=arguments.length,s=new Array(t>1?t-1:0),i=1;i<t;i++)s[i-1]=arguments[i];r.apply(void 0,[e].concat(s))}},c(),o&&!Ie.has(n)&&(console.warn(n),Ie.add(n))}catch(e){Ce.test(e.message)&&Ie.delete(n)}finally{console.error=r}}},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&("production"==="production"||e.charAt(0)===e.charAt(0).toLowerCase())}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(),Ge=Me.Consumer;function Le(e){var t=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me),n=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:D(7)}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return"production"!=="production"&&!t&&r&&r(i),i}(i,r,m, false?e.warnTooManyClasses:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,__WEBPACK_IMPORTED_MODULE_5__emotion_is_prop_valid__["a" /* default */],b):!_||Object(__WEBPACK_IMPORTED_MODULE_5__emotion_is_prop_valid__["a" /* default */])(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(b,A)}(A,e,t,I)};return P.displayName=p,(A=__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}),"production"!=="production"&&(Pe(p,v),A.warnTooManyClasses=function(e,t){var n={},r=!1;return function(o){if(!r&&(n[o]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'+t+'"':"";console.warn("Over 200 classes were generated for component "+e+s+".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),r=!0,n={}}}}(p,v)),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!Object(__WEBPACK_IMPORTED_MODULE_0_react_is__["isValidElementType"])(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me),d=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(t.allocateGSInstance(a)).current;return"production"!=="production"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(e.children)&&console.warn("The global style component "+a+" was given child JSX. createGlobalStyle does not render children."),"production"!=="production"&&i.some((function(e){return"string"==typeof e&&-1!==e.indexOf("@import")}))&&console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."),t.server&&h(d,e,t,o,n),Object(__WEBPACK_IMPORTED_MODULE_1_react__["useLayoutEffect"])((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return"production"!=="production"&&Pe(a),__WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(d)}function We(e){"production"!=="production"&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef((function(t,n){var o=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me),i=e.defaultProps,a=Oe(t,o,i);return"production"!=="production"&&void 0===a&&console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "'+b(e)+'"'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(e,y({},t,{theme:a,ref:n}))}));return __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me)},Ze={StyleSheet:X,masterSheet:de};"production"!=="production"&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"),"production"!=="production"&&"test"!=="production"&&"undefined"!=typeof window&&(window["__styled-components-init__"]=window["__styled-components-init__"]||0,1===window["__styled-components-init__"]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window["__styled-components-init__"]+=1);/* harmony default export */ __webpack_exports__["c"] = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(134)))

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ReactReduxContext.displayName = 'ReactRedux';
}

/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export genericApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return probabiliApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiWithUrlParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_configManager_configManager__ = __webpack_require__(12);
var genericApi=function genericApi(serviceGroup,serviceName,payload){// Get Service information
var serviceInfo=__WEBPACK_IMPORTED_MODULE_1__common_configManager_configManager__["a" /* default */].getServiceInfo(serviceGroup,serviceName);// URL concatenation
var url=__WEBPACK_IMPORTED_MODULE_1__common_configManager_configManager__["a" /* default */].getContextRoot()+serviceInfo.name;// add headers
var headers={};headers['Content-Type']=serviceInfo.content;// Request Object
var requestObject={url:url,options:{method:serviceInfo.type,headers:headers}};if(payload!=null){requestObject.options.body=JSON.stringify(payload);}return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(requestObject.url,requestObject).then(function(response){resolve(response.json());}).catch(function(error){reject(error);});});};var probabiliApi=function probabiliApi(serviceGroup,serviceName,urlParams){// Get Service information
var serviceInfo=__WEBPACK_IMPORTED_MODULE_1__common_configManager_configManager__["a" /* default */].getServiceInfo(serviceGroup,serviceName);// URL concatenation
var url=__WEBPACK_IMPORTED_MODULE_1__common_configManager_configManager__["a" /* default */].buildUrl(__WEBPACK_IMPORTED_MODULE_1__common_configManager_configManager__["a" /* default */].getProbabiliEndpoint(),serviceInfo.name,urlParams);//const url = ConfigManager.getContextRoot() + serviceInfo.name;
// add headers
var headers={};headers['Content-Type']=serviceInfo.content;// Request Object
var requestObject={url:url,options:{method:serviceInfo.type,headers:headers}};/* if (payload != null) {
    requestObject.options.body = JSON.stringify(payload);
  }*/return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(requestObject.url,requestObject.options).then(function(response){resolve(response.text());}).catch(function(error){reject(error);});});};var apiWithUrlParams=function apiWithUrlParams(serviceGroup,serviceName,urlParams){// Get Service information
var serviceInfo=__WEBPACK_IMPORTED_MODULE_1__common_configManager_configManager__["a" /* default */].getServiceInfo(serviceGroup,serviceName);// URL concatenation
var url=__WEBPACK_IMPORTED_MODULE_1__common_configManager_configManager__["a" /* default */].buildUrl(__WEBPACK_IMPORTED_MODULE_1__common_configManager_configManager__["a" /* default */].getContextRoot(),serviceInfo.name,urlParams);// add headers
var headers={};headers['Content-Type']=serviceInfo.content;// Request Object
var requestObject={url:url,options:{method:serviceInfo.type,headers:headers}};return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(requestObject.url,requestObject.options).then(function(response){resolve(response.json());}).catch(function(error){reject(error);});});};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANNEL_END_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MULTICAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAGA_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SELF_CANCELLATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TASK_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TERMINATE; });
var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};

var CANCEL =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
var IO =
/*#__PURE__*/
createSymbol('IO');
var MATCH =
/*#__PURE__*/
createSymbol('MATCH');
var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
var SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var TASK =
/*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE =
/*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION =
/*#__PURE__*/
createSymbol('LOCATION');




/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setConfiguration = exports.getConfiguration = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var configuration = {
  breakpoints: [576, 768, 992, 1200],
  containerWidths: [540, 750, 960, 1140],
  gutterWidth: 30,
  gridColumns: 12,
  defaultScreenClass: 'xl'
};

var getConfiguration = function getConfiguration() {
  return configuration;
};

exports.getConfiguration = getConfiguration;

var setConfiguration = function setConfiguration(newConfiguration) {
  configuration = _objectSpread({}, configuration, {}, newConfiguration);
};

exports.setConfiguration = setConfiguration;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ConfigManager=function(){function ConfigManager(){_classCallCheck(this,ConfigManager);}_createClass(ConfigManager,null,[{key:'getEnv',value:function getEnv(){__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].urlToUse="production";return "production";}},{key:'getContextRoot',value:function getContextRoot(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].endpoints[this.getEnv()];}},{key:'getServiceInfo',value:function getServiceInfo(group,serviceName){var serviceObject=__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].serviceCollection[group][serviceName];return serviceObject;}},{key:'getApiVersion',value:function getApiVersion(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].apiVersion;}},{key:'getConstants',value:function getConstants(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].constants;}},{key:'buildUrl',value:function buildUrl(contextRoot,apiName,urlParameters){if(typeof urlParameters.version==='undefined'){urlParameters.version=this.getApiVersion();}return''+contextRoot+apiName(urlParameters);}},{key:'getProbabiliEndpoint',value:function getProbabiliEndpoint(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].endpoints.probabiliMethode;}},{key:'getSportRefreshInterval',value:function getSportRefreshInterval(sportId){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].sportRefreshInterval[sportId];}},{key:'getPlayerUrl',value:function getPlayerUrl(playerName,playerId,sportId,site){return Object(__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["prettyPlayerUrl"])(playerName,playerId,sportId,site);}},{key:'getLanguageDictionary',value:function getLanguageDictionary(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].dictionary[__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].language];}},{key:'getRoute',value:function getRoute(routeName){var routeObject=__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].routes[routeName];return routeObject[this.getEnv()]();}},{key:'getColsOrder',value:function getColsOrder(tableName){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].tables.colsPosition[tableName];}},{key:'getJoinedCols',value:function getJoinedCols(tableName){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].tables.joinedCols[tableName];}},{key:'getPositionMarker',value:function getPositionMarker(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].tables.positionMarker;}},{key:'getSkipCols',value:function getSkipCols(tableName){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].tables.skipCols[tableName];}},{key:'getTabbarTabs',value:function getTabbarTabs(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].tables.tableTabbar.realteamPage;}},{key:'getFootballTeams',value:function getFootballTeams(res){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].imageUrls.football.teams[res];}},{key:'getCountriesFlag',value:function getCountriesFlag(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].imageUrls.countriesFlag;}},{key:'getFootballPlayers',value:function getFootballPlayers(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].imageUrls.football.players;}},{key:'prettyTeamUrl',value:function prettyTeamUrl(sportId,competitionId,site,team){return Object(__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["prettyTeamUrl"])(sportId,competitionId,site,team);}},{key:'getMotorSportConstructor',value:function getMotorSportConstructor(){return __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["configJson"].imageUrls.teams;}}]);return ConfigManager;}();/* harmony default export */ __webpack_exports__["a"] = (ConfigManager);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _ScreenClassProvider = _interopRequireWildcard(__webpack_require__(50));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScreenClassResolver = function ScreenClassResolver(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_ScreenClassProvider.ScreenClassContext.Consumer, null, function (screenClassCheck) {
    if (screenClassCheck === _ScreenClassProvider.NO_PROVIDER_FLAG) {
      return _react.default.createElement(_ScreenClassProvider.default, null, _react.default.createElement(_ScreenClassProvider.ScreenClassContext.Consumer, null, function (screenClassResolved) {
        return children(screenClassResolved);
      }));
    }

    return children(screenClassCheck);
  });
};

ScreenClassResolver.propTypes = {
  children: _propTypes.default.func.isRequired
};
var _default = ScreenClassResolver;
exports.default = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* unused harmony export Redirect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Switch; });
/* unused harmony export __HistoryContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return matchPath; });
/* unused harmony export useHistory */
/* unused harmony export useLocation */
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* unused harmony export withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_invariant__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_is__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_hoist_non_react_statics__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_hoist_non_react_statics__);












var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
? // eslint-disable-next-line no-undef
globalThis : typeof window !== "undefined" ? window // Browser
: typeof global !== "undefined" ? global // node.js
: {};

function getUniqueId() {
  var key = "__global_unique_id__";
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is


function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = "__create-react-context-" + getUniqueId() + "__";

  var Provider = /*#__PURE__*/function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _React$Component);

    function Provider() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            process.env.NODE_ENV !== "production" ? warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, "calculateChangedBits: Expected the return value to be a " + "31-bit integer. Instead received: " + changedBits) : void 0;
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer = /*#__PURE__*/function (_React$Component2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Consumer, _React$Component2);

    function Consumer() {
      var _this2;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _React$Component2.call.apply(_React$Component2, [this].concat(args)) || this;
      _this2.observedBits = void 0;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

// MIT License
var createContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext || createReactContext;

// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = createContext();
  context.displayName = name;
  return context;
};

var historyContext = /*#__PURE__*/createNamedContext("Router-History");

var context = /*#__PURE__*/createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        _this._pendingLocation = location;
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._isMounted = true;

    if (this.unlisten) {
      // Any pre-mount location changes have been captured at
      // this point, so unregister the listener.
      this.unlisten();
    }

    if (!this.props.staticContext) {
      this.unlisten = this.props.history.listen(function (location) {
        if (_this2._isMounted) {
          _this2.setState({
            location: location
          });
        }
      });
    }

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
      this._isMounted = false;
      this._pendingLocation = null;
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && isEmptyChildren(children)) {
        children = null;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_invariant__["a" /* default */])(false) : void 0;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_10_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(historyContext);
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  var location = useLocation();
  var match = useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global$1 = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global$1[key] && global$1[key] !== "esm") {
      var initialBuildName = buildNames[global$1[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global$1[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCATION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onLocationChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return push; });
/* unused harmony export replace */
/* unused harmony export go */
/* unused harmony export goBack */
/* unused harmony export goForward */
/* unused harmony export routerActions */
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
var onLocationChanged = function onLocationChanged(location, action) {
  var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: LOCATION_CHANGE,
    payload: {
      location: location,
      action: action,
      isFirstRendering: isFirstRendering
    }
  };
};
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */

var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

var updateLocation = function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: {
        method: method,
        args: args
      }
    };
  };
};
/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */


var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');
var routerActions = {
  push: push,
  replace: replace,
  go: go,
  goBack: goBack,
  goForward: goForward
};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "legacy_createStore", function() { return legacy_createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(100);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = createStore;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export $ */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return wrapSagaDispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return identity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FORK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_CONTEXT; });
/* unused harmony export H */
/* unused harmony export I */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return JOIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return take; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fork; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return cancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return call; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return delay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return actionChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sliding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return race; });
/* unused harmony export W */
/* unused harmony export X */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return put; });
/* unused harmony export Z */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CPS; });
/* unused harmony export a0 */
/* unused harmony export a1 */
/* unused harmony export a2 */
/* unused harmony export a3 */
/* unused harmony export a4 */
/* unused harmony export a5 */
/* unused harmony export a6 */
/* unused harmony export a7 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return check; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ACTION_CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return expanding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getMetaInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return kTrue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return createAllStyleChildCallbacks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return createEmptyArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return none; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return once; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return assignWithSymbols; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return makeIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return shouldComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return flatMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getLocation; });
/* unused harmony export w */
/* unused harmony export x */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return shouldCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return shouldTerminate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_saga_delay_p__ = __webpack_require__(30);





var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue =
/*#__PURE__*/
konst(true);

var noop = function noop() {};

if (false) {
  noop =
  /*#__PURE__*/
  new Proxy(noop, {
    set: function set() {
      throw internalErr('There was an attempt to assign a property to internal `noop` function.');
    }
  });
}
var identity = function identity(v) {
  return v;
};
var hasSymbol = typeof Symbol === 'function';
var asyncIteratorSymbol = hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function check(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}
var assignWithSymbols = function assignWithSymbols(target, source) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(target, source);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(source).forEach(function (s) {
      target[s] = source[s];
    });
  }
};
var flatMap = function flatMap(mapper, arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function remove(array, item) {
  var index = array.indexOf(item);

  if (index >= 0) {
    array.splice(index, 1);
  }
}
function once(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    fn();
  };
}

var kThrow = function kThrow(err) {
  throw err;
};

var kReturn = function kReturn(value) {
  return {
    value: value,
    done: true
  };
};

function makeIterator(next, thro, name) {
  if (thro === void 0) {
    thro = kThrow;
  }

  if (name === void 0) {
    name = 'iterator';
  }

  var iterator = {
    meta: {
      name: name
    },
    next: next,
    throw: thro,
    return: kReturn,
    isSagaIterator: true
  };

  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}
function logError(error, _ref2) {
  var sagaStack = _ref2.sagaStack;

  /*eslint-disable no-console*/
  console.error(error);
  console.error(sagaStack);
}
var internalErr = function internalErr(err) {
  return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array

var createEmptyArray = function createEmptyArray(n) {
  return Array.apply(null, new Array(n));
};
var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    if (false) {
      check(action, function (ac) {
        return !Object.isFrozen(ac);
      }, FROZEN_ACTION_ERROR);
    }

    return dispatch(Object.defineProperty(action, __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["f" /* SAGA_ACTION */], {
      value: true
    }));
  };
};
var shouldTerminate = function shouldTerminate(res) {
  return res === __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["k" /* TERMINATE */];
};
var shouldCancel = function shouldCancel(res) {
  return res === __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["j" /* TASK_CANCEL */];
};
var shouldComplete = function shouldComplete(res) {
  return shouldTerminate(res) || shouldCancel(res);
};
function createAllStyleChildCallbacks(shape, parentCallback) {
  var keys = Object.keys(shape);
  var totalCount = keys.length;

  if (false) {
    check(totalCount, function (c) {
      return c > 0;
    }, 'createAllStyleChildCallbacks: get an empty array or object');
  }

  var completedCount = 0;
  var completed;
  var results = Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["a" /* array */])(shape) ? createEmptyArray(totalCount) : {};
  var childCallbacks = {};

  function checkEnd() {
    if (completedCount === totalCount) {
      completed = true;
      parentCallback(results);
    }
  }

  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        parentCallback.cancel();
        parentCallback(res, isErr);
      } else {
        results[key] = res;
        completedCount++;
        checkEnd();
      }
    };

    chCbAtKey.cancel = noop;
    childCallbacks[key] = chCbAtKey;
  });

  parentCallback.cancel = function () {
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCallbacks[key].cancel();
      });
    }
  };

  return childCallbacks;
}
function getMetaInfo(fn) {
  return {
    name: fn.name || 'anonymous',
    location: getLocation(fn)
  };
}
function getLocation(instrumented) {
  return instrumented[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["g" /* SAGA_LOCATION */]];
}

var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;
var zeroBuffer = {
  isEmpty: kTrue,
  put: noop,
  take: noop
};

function ringBuffer(limit, overflowAction) {
  if (limit === void 0) {
    limit = 10;
  }

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];

    while (length) {
      items.push(take());
    }

    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit;

        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);

          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;

          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;
            arr = flush();
            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;
            arr.length = doubledLimit;
            limit = doubledLimit;
            push(it);
            break;

          default: // DROP

        }
      }
    },
    take: take,
    flush: flush
  };
}

var none = function none() {
  return zeroBuffer;
};
var fixed = function fixed(limit) {
  return ringBuffer(limit, ON_OVERFLOW_THROW);
};
var dropping = function dropping(limit) {
  return ringBuffer(limit, ON_OVERFLOW_DROP);
};
var sliding = function sliding(limit) {
  return ringBuffer(limit, ON_OVERFLOW_SLIDE);
};
var expanding = function expanding(initialSize) {
  return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};

var buffers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  none: none,
  fixed: fixed,
  dropping: dropping,
  sliding: sliding,
  expanding: expanding
});

var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var effectTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TAKE: TAKE,
  PUT: PUT,
  ALL: ALL,
  RACE: RACE,
  CALL: CALL,
  CPS: CPS,
  FORK: FORK,
  JOIN: JOIN,
  CANCEL: CANCEL,
  SELECT: SELECT,
  ACTION_CHANNEL: ACTION_CHANNEL,
  CANCELLED: CANCELLED,
  FLUSH: FLUSH,
  GET_CONTEXT: GET_CONTEXT,
  SET_CONTEXT: SET_CONTEXT
});

var TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';

var makeEffect = function makeEffect(type, payload) {
  var _ref;

  return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["c" /* IO */]] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};

var isForkEffect = function isForkEffect(eff) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["c" /* effect */])(eff) && eff.type === FORK;
};

var detach = function detach(eff) {
  if (false) {
    check(eff, isForkEffect, 'detach(eff): argument must be a fork effect');
  }

  return makeEffect(FORK, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, eff.payload, {
    detached: true
  }));
};
function take(patternOrChannel, multicastPattern) {
  if (patternOrChannel === void 0) {
    patternOrChannel = '*';
  }

  if (false) {
    check(arguments[0], notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["i" /* pattern */])(patternOrChannel)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["g" /* notUndef */])(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
    }

    return makeEffect(TAKE, {
      pattern: patternOrChannel
    });
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["f" /* multicast */])(patternOrChannel) && Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["g" /* notUndef */])(multicastPattern) && Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["i" /* pattern */])(multicastPattern)) {
    return makeEffect(TAKE, {
      channel: patternOrChannel,
      pattern: multicastPattern
    });
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["b" /* channel */])(patternOrChannel)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["g" /* notUndef */])(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
    }

    return makeEffect(TAKE, {
      channel: patternOrChannel
    });
  }

  if (false) {
    throw new Error("take(patternOrChannel): argument " + patternOrChannel + " is not valid channel or a valid pattern");
  }
}
var takeMaybe = function takeMaybe() {
  var eff = take.apply(void 0, arguments);
  eff.payload.maybe = true;
  return eff;
};
function put(channel$1, action) {
  if (false) {
    if (arguments.length > 1) {
      check(channel$1, notUndef, 'put(channel, action): argument channel is undefined');
      check(channel$1, channel, "put(channel, action): argument " + channel$1 + " is not a valid channel");
      check(action, notUndef, 'put(channel, action): argument action is undefined');
    } else {
      check(channel$1, notUndef, 'put(action): argument action is undefined');
    }
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["n" /* undef */])(action)) {
    action = channel$1; // `undefined` instead of `null` to make default parameter work

    channel$1 = undefined;
  }

  return makeEffect(PUT, {
    channel: channel$1,
    action: action
  });
}
var putResolve = function putResolve() {
  var eff = put.apply(void 0, arguments);
  eff.payload.resolve = true;
  return eff;
};
function all(effects) {
  var eff = makeEffect(ALL, effects);
  eff.combinator = true;
  return eff;
}
function race(effects) {
  var eff = makeEffect(RACE, effects);
  eff.combinator = true;
  return eff;
} // this match getFnCallDescriptor logic

var validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
  check(fnDescriptor, __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["g" /* notUndef */], effectName + ": argument fn is undefined or null");

  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["d" /* func */])(fnDescriptor)) {
    return;
  }

  var context = null;
  var fn;

  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["a" /* array */])(fnDescriptor)) {
    context = fnDescriptor[0];
    fn = fnDescriptor[1];
    check(fn, __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["g" /* notUndef */], effectName + ": argument of type [context, fn] has undefined or null `fn`");
  } else if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["h" /* object */])(fnDescriptor)) {
    context = fnDescriptor.context;
    fn = fnDescriptor.fn;
    check(fn, __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["g" /* notUndef */], effectName + ": argument of type {context, fn} has undefined or null `fn`");
  } else {
    check(fnDescriptor, __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["d" /* func */], effectName + ": argument fn is not function");
    return;
  }

  if (context && Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["k" /* string */])(fn)) {
    check(context[fn], __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["d" /* func */], effectName + ": context arguments has no such method - \"" + fn + "\"");
    return;
  }

  check(fn, __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["d" /* func */], effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};

function getFnCallDescriptor(fnDescriptor, args) {
  var context = null;
  var fn;

  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["d" /* func */])(fnDescriptor)) {
    fn = fnDescriptor;
  } else {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["a" /* array */])(fnDescriptor)) {
      context = fnDescriptor[0];
      fn = fnDescriptor[1];
    } else {
      context = fnDescriptor.context;
      fn = fnDescriptor.fn;
    }

    if (context && Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["k" /* string */])(fn) && Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["d" /* func */])(context[fn])) {
      fn = context[fn];
    }
  }

  return {
    context: context,
    fn: fn,
    args: args
  };
}

var isNotDelayEffect = function isNotDelayEffect(fn) {
  return fn !== delay;
};

function call(fnDescriptor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (false) {
    var arg0 = typeof args[0] === 'number' ? args[0] : 'ms';
    check(fnDescriptor, isNotDelayEffect, "instead of writing `yield call(delay, " + arg0 + ")` where delay is an effect from `redux-saga/effects` you should write `yield delay(" + arg0 + ")`");
    validateFnDescriptor('call', fnDescriptor);
  }

  return makeEffect(CALL, getFnCallDescriptor(fnDescriptor, args));
}
function apply(context, fn, args) {
  if (args === void 0) {
    args = [];
  }

  var fnDescriptor = [context, fn];

  if (false) {
    validateFnDescriptor('apply', fnDescriptor);
  }

  return makeEffect(CALL, getFnCallDescriptor([context, fn], args));
}
function cps(fnDescriptor) {
  if (false) {
    validateFnDescriptor('cps', fnDescriptor);
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return makeEffect(CPS, getFnCallDescriptor(fnDescriptor, args));
}
function fork(fnDescriptor) {
  if (false) {
    validateFnDescriptor('fork', fnDescriptor);
    check(fnDescriptor, function (arg) {
      return !effect(arg);
    }, 'fork: argument must not be an effect');
  }

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return makeEffect(FORK, getFnCallDescriptor(fnDescriptor, args));
}
function spawn(fnDescriptor) {
  if (false) {
    validateFnDescriptor('spawn', fnDescriptor);
  }

  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(void 0, [fnDescriptor].concat(args)));
}
function join(taskOrTasks) {
  if (false) {
    if (arguments.length > 1) {
      throw new Error('join(...tasks) is not supported any more. Please use join([...tasks]) to join multiple tasks.');
    }

    if (array(taskOrTasks)) {
      taskOrTasks.forEach(function (t) {
        check(t, task, "join([...tasks]): argument " + t + " is not a valid Task object " + TEST_HINT);
      });
    } else {
      check(taskOrTasks, task, "join(task): argument " + taskOrTasks + " is not a valid Task object " + TEST_HINT);
    }
  }

  return makeEffect(JOIN, taskOrTasks);
}
function cancel(taskOrTasks) {
  if (taskOrTasks === void 0) {
    taskOrTasks = __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["h" /* SELF_CANCELLATION */];
  }

  if (false) {
    if (arguments.length > 1) {
      throw new Error('cancel(...tasks) is not supported any more. Please use cancel([...tasks]) to cancel multiple tasks.');
    }

    if (array(taskOrTasks)) {
      taskOrTasks.forEach(function (t) {
        check(t, task, "cancel([...tasks]): argument " + t + " is not a valid Task object " + TEST_HINT);
      });
    } else if (taskOrTasks !== SELF_CANCELLATION && notUndef(taskOrTasks)) {
      check(taskOrTasks, task, "cancel(task): argument " + taskOrTasks + " is not a valid Task object " + TEST_HINT);
    }
  }

  return makeEffect(CANCEL, taskOrTasks);
}
function select(selector) {
  if (selector === void 0) {
    selector = identity;
  }

  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (false) {
    check(arguments[0], notUndef, 'select(selector, [...]): argument selector is undefined');
    check(selector, func, "select(selector, [...]): argument " + selector + " is not a function");
  }

  return makeEffect(SELECT, {
    selector: selector,
    args: args
  });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/

function actionChannel(pattern$1, buffer$1) {
  if (false) {
    check(pattern$1, pattern, 'actionChannel(pattern,...): argument pattern is not valid');

    if (arguments.length > 1) {
      check(buffer$1, notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
      check(buffer$1, buffer, "actionChannel(pattern, buffer): argument " + buffer$1 + " is not a valid buffer");
    }
  }

  return makeEffect(ACTION_CHANNEL, {
    pattern: pattern$1,
    buffer: buffer$1
  });
}
function cancelled() {
  return makeEffect(CANCELLED, {});
}
function flush(channel$1) {
  if (false) {
    check(channel$1, channel, "flush(channel): argument " + channel$1 + " is not valid channel");
  }

  return makeEffect(FLUSH, channel$1);
}
function getContext(prop) {
  if (false) {
    check(prop, string, "getContext(prop): argument " + prop + " is not a string");
  }

  return makeEffect(GET_CONTEXT, prop);
}
function setContext(props) {
  if (false) {
    check(props, object, createSetContextWarning(null, props));
  }

  return makeEffect(SET_CONTEXT, props);
}
var delay =
/*#__PURE__*/
call.bind(null, __WEBPACK_IMPORTED_MODULE_3__redux_saga_delay_p__["a" /* default */]);




/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports__ = __webpack_require__(67);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__exports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__exports__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__exports__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_reactBatchedUpdates__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_batch__ = __webpack_require__(35);
/* unused harmony reexport batch */


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

Object(__WEBPACK_IMPORTED_MODULE_2__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_1__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSubscription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(35);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(24);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(71);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectedRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectRouter; });
/* unused harmony export getLocation */
/* unused harmony export getAction */
/* unused harmony export getHash */
/* unused harmony export getRouter */
/* unused harmony export getSearch */
/* unused harmony export createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__structure_plain__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(16);
/* unused harmony reexport LOCATION_CHANGE */
/* unused harmony reexport CALL_HISTORY_METHOD */
/* unused harmony reexport onLocationChanged */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__actions__["d"]; });
/* unused harmony reexport replace */
/* unused harmony reexport go */
/* unused harmony reexport goBack */
/* unused harmony reexport goForward */
/* unused harmony reexport routerActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middleware__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__middleware__["a"]; });






var ConnectedRouter = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__structure_plain__["a" /* default */]);
var connectRouter = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__structure_plain__["a" /* default */]);

var _createSelectors = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__structure_plain__["a" /* default */]),
    getLocation = _createSelectors.getLocation,
    getAction = _createSelectors.getAction,
    getHash = _createSelectors.getHash,
    getRouter = _createSelectors.getRouter,
    getSearch = _createSelectors.getSearch,
    createMatchSelector = _createSelectors.createMatchSelector;



/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(28);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return array; });
/* unused harmony export buffer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return channel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return func; });
/* unused harmony export iterable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return iterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return multicast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return notUndef; });
/* unused harmony export number */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return object; });
/* unused harmony export observable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return pattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return promise; });
/* unused harmony export sagaAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return string; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return stringableFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return symbol; });
/* unused harmony export task */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return undef; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__ = __webpack_require__(10);


var undef = function undef(v) {
  return v === null || v === undefined;
};
var notUndef = function notUndef(v) {
  return v !== null && v !== undefined;
};
var func = function func(f) {
  return typeof f === 'function';
};
var number = function number(n) {
  return typeof n === 'number';
};
var string = function string(s) {
  return typeof s === 'string';
};
var array = Array.isArray;
var object = function object(obj) {
  return obj && !array(obj) && typeof obj === 'object';
};
var promise = function promise(p) {
  return p && func(p.then);
};
var iterator = function iterator(it) {
  return it && func(it.next) && func(it.throw);
};
var iterable = function iterable(it) {
  return it && func(Symbol) ? func(it[Symbol.iterator]) : array(it);
};
var task = function task(t) {
  return t && t[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["i" /* TASK */]];
};
var sagaAction = function sagaAction(a) {
  return Boolean(a && a[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["f" /* SAGA_ACTION */]]);
};
var observable = function observable(ob) {
  return ob && func(ob.subscribe);
};
var buffer = function buffer(buf) {
  return buf && func(buf.isEmpty) && func(buf.take) && func(buf.put);
};
var pattern = function pattern(pat) {
  return pat && (string(pat) || symbol(pat) || func(pat) || array(pat) && pat.every(pattern));
};
var channel = function channel(ch) {
  return ch && func(ch.take) && func(ch.close);
};
var stringableFunc = function stringableFunc(f) {
  return func(f) && f.hasOwnProperty('toString');
};
var symbol = function symbol(sym) {
  return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var multicast = function multicast(ch) {
  return channel(ch) && ch[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["e" /* MULTICAST */]];
};
var effect = function effect(eff) {
  return eff && eff[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["c" /* IO */]];
};




/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__ = __webpack_require__(10);


var MAX_SIGNED_INT = 2147483647;
function delayP(ms, val) {
  if (val === void 0) {
    val = true;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
  if (false) {
    throw new Error('delay only supports a maximum value of ' + MAX_SIGNED_INT + 'ms');
  }

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(resolve, Math.min(MAX_SIGNED_INT, ms), val);
  });

  promise[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["a" /* CANCEL */]] = function () {
    clearTimeout(timeoutId);
  };

  return promise;
}

/* harmony default export */ __webpack_exports__["a"] = (delayP);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _countryCode, _imageRacingMap;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var configJson = {
  urlToUse: 'local',
  language: 'it',
  endpoints: {
    local: 'http://localhost:9001/',
    development: 'https://dev-api-mtc.gazzetta.it/',
    stag: 'https://dev-api-mtc.gazzetta.it/',
    production: 'https://api2-mtc.gazzetta.it/',
    articles: 'https://smart.gazzetta.it/',
    articlesV2: 'https://searchapiservice.gazzetta.it/api/',
    bet: 'https://json2.gazzettaobjects.it/quote-mc/',
    //probabiliMethode: 'https://json.gazzettaobjects.it/',
    probabiliMethode: 'https://api-matches-lineups.gazzetta.it/api/lineups/team/', //NON PIU' GESTITE DA METHODE MA DA XALOK
    nextApi: 'https://next-api-mtc2.gazzetta.it/',
    'dev-nextApi': 'https://dev-next-api-mtc.gazzetta.it/',
    staticApi: 'https://json2.gazzettaobjects.it/'
  },
  apiVersion: 'v1',
  serviceCollection: {
    hublive: {
      getSportsList: {
        name: function name(paramsObject) {
          if (paramsObject.pref) {
            return 'api/' + paramsObject.version + '/sports/' + paramsObject.date + '?pref=' + paramsObject.pref;
          } else {
            return 'api/' + paramsObject.version + '/sports/' + paramsObject.date;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCompetitionsList: {
        name: function name(paramsObject) {
          if (paramsObject.pref) {
            return 'api/' + paramsObject.version + '/sports/' + paramsObject.date + '?sportId=' + paramsObject.id + '&pref=' + paramsObject.pref;
          } else {
            return 'api/' + paramsObject.version + '/sports/' + paramsObject.date + '?sportId=' + paramsObject.id;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    hubliveFavourites: {
      getYesterdayTomorrow: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/sports/favourites?yesterday=' + paramsObject.yesterdaySportIds + '&tomorrow=' + paramsObject.tomorrowSportIds;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    calendar: {
      getCalendar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCalendarWidgetCorriere: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&isWidget=' + paramsObject.isWidget + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&isWidget=' + paramsObject.isWidget;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCalendarTennis: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&order=' + paramsObject.order + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&order=' + paramsObject.order;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getDayCalendar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?day=' + paramsObject.day + '&sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?day=' + paramsObject.day + '&sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCupTabbar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/info/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/info/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getDayCupCalendar: {
        name: function name(paramsObject) {
          var urlToCall = 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;

          if (paramsObject.phase) {
            urlToCall += '&phase=' + paramsObject.phase;
          }
          if (paramsObject.subPhase) {
            urlToCall += '&subphase=' + paramsObject.subPhase;
          }
          if (paramsObject.isWidget && paramsObject.isWidget === true) {
            urlToCall += '&isWidget=' + paramsObject.isWidget;
          }
          if (paramsObject.seasonId) {
            urlToCall += '&seasonId=' + paramsObject.seasonId;
          }
          return urlToCall;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSeasonCalendarTennis: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/seasonCalendar?sportId=' + paramsObject.sportId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/seasonCalendar?sportId=' + paramsObject.sportId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getBasketCalendar: {
        name: function name(paramsObject) {
          var urlToCall = 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;

          if (paramsObject.day) {
            urlToCall += '&day=' + paramsObject.day;
          }
          if (paramsObject.phase) {
            urlToCall += '&phase=' + paramsObject.phase;
          }
          if (paramsObject.subPhase) {
            urlToCall += '&subphase=' + paramsObject.subPhase;
          }

          if (paramsObject.seasonId) {
            urlToCall += '&seasonId=' + paramsObject.seasonId;
          }
          return urlToCall;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    competitionData: {
      getStandings: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/teams?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/teams?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getStandingsWithPhase: {
        name: function name(paramsObject) {
          var urlToCall = 'api/' + paramsObject.version + '/standings/teams?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&phase=' + paramsObject.phase;
          if (paramsObject.subPhase) {
            urlToCall += '&subphase=' + paramsObject.subPhase;
          }

          if (paramsObject.seasonId) {
            urlToCall += '&seasonId=' + paramsObject.seasonId;
          }
          return urlToCall;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getTopScorers: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/markers?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/markers?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getPlayoffPhase: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/playoff?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/playoff?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },


        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getQualification: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/qualification?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/qualification?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCompetitionPhase: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/info/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/info/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHallOfFame: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/hallOfFame/competition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getLastMatches: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/teams/lastMatches?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSquad: {
        name: function name(paramsObject) {
          var urlToCall = 'api/' + paramsObject.version + '/teams/squad?sportId=' + paramsObject.sportId;

          if (paramsObject.playerId) {
            urlToCall += '&playerId=' + paramsObject.playerId;
          } else if (paramsObject.competitionId && paramsObject.teamId) {
            urlToCall += '&competitionId=' + paramsObject.competitionId + '&teamId=' + paramsObject.teamId;
          }
          if (paramsObject.seasonId) {
            urlToCall += '&seasonId=' + paramsObject.seasonId;
          }
          return urlToCall;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getUefaStandings: {
        name: function name(paramsObject) {
          var url = '';
          var category = paramsObject.category;

          switch (category) {
            case 'club':
              url = 'Calcio/uefa_standings/club.json';
              break;
            case 'international':
              url = 'Calcio/uefa_standings/international.json';
              break;
            case 'dictionary':
              url = 'Calcio/uefa_standings/dictionary.json';
              break;
            default:
              url = 'Calcio/uefa_standings/club.json';
              break;
          }
          return url;
        },
        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getCyclingHallOfFame: {
        name: function name(paramsObject) {
          return 'CyclingHallOfFame/' + paramsObject.competitionId + '/standings.json';
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    teamData: {
      getClubInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/teams/clubInfo?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHeaderInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/teams/globalInfo?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&teamId=' + paramsObject.teamId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getTeamCalendar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/teams/calendar?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/teams/calendar?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    match: {
      getHeaderInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/live?sportId=' + paramsObject.sportId + '&matchId=' + paramsObject.matchId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticles: {
        name: function name(paramsObject) {
          return 'ricerca-calcio/' + paramsObject.homeTeam + '/' + paramsObject.awayTeam + '/' + paramsObject.competitionName;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticlesV2: {
        name: function name(paramsObject) {
          return 'search/mtc/?find=headline:' + paramsObject.homeTeam + '|' + paramsObject.awayTeam + '&section=' + paramsObject.competitionName + '&rows=' + paramsObject.maxResults;
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      },
      getArticlesByTeam: {
        name: function name(paramsObject) {
          return 'search/mtc/?section=' + paramsObject.competitionName + '/' + paramsObject.homeTeam + '|' + paramsObject.competitionName + '/' + paramsObject.awayTeam + '&rows=' + paramsObject.maxResults;
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      },
      getReports: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/commentary?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId + '&period=' + paramsObject.period + '&lang=it';
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getFacts: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/facts?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSynthesis: {
        name: function name(paramsObject) {
          if (paramsObject.newformat) {
            return 'api/' + paramsObject.version + '/events/synthesis?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId + '&lang=it';
          } else {
            return 'api/' + paramsObject.version + '/events/commentary?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId + '&period=' + paramsObject.period + '&lang=it&synthesis=true';
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getLineups: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/lineup?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getStatistics: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/stats?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHeadToHead: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/headtohead?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getVotations: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/votations?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticlesTennis: {
        name: function name(paramsObject) {
          return 'ricerca-tennis/' + paramsObject.firstEntry + '/' + paramsObject.SecondEntry + '/';
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticlesTennisV2: {
        name: function name(paramsObject) {
          return 'search/mtc/?find=headline:' + paramsObject.firstEntry + '|' + paramsObject.SecondEntry + '&section=Tennis&rows=' + paramsObject.maxResults;
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      },
      getAllMatches: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/allMatches?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    player: {
      getInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/players/info?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getBio: {
        name: function name(paramsObject) {
          return 'api/info/v1/player/biography?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId;
        },
        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getStats: {
        name: function name(paramsObject) {
          if (paramsObject.competitionId) {
            return 'api/' + paramsObject.version + '/players/stats?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId + '&competitionId=' + paramsObject.competitionId;
          } else {
            return 'api/' + paramsObject.version + '/players/stats?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getMagicStats: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/players/magicStats?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getMagicDetails: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/players/magicDetails?sportId=' + paramsObject.sportId + '&playerId=' + paramsObject.playerId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    raceData: {
      getDriverStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/drivers?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getConstructorStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/constructors?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getTeamsStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/teams?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHeaderInfo: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/live?sportId=' + paramsObject.sportId + '&matchId=' + paramsObject.matchId + '&competitionId=' + paramsObject.competitionId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getStatistics: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/stats?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId + '&phase=' + paramsObject.phase;
        },


        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticles: {
        name: function name(paramsObject) {
          return 'ricerca/' + paramsObject.sportName + '/' + paramsObject.gpName;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getArticlesV2: {
        name: function name(paramsObject) {
          return 'search/mtc/?find=headline:' + paramsObject.gpName + '&section=' + paramsObject.sportName + '&rows=' + paramsObject.maxResults;
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      },
      getSessionsList: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/sessions?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&gpId=' + paramsObject.gpId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSession: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/events/sessions?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&gpId=' + paramsObject.gpId + '&session=' + paramsObject.session;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    cyclingData: {
      cyclingStageStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/cycling?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&standingType=' + paramsObject.standingType + '&phase=' + paramsObject.phase;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      cyclingStandings: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/standings/cycling?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&standingType=' + paramsObject.standingType;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSeasonCalendarUci: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/seasonCalendar?sportId=' + paramsObject.sportId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/seasonCalendar?sportId=' + paramsObject.sportId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    skiData: {
      skiStageStandings: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/ski?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&eventId=' + paramsObject.eventId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/ski?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&eventId=' + paramsObject.eventId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      skiStandings: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/standings/ski?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/standings/ski?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getSeasonCalendarSki: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&seasonId=' + paramsObject.seasonId;
          } else {
            return 'api/' + paramsObject.version + '/sports/calendar?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    widgets: {
      getLeafEvent: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/widget/leafEvent?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&matchId=' + paramsObject.matchId;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getLeafCompetition: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/widget/leafCompetition?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&oldestFirst=' + paramsObject.oldestFirst;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getNextMatch: {
        name: function name(paramsObject) {
          if (paramsObject.competitionId) {
            return 'api/' + paramsObject.version + '/widget/nextMatch?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId + '&competitionId=' + paramsObject.competitionId;
          } else {
            return 'api/' + paramsObject.version + '/widget/nextMatch?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getHeaderCorriere: {
        name: function name(paramsObject) {
          return 'api/' + paramsObject.version + '/widget/headerCorriere?sportId=' + paramsObject.sportId + '&competitionId=' + paramsObject.competitionId + '&oldestFirst=' + paramsObject.oldestFirst;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      getTeamCalendar: {
        name: function name(paramsObject) {
          if (paramsObject.seasonId) {
            return 'api/' + paramsObject.version + '/teams/calendar?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId + '&seasonId=' + paramsObject.seasonId + '&isWidget=' + paramsObject.isWidget;
          } else {
            return 'api/' + paramsObject.version + '/teams/calendar?sportId=' + paramsObject.sportId + '&teamId=' + paramsObject.teamId + '&isWidget=' + paramsObject.isWidget;
          }
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    betting: {
      getBetMatch: {
        name: function name(paramsObject) {
          return paramsObject.sportId + '/' + paramsObject.competitionId + '/' + paramsObject.betterName + '/full.json';
        },

        type: 'GET',
        content: 'application/json;charset=UTF-8'
      }
    },
    probabiliMethode: {
      getProbabiliMethode: {
        name: function name(paramsObject) {
          return '?competitionId=' + paramsObject.competitionId + '&teamId=' + paramsObject.squad;
        },

        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    nextSportsApi: {
      daily: {
        name: function name(paramsObject) {
          return 'api/sports/v1/daily/' + paramsObject.date;
        },
        type: 'GET',
        content: 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }
  },

  filterBar: {
    sports: [{
      id: '1',
      name: 'calcio',
      label: 'calcio',
      isAvailable: false,
      isSelected: false
    }, {
      id: '8',
      name: 'tennis',
      label: 'tennis',
      isAvailable: false,
      isSelected: false
    }, {
      id: '3',
      name: 'basket',
      label: 'basket',
      isAvailable: false,
      isSelected: false
    }, {
      id: '6C',
      name: 'f1',
      label: 'Automobilismo',
      isAvailable: false,
      isSelected: false
    }, {
      id: '6M',
      name: 'moto',
      label: 'Motociclismo',
      isAvailable: false,
      isSelected: false
    }]
  },
  sportRefreshInterval: {
    1: 5000,
    2: 60000,
    8: 60000,
    3: 20000
  },
  dictionary: {
    it: {
      date: {
        months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
        days: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']
      },
      tooltip: {
        add: 'Aggiunto ai tuoi preferiti'
      },
      calendar: {
        legs: {
          firstLeg: 'Andata',
          secondLeg: 'Ritorno'
        },
        phases: {
          groups: 'Fase a gironi',
          groups_5_34: 'Fase a round',
          groups_5_35: 'Fase a gironi',
          playoffs: 'Fase finale',
          playoffs_1_105: 'Playoff',
          playout: 'Playout',
          playoffs_2: 'Playoff',
          playoffs_3: 'Playoff',
          extraPlayoffs: 'Playoff 5°-8°',
          playoffs_5: 'Playoff',
          playoffs_5_34: 'Fase finale',
          playoffs_5_35: 'Fase finale',
          preliminaries: 'Qualificazioni',
          preSeason_3: 'Pre season',
          regularSeason: 'Stagione regolare',
          'regular-season': 'Stagione regolare',
          'NBACup': 'NBA Cup',
          'championship': 'Girone Unico'
        },
        subPhases: {
          playOffs: 'Spareggi',
          round1: '1° turno',
          round2: '2° turno',
          round3: '3° turno',
          round4: '4° turno',
          'qualifier-round-1': '1° turno',
          'round-1': '1° turno',
          'round-2': '2° turno',
          'round-3': '3° turno',
          'round-4': '4° turno',
          'play-offs': 'Spareggi',
          preliminary: 'Spareggi',
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
          6: '6',
          round: 'Spareggi',
          'round-of-32': 'Sedicesimi',
          'round-of-16': 'Ottavi',
          'quarter-finals': 'Quarti',
          'semi-finals': 'Semifinali',
          finals: 'Finale',
          '3rd-and-4th-place': 'Finale per il 3° posto',
          '3rd-place-final': 'Finale per il 3° posto',
          '5th-place-final': 'Finale per il 5° posto',
          'qualifier-round': '1° turno',
          'qualifier-round-el': 'Preliminari',
          final: 'Finale',
          'conference-round-1': '1° turno',
          'conference-round-2': '2° turno',
          'conference-semifinals': 'Semifinale di Conference',
          'conference-finals': 'Finale di Conference',
          'nba-finals': 'Finals',
          conferences: 'Conference',
          divisions: 'Division',
          sf_2: 'Semifinali',
          final_2: 'Finale',
          'play-off-qualifying': 'Playoff',
          'classification-round_3': 'Girone perdenti',
          '2nd-round_3': '2&deg; girone',
          'group-stage_3': '1&deg; girone',
          '5th-place-play-offs_3': 'Playoff 5&deg; posto',
          'quarter-finals_3': 'Quarti',
          'semi-finals_3': 'Semifinali',
          '7th-place-final_3': 'Finale 7&deg; posto',
          '5th-place-final_3': 'Finale 5&deg; posto',
          '3rd-place-final_3': 'Finale 3&deg; posto',
          '3rd-place-finals_3': 'Finale 3&deg; posto',
          final_3: 'Finale',
          '3rd-place-final_5': 'Finale per il 3&deg; posto',
          'play-offs_1_335': 'Finale per il 5&deg; posto',
          'quarter-finals_1_335': '2&deg; turno'
        },
        exceptionLablesCompetition: {
          259: {
            'qualifier-round': 'Preliminari',
            'Qualifier Round': 'Preliminari'
          },
          5: {
            'qualifier-round': 'Preliminari',
            'Qualifier Round': 'Preliminari'
          }
        },
        special: {
          phases: {
            playout: 'Playout',
            playoffs: 'Playoff'
          },
          subPhases: {
            preliminary: 'Spareggi',
            'semi-finals': 'Semifinali',
            final: 'Finale'
          }
        },
        tennis: {
          phases: {
            '1st Round': '1° Turno',
            '2nd Round': '2° Turno',
            '3rd Round': '3° Turno',
            '4th Round': '4° Turno',
            'Quarter-final': 'Quarti',
            'Quarter-Final': 'Quarti',
            'Semi-final': 'Semifinali',
            Final: 'Finale',
            '1-128-final': 'Sessantaquattresimi',
            '1-64-final': 'Trentaduesimi',
            '1-32-final': 'Sedicesimi',
            '1-16-final': 'Ottavi',
            'quarter-finals': 'Quarti',
            'semi-finals': 'Semifinali',
            '3rd-place': 'Finale terzo posto',
            final: 'Finale',
            'group-stage': 'Fase a gruppi',
            'qualifying-1st-round': 'Qualificazioni 1° Turno',
            'qualifying-2nd-round': 'Qualificazioni 2° Turno',
            'qualifying-3rd-round': 'Qualificazioni 3° Turno',
            'qualifying-final': 'Qualificazioni Finale',
            'world-group-play-offs': 'Spareggi'
          }
        }
      },
      lineups: {
        lineupInfo: 'Formazioni ufficiali',
        previewLineup: 'Probabili formazioni',
        referee: 'Arbitro',
        mainPlayers: 'Titolari',
        benchPlayers: 'Panchina',
        unavailablePlayers: 'Indisponibili',
        warnedPlayers: 'Diffidati',
        otherPlayers: 'Altri',
        suspendedPlayers: 'Squalificati',
        ballotPlayers: 'Ballottaggi',
        coach: 'Allenatore',
        linemans: 'Guardalinee',
        fourthOfficial: 'Quarto uomo',
        varReferee: 'VAR'
      },
      votations: {
        lineupInfo: 'Formazioni ufficiali',
        referee: 'Arbitro',
        mainPlayers: 'In campo',
        benchPlayers: 'A disposizione',
        unavailablePlayers: 'Indisponibili',
        warnedPlayers: 'Diffidati',
        otherPlayers: 'Altri',
        suspendedPlayers: 'Squalificati',
        ballotPlayers: 'Ballottaggi',
        coach: 'Allenatore',
        linemans: 'Guardalinee',
        fourthOfficial: 'Quarto uomo',
        varReferee: 'VAR'
      },
      filterBar: {
        filterTitle: 'Filtra per: ',
        allSport: 'Tutti',
        live: 'live',
        dropdown: [{
          label: 'ieri',
          value: 'yesterday'
        }, {
          label: 'oggi',
          value: 'today'
        }, {
          label: 'domani',
          value: 'tomorrow'
        }]
      },
      competitionTable: {
        allMatches: 'Vedi tutta la giornata',
        calendar: 'Calendario e risultati',
        standings: 'Classifica',
        roundPhase: 'Fase a gironi',
        playoffPhase: 'Playoff',
        qualification: 'Qualificazioni',
        day: 'giornata',
        dayA: 'ª giornata',
        dayAServer: '&ordf; giornata',
        timing: {
          'Full Time': 'Fine',
          FINISHED: 'Fine',
          'First Half': '1°T',
          'Half Time': 'Fine 1°T',
          'Second Half': '2°T',
          'Pre Match': '',
          FullTime: 'Fine',
          FullTime90: 'Fine 2° Tempo',
          FullTimePens: 'Fine 2° TS',
          FirstHalf: '1°T',
          HalfTime: 'Fine 1°T',
          SecondHalf: '2°T',
          PreMatch: '',
          ExtraFirstHalf: '1° TS',
          ExtraHalfTime: 'Fine 1°TS',
          ExtraSecondHalf: '2° TS',
          ShootOut: 'Calci di rigore',
          Abandoned: 'Interrotta',
          Postponed: 'Rinviata',
          Notplayed: 'non disputata',
          Delayed: 'Posticipato',
          Suspended: 'Sospeso',
          Cancelled: 'Cancellato',
          Walkover: 'Tavolino',
          Live: 'Live',
          header: {
            'Full Time': 'Fine',
            'First Half': '1° Tempo',
            'Half Time': 'Fine 1° Tempo',
            'Second Half': '2° Tempo',
            'Pre Match': '',
            ExtraFirstHalf: '1° tempo Suppl.',
            ExtraHalfTime: 'Fine 1° TS',
            ExtraSecondHalf: '2° tempo Suppl.',
            ShootOut: 'Calci di rigore',
            FullTime: 'Fine',
            FullTime90: 'Fine 2° Tempo',
            FullTimePens: 'Fine 2° TS',
            FirstHalf: '1° Tempo',
            HalfTime: 'Fine 1° Tempo',
            SecondHalf: '2° Tempo',
            PreMatch: '',
            Abandoned: 'Interrotta',
            Postponed: 'Rinviata',
            Notplayed: 'non disputata',
            Delayed: 'Posticipato',
            Suspended: 'Sospeso',
            Cancelled: 'Cancellato'
          }
        },
        basketTiming: {
          1: '1°T',
          2: '2°T',
          3: 'Q1',
          4: 'Q2',
          5: 'Q3',
          6: 'Q4',
          7: 'OT',
          11: 'Fine 1°Q',
          12: 'Fine 1°T',
          13: 'Fine 3°Q',
          14: 'Fine 2°T',
          15: 'Fine',
          header: {
            1: '1°T',
            2: '2°T',
            3: 'Q1',
            4: 'Q2',
            5: 'Q3',
            6: 'Q4',
            7: 'OT',
            11: 'Fine 1°Q',
            12: 'Fine 1°T',
            13: 'Fine 3°Q',
            14: 'Fine 2°T',
            15: 'Fine'
          }
        },
        competitionName: {
          3: 'Europei',
          235: 'Qualificazioni Europei',
          352: 'Europei U21',
          383: 'Europei U19',
          4: 'Mondiali',
          408: 'Mondiali Femminili',
          616: 'Europei Femminili',
          21: 'Serie A',
          105: 'Serie B',
          128: 'Copa America',
          1105: 'Serie B',
          259: 'Coppa Italia',
          232: 'Qualificazioni CL',
          5: 'Champions League',
          548: 'Coppa dei Campioni',
          524: 'Qualificazioni EL',
          6: 'Europa League',
          1125: 'Conference League',
          1126: 'Qualificazioni Conference League',
          173: 'Supercoppa Italiana',
          174: 'Supercoppa Europea',
          8: 'Premier League',
          24: 'Ligue 1',
          23: 'Liga',
          22: 'Bundesliga',
          1277: 'Coppa del Mondo per Club',
          335: 'Coppa del Mondo per Club 2023',
          941: 'Nations League',
          34: 'Amichevole',
          88: 'Amichevole',
          35: 'Amichevole U21',
          514: 'Serie D',
          515: 'Serie D',
          516: 'Serie D',
          517: 'Serie D',
          518: 'Serie D',
          520: 'Serie D',
          521: 'Serie D',
          522: 'Serie D',
          167: 'Serie C Girone A',
          357: 'Serie C Girone B',
          728: 'Serie C Girone C',
          345: 'Qualificazioni Mondiali',
          330: 'Confederations Cup',
          129: 'Premier Liga Russia (RUS)',
          9: 'Eredivisie (OLA)',
          99: 'LPFP Portogallo (POR)',
          363: 'Brasileirao (BRA)',
          724: 'Primera Division (ARG)',
          116: 'Prva HNL Croazia (CRO)',
          113: 'Greece Superleague (GRE)',
          115: 'Super Lig Turchia (TUR)',
          112: 'Begisch Pro League (BEL)',
          135: 'Swiss Super League (SUI)',
          370: 'Apertura Cile (CHI)',
          558: 'Clausura Cile (CHI)',
          199: 'Apertura Messico (MES)',
          385: 'Clausura Messico (MES)',
          367: 'Primera Division Uruguay (URU)',
          588: 'Campionato Uruguay (clausura)',
          14: 'Premier League Scozia (SCO)',
          371: 'Apertura Colombia (COL)',
          589: 'Clausura Colombia (COL)',
          1166: 'Finale Conmebol/Uefa',
          0: 'Totale'
        },
        rugbyCompetitionName: {
          209: '6 Nazioni',
          212: 'Top 12'
        },
        raceCompetitionName: {
          1: 'F1',
          2: 'SBK',
          3: 'Moto GP',
          4: 'Moto 2',
          5: 'Moto 3'
        },
        raceCompetitionLongName: {
          1: 'Formula 1',
          2: 'SBK',
          3: 'Moto GP',
          4: 'Moto 2',
          5: 'Moto 3'
        },
        gpName: {
          Australia: 'Australia',
          Austria: 'Austria',
          Azerbaijan: 'Azerbaigian',
          Argentina: 'Argentina',
          Bahrain: 'Bahrain',
          Belgium: 'Belgio',
          Brazil: 'Brasile',
          'Czech Republic': 'Repubblica Ceca',
          Canada: 'Canada',
          China: 'Cina',
          France: 'Francia',
          Germany: 'Germania',
          'Great Britain': 'Gran Bretagna',
          Hungary: 'Ungheria',
          Kazakhstan: 'Kazakistan',
          Italy: 'Italia',
          India: 'India',
          Indonesia: 'Indonesia',
          Japan: 'Giappone',
          Malaysia: 'Malesia',
          Mexico: 'Messico',
          Monaco: 'Monaco',
          Netherlands: 'Olanda',
          Portugal: 'Portogallo',
          Qatar: 'Qatar',
          Russia: 'Russia',
          'San Marino': 'San Marino',
          'Saudi Arabia': 'Arabia Saudita',
          Singapore: 'Singapore',
          Spain: 'Spagna',
          Thailand: 'Thailandia',
          Toscana: 'Toscana Ferrari 1000',
          USA: 'USA',
          'United States of America': 'USA',
          'United Arab Emirates': 'Abu Dhabi',
          'United Kingdom': 'Gran Bretagna',
          Vietnam: 'Vietnam',
          Finland: 'Finlandia',
          Turkey: 'Turchia'
        },
        gpNameWithGrammar: {
          Australia: "D'Australia",
          Austria: "D'Austria",
          Azerbaijan: "D'Azerbaigian",
          Argentina: "D'Argentina",
          Bahrain: 'Del Bahrain',
          Belgium: 'Del Belgio',
          Brazil: 'Del Brasile',
          'Czech Republic': 'Della Repubblica Ceca',
          Canada: 'Del Canada',
          China: 'Di Cina',
          France: 'Di Francia',
          Germany: 'Di Germania',
          'Great Britain': 'Di Gran Bretagna',
          Hungary: 'Di Ungheria',
          Kazakhstan: 'Del Kazakistan',
          Italy: "D'Italia",
          India: "D'India",
          Japan: 'Del Giappone',
          Malaysia: 'Della Malesia',
          Mexico: 'Del Messico',
          Monaco: 'Di Monaco',
          Netherlands: "D'Olanda",
          Portugal: 'Del Portogallo',
          Qatar: 'Del Quatar',
          Russia: 'Di Russia',
          'San Marino': 'Di San Marino',
          Singapore: 'Di Singapore',
          Spain: 'Di Spagna',
          Thailand: 'Della Thailandia',
          USA: 'Degli USA',
          'United Arab Emirates': 'Di Abu Dhabi',
          'United Kingdom': 'Di Gran Bretagna'
        },
        gpStatus: {
          TOAPPROVAL: 'Rinviata',
          TBD: 'Rinviata',
          ABORTED: 'Annullata',
          FINISHED: 'Fine',
          'ON TRACK': 'Live'
        },
        gpPhases: {
          FP: 'Prove libere',
          FP1: 'Prove libere 1',
          FP2: 'Prove libere 2',
          FP3: 'Prove libere 3',
          FP4: 'Prove libere 4',
          QUALI: 'Qualifiche',
          SPRINTQUALI: 'Gara Sprint',
          SUPERPOLE: 'Superpole',
          WARMUP: 'Warmup',
          SPRINTRACE: 'Gara Sprint',
          SPRINTSHOOTOUT: 'Qualifiche Sprint',
          RACE: 'Gara',
          RACE1: 'Gara 1',
          RACE_SUPERPOLE: 'Race Superpole',
          RACE2: 'Gara 2'
        },
        roundName: {
          'Round of 32': 'Sedicesimi di finale',
          'Round of 16': 'Ottavi di finale',
          'round-of-16': 'Ottavi di finale',
          'Quarter-Finals': 'Quarti di finale',
          'quarter-finals': 'Quarti di finale',
          'Semi-Finals': 'Semifinali',
          'semi-finals': 'Semifinali',
          Round: 'Giornata 1',
          'Play-Offs': 'Playoff',
          '3rd and 4th Place': 'Finale per il 3° posto',
          '3rd-and-4th-place': 'Finale per il 3° posto',
          Final: 'Finale',
          final: 'Finale',
          'Play Out': 'Play out',
          'Play-Out': 'Play out',
          Preliminary: 'Playoff Preliminari',
          'Qualifier Round': 'Turno di qualificazioni',
          'conference-round-1': '1&deg; turno',
          'conference-round-2': '2&deg; turno',
          'conference-semifinals': 'Semifinale di Conference',
          'conference-finals': 'Finale di Conference',
          'nba-finals': 'Finals'
        },
        roundNameTennis: {
          '1st Round': '1° Turno',
          '2nd Round': '2° Turno',
          '3rd Round': '3° Turno',
          '4th Round': '4° Turno',
          'Quarter-final': 'Quarti',
          'Quarter-Final': 'Quarti',
          'Semi-final': 'Semifinali',
          Final: 'Finale',
          '1-128-final': 'Sessantaquattresimi',
          '1-64-final': 'Trentaduesimi',
          '1-32-final': 'Sedicesimi',
          '1-16-final': 'Ottavi',
          'quarter-finals': 'Quarti',
          'semi-finals': 'Semifinali',
          '3rd-place': 'Finale terzo posto',
          final: 'Finale',
          'group-stage': 'Fase a gruppi',
          'qualifying-1st-round': 'Qualificazioni 1° Turno',
          'qualifying-2nd-round': 'Qualificazioni 2° Turno',
          'qualifying-3rd-round': 'Qualificazioni 3° Turno',
          'qualifying-final': 'Qualificazioni Finale',
          'world-group-play-offs': 'Spareggi'
        },
        roundNameMobile: {
          'Qualifier Round': '1&deg; turno',
          'Round 1': '1&deg; turno',
          'Round 2': '2&deg; turno',
          'Round 3': '3&deg; turno',
          'Round 4': '4&deg; turno',
          'Play-Offs': 'Spareggi',
          'Round of 32': 'Sedicesimi',
          'Round of 16': 'Ottavi',
          'Quarter-Finals': 'Quarti',
          'Semi-Finals': 'Semifinali',
          Final: 'Finale',
          '3rd and 4th Place': 'Finale per il 3&deg; posto',
          'Play Out': 'Play out',
          'Play-Out': 'Play out',
          Preliminary: 'Playoff Preliminari'
        },
        roundNameMobileCorriere: {
          'Round of 32': 'Sedicesimi',
          'Round of 16': 'Ottavi',
          'Quarter-Finals': 'Quarti',
          'Semi-Finals': 'Semifinali',
          Round: 'Giornata 1',
          'Play-Offs': 'Playoff',
          Final: 'Finale',
          '3rd and 4th Place': 'Finale per il 3° posto',
          'Play Out': 'Play out',
          'Play-Out': 'Play out',
          Preliminary: 'Preliminari'
        },
        matchColor: {
          L: 'P',
          W: 'V',
          D: 'N'
        },
        tennisCompetitionName: {
          'Mens Singles': 'Singolare Maschile',
          'Womens Singles': 'Singolare Femminile',
          'Mens Doubles': 'Doppio Maschile',
          'Womens Doubles': 'Doppio Femminile',
          'Mixed Doubles': 'Doppio Misto',
          'Davis Cup Mens': 'Maschile',
          'Davis Cup Womens': 'Femminile',
          'Czech Republic Vs Usa Singles': 'Czech Republic Vs Usa Singles',
          'Czech Republic Vs Usa Doubles': 'Czech Republic Vs Usa Doubles',
          'Lille Challenger': 'Lille Challenger',
          'Mens National Teams': 'Nazionale Maschile'
        },
        tennisTournamentType: {
          'ATP World Tour 250': 'ATP',
          'Grand Slam': 'Grande Slam',
          'ATP World Tour Masters 1000': 'Masters 1000',
          'ATP Masters 1000': 'Masters 1000',
          'ATP World Tour 500': 'Master 500',
          'ATP World Tour Finals': 'ATP',
          'ATP Challenger': 'Challenger',
          'ATP 250': 'ATP',
          'ATP 500': 'Master 500',
          'ATP Masters 1000 / WTA 1000': 'Masters 1000',
          'ATP Finals': 'Finals',
          'WTA Finals': 'Finals',
          'WTA Premier': 'WTA',
          'WTA International': 'WTA',
          'WTA 500': 'WTA',
          'WTA 250': 'WTA',
          'WTA 1000': 'WTA',
          'WTA 125': 'WTA',
          'WTA 125s': 'WTA',
          'Season-Ending Championships': 'WTA',
          Olympics: 'Olimpiadi',
          'Laver cup': 'Laver Cup',
          'Davis Cup': 'Davis Cup',
          'Fed Cup': 'Fed Cup',
          'ATP Challenger Tour': 'Challenger',
          Masters: 'Masters 1000',
          ATP250: 'ATP',
          ATP500: 'Master 500',
          'World Championship': 'Finals',
          'WTA 125K Series': 'WTA',
          Normal: 'Finals'
        },
        cyclingTableType: {
          Individual: 'Generale',
          Montaña: 'Scalatori',
          Puntos: 'A punti',
          Jóvenes: 'Giovani',
          Jovenes: 'Giovani',
          Equipos: 'Squadre',
          Abandonos: 'Ritirati'
        }
      },
      dynamicTable: {
        cols: {
          competitionTeams: {
            teamName: '',
            teamId: '',
            drawn: 'N',
            englishMean: 'MI',
            form: 'Forma',
            goalsConceded: 'Gs',
            goalsMade: 'Gf',
            lost: 'P',
            played: 'G',
            points: 'Pt.',
            position: '',
            startingPosition: '',
            won: 'V',
            titleLabel: function titleLabel(id) {
              return 'GRUPPO ' + id;
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              drawn: 'Pareggi',
              englishMean: 'Media Inglese',
              goalsConceded: 'Goal subiti',
              goalsMade: 'Goal fatti',
              lost: 'Perse',
              played: 'Giocate',
              points: 'Punti',
              position: '',
              won: 'Vittorie'
            }
          },
          standingTeams: {
            teamOfficialName: '',
            drawn: 'N',
            setsAgainst: 'Sp',
            setsPro: 'Sv',
            matchesLost: 'P',
            matchesTotal: 'T',
            points: 'Pt.',
            rank: '',
            matchesWon: 'V',
            teamId: '',
            title: '',
            titleLabel: function titleLabel(id) {
              return 'GRUPPO ' + id;
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              drawn: 'Pareggi',
              englishMean: 'Media Inglese',
              goalsConceded: 'Goal subiti',
              goalsMade: 'Goal fatti',
              lost: 'Perse',
              played: 'Giocate',
              points: 'Punti',
              position: '',
              won: 'Vittorie',
              matchesTotal: 'Totali',
              matchesWon: 'Vinte',
              matchesLost: 'Perse',
              setsPro: 'Set Vinti',
              setsAgainst: 'Set Persi'
            }
          },
          basketStandings: {
            lost: 'P',
            pointsConceded: 'PS',
            pointsScored: 'PF',
            pointsStanding: 'Pt.',
            rank: '',
            teamId: '',
            teamName: '',
            total: 'G',
            winPercentage: 'Diff.',
            won: 'V',
            title: '',
            titleLabel: function titleLabel(id) {
              return 'GRUPPO ' + id;
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              lost: 'Perse',
              pointsConceded: 'Punti Subiti',
              pointsScored: 'Punti Fatti',
              pointsStanding: 'Punti',
              rank: '',
              teamId: '',
              teamName: '',
              total: 'Giocate',
              winPercentage: 'Diff. Punti',
              won: 'Vittorie',
              title: ''
            }
          },
          competitionMarkers: {
            goals: 'G',
            penalties: 'R',
            playerId: '',
            playerName: '',
            playerRole: 'Ruolo',
            playerCountry: '',
            teamId: '',
            teamName: 'Squadra',
            titleLabel: function titleLabel() {
              return '';
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              goals: 'Goal',
              penalties: 'Rigori'
            }
          },
          competitionRoundMatches: {
            team1: '',
            team2: '',
            firstLeg: 'Andata',
            secondLeg: 'Ritorno',
            titleLabel: function titleLabel(id) {
              var playOffLabel = {
                'Round of 32': 'Sedicesimi di finale',
                'Round of 16': 'Ottavi di finale',
                'Quarter-Finals': 'Quarti di finale',
                'Semi-Finals': 'Semifinali',
                Round: '',
                'Play-Offs': '',
                '3rd and 4th Place': 'Finale per il 3° posto',
                Final: 'Finale',
                D2: 'Gruppo D2'
              };
              return playOffLabel[id];
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              }
            }
          },
          hallOfFame: {
            teamName: '',
            teamId: '',
            year: '',
            point: '',
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              year: ''
            }
          },
          drivers: {
            points: 'P',
            team: '',
            teamNat: '',
            driverId: '',
            driver: '',
            driverNat: '',
            driverFirstName: '',
            driverLastName: '',
            position: '',
            toolTip: {
              points: 'Punti'
            }
          },
          players: {
            nationality: '',
            displayName: '',
            firstName: '',
            lastName: '',
            points: 'Pt.',
            rank: '',
            toolTip: {
              points: 'Punti'
            }
          },
          constructors: {
            points: 'P',
            builder: '',
            constructorId: '',
            position: '',
            toolTip: {
              points: 'Punti'
            }
          },
          teams: {
            points: 'P',
            team: '',
            teamId: '',
            position: '',
            toolTip: {
              points: 'Punti'
            }
          },
          freePractice: {
            time: '',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: ''
          },
          superpole: {
            time: 'Tempo',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              time: ''
            }
          },
          warmup: {
            time: 'Tempo',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              time: ''
            }
          },
          qualification: {
            Q3: 'Q3',
            Q2: 'Q2',
            Q1: 'Q1',
            team: '',
            tid: '',
            driver: '',
            driverName: '',
            nat: '',
            pos: '',
            toolTip: {
              Q3: 'Qualificazione 1',
              Q2: 'Qualificazione 2',
              Q1: ' Qualificazione1'
            }
          },
          qualification2: {
            time: 'Tempo',
            team: '',
            tid: '',
            driver: '',
            driverName: '',
            nat: '',
            pos: '',
            toolTip: {}
          },
          raceLive: {
            pitstops: 'Pit Stop',
            time: 'Tempo',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          sprintraceLive: {
            pitstops: 'Pit Stop',
            time: 'Tempo',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          sprintqualiLive: {
            pitstops: 'Pit Stop',
            time: 'Tempo',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          race1Live: {
            pitstops: 'Pit Stop',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          race_superpoleLive: {
            pitstops: 'Pit Stop',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          race2Live: {
            pitstops: 'Pit Stop',
            laps: 'Giri',
            status: 'Status',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            titleLabel: function titleLabel(laps) {
              return laps;
            },
            toolTip: {
              pitstops: '',
              laps: '',
              status: ''
            }
          },
          raceEnded: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          sprintraceEnded: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          sprintqualiEnded: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          race1Ended: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          race_superpoleEnded: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          race2Ended: {
            pitstops: 'PS',
            time: 'Tempo',
            points: 'P',
            team: '',
            tid: '',
            didx: '',
            driver: '',
            nat: '',
            pos: '',
            toolTip: {
              pitstops: 'Pit Stop',
              points: 'Punti',
              time: ''
            }
          },
          squad: {
            playerId: '',
            teamId: '',
            playerName: 'Nome giocatore',
            playerJersey: '',
            playerRole: 'Ruolo',
            playerBirthDate: '',
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              playerId: '',
              teamId: '',
              playerName: 'Nome giocatore',
              playerJersey: '',
              playerRole: 'Ruolo',
              playerBirthDate: ''
            }
          }
        }
      },
      statistics: {
        newspapers: {
          gazzetta: 'La Gazzetta dello Sport',
          corriere: 'Corriere.it',
          fcinter: 'FC Inter 1908',
          forzaroma: 'Forzaroma.info',
          calcionapoli1926: 'Calcio Napoli 1926'
        },
        statsInCompetition: {
          won: 'partite vinte',
          lost: 'sconfitte',
          drawn: 'pareggi',
          goalsMade: 'gol segnati',
          goalsConceded: 'gol subiti',
          played: 'gol/partita'
        },
        lastMatches: {
          last: 'Ultime 5 partite',
          versus: 'Testa a testa',
          form: 'Forma',
          allMatches: 'Tutte le partite',
          headToHead: 'Sfide in',
          played: 'Giocate',
          draw: 'Pareggiate'
        },
        barLabels: {
          possession_percentage: {
            label: 'Possesso Palla',
            isPercentage: true,
            isInside: true
          },
          shots: {
            label: 'Tiri in porta',
            isPercentage: false,
            isInside: true
          },
          shots_saved: {
            label: 'Tiri respinti',
            isPercentage: false,
            isInside: true
          },
          offsides: {
            label: 'Fuorigioco',
            isPercentage: false,
            isInside: true
          },
          corners: {
            label: 'Corner',
            isPercentage: false,
            isInside: true
          },
          crosses: {
            label: 'Cross',
            isPercentage: false,
            isInside: true
          },
          dribblings: {
            label: 'Dribbling',
            isPercentage: false,
            isInside: true
          },
          fouls: {
            label: 'Falli subiti',
            isPercentage: false,
            isInside: true
          },
          yellow_cards: {
            label: 'Ammonizioni',
            isPercentage: false,
            isInside: true
          },
          red_cards: {
            label: 'Espulsioni',
            isPercentage: false,
            isInside: true
          },
          lastFive: {
            label: 'Vinte',
            isPercentage: false,
            isInside: false
          },
          pointsScored: {
            label: 'Punti segnati',
            isPercentage: false,
            isInside: true
          },
          fieldGoalsMade: {
            label: 'Tiri realizzati',
            isPercentage: false,
            isInside: true
          },
          fieldGoalsAttempts: {
            label: 'Tiri totali',
            isPercentage: false,
            isInside: true
          },
          s2PointMade: {
            label: 'Tiri da 2',
            isPercentage: false,
            isInside: true
          },
          s2PointAttempts: {
            label: 'Tentativi tiri da 2',
            isPercentage: false,
            isInside: true
          },
          s3PointMade: {
            label: 'Tiri da 3',
            isPercentage: false,
            isInside: true
          },
          s3PointAttempts: {
            label: 'Tentativi tiri da 3',
            isPercentage: false,
            isInside: true
          },
          freeThrowsMade: {
            label: 'Tiri liberi',
            isPercentage: false,
            isInside: true
          },
          freeThrowsAttempts: {
            label: 'Tentativi tiri liberi',
            isPercentage: false,
            isInside: true
          },
          offensiveRebounds: {
            label: 'Rimbalzi Offensivi',
            isPercentage: false,
            isInside: true
          },
          defensiveRebounds: {
            label: 'Rimbalzi Difensivi',
            isPercentage: false,
            isInside: true
          },
          totalRebounds: {
            label: 'Rimbalzi Totali',
            isPercentage: false,
            isInside: true
          },
          personalFouls: {
            label: 'Falli Fatti',
            isPercentage: false,
            isInside: true
          },
          assists: {
            label: 'Assist',
            isPercentage: false,
            isInside: true
          },
          steals: {
            label: 'Palle Rubate',
            isPercentage: false,
            isInside: true
          },
          blocks: {
            label: 'Stoppate',
            isPercentage: false,
            isInside: true
          }

        },
        player: {
          age: 'Età',
          height: 'Altezza',
          weight: 'Peso',
          foot: 'Piede preferito',
          goal: 'gol realizzati',
          assist: 'assist',
          penalty: 'rigori realizzati',
          games: 'partite giocate',
          subOff: 'da titolare',
          subOn: 'da subentrato',
          minPlayed: 'minuti giocati',
          yellowCards: 'ammonizioni',
          redCards: 'espulsioni',
          voteMean: 'media voto',
          magicVoteMean: 'media Magic voto',
          magicCredits: 'Magic crediti'
        }
      },
      header: {
        21: 'Serie A',
        105: 'Serie B',
        128: 'Copa America',
        5: 'Champions League',
        6: 'Europa League',
        1125: 'Conference League',
        22: 'Bundesliga',
        23: 'Liga',
        8: 'Premier League',
        24: 'Ligue 1',
        3: 'Euro 2024',
        352: 'Europei U21',
        383: 'Europei U19',
        4: 'Mondiali',
        1277: 'Mondiale per Club',
        408: 'Mondiali Femminili',
        616: 'Europei Femminili',
        941: 'Nations League',
        259: 'Coppa Italia',
        173: 'Super Coppa Italiana',
        174: 'Super Coppa Europea',
        558: 'Clausura Cile',
        9: 'Eredivisie',
        135: 'Swiss Super League',
        199: 'Apertura Messico',
        363: 'Brasileirao',
        371: 'Apertura Colombia',
        99: 'LPFP Portogallo',
        115: 'Super Lig Turchia',
        724: 'Primera Division',
        589: 'Clausura Colombia',
        129: 'Premier Liga Russa',
        367: 'Primera Division Uruguay (Apertura)',
        588: 'Primera Division Uruguay (Clausura)',
        370: 'Apertura Cile',
        113: 'Greece Superleague',
        14: 'Premier League Scozia',
        116: 'Prva HNL Croazia',
        88: 'Amichevole',
        standings: 'Posizione in classifica: #',
        motorsport: {
          1: 'Formula 1',
          3: 'Moto GP',
          4: 'Moto 2',
          5: 'Moto 3'
        }
      },
      clubInfo: {
        society: 'Societ&agrave;',
        management: 'Dirigenza',
        founded: 'Anno fondazione',
        stadium: 'Stadio',
        place: 'Sede',
        staff: 'Staff tecnico',
        honours: 'Albo d\'oro',
        'Assistant Manager': 'Allenatore in 2&ordf;',
        Manager: 'Allenatore',
        'Organisation and technical': 'Direttore Area Tecnica',
        'Director, Head of Board': 'Direttore Generale',
        President: 'Presidente',
        'Fitness Trainer': 'Massaggiatore',
        'Team Manager': 'Direttore Sportivo',
        'Athletic trainer': 'Preparatore atletico'
      },
      cupstandings: {
        forward: 'Avanti',
        back: 'Indietro',
        toolTip: {
          goals: 'Goal',
          penalties: 'Rigori'
        }
      },
      liveHubLink: {
        local: '#',
        development: '#',
        stag: '/risultati-live/',
        production: '/risultati-live/'
      },
      gazzanetLiveHubLink: {
        local: '#',
        development: '#',
        stag: '/competizioni-calcio/risultati-live/',
        production: '/competizioni-calcio/risultati-live/'
      },
      calendarLink: {
        local: '#',
        development: '#',
        stag: '/calcio/',
        production: '/calcio/'
      },
      gazzanetCalendarLink: {
        local: '#',
        development: '#',
        stag: '/competizioni-calcio/',
        production: '/competizioni-calcio/'
      },
      raceCalendarLink: {
        local: '#',
        development: '#',
        stag: '/motori/',
        production: '/motori/'
      },
      standingsLink: {
        local: '#',
        development: '#',
        stag: '/calcio/',
        production: '/calcio/'
      },
      gazzanetStandingsLink: {
        local: '#',
        development: '#',
        stag: '/competizioni-calcio/',
        production: '/competizioni-calcio/'
      },
      raceStandingsLink: {
        local: '#',
        development: '#',
        stag: '/motori/',
        production: '/motori/'
      },
      competitionLink: {
        21: 'serie-a',
        105: 'serie-b',
        1105: 'serie-b-playoff',
        128: 'copa-america',
        5: 'champions-league',
        6: 'europa-league',
        1125: 'conference-league',
        22: 'bundesliga',
        23: 'liga',
        8: 'premier-league',
        24: 'ligue-1',
        3: 'europei',
        352: 'europei-u21',
        383: 'europei-u19',
        4: 'mondiali',
        408: 'mondiali-femminili',
        616: 'nazionale-femminile',
        941: 'nations-league',
        259: 'coppa-italia',
        173: 'supercoppaitaliana',
        174: 'supercoppaeuropea',
        88: 'amichevoli',
        558: 'clausura-cile',
        9: 'eredivisie',
        135: 'swiss-super-league',
        199: 'apertura-mexico',
        363: 'brasileirao',
        371: 'apertura-colombia',
        99: 'lpfp_portuguese-liga',
        115: 'tff-super-lig',
        724: 'primera-division-argentina',
        589: 'clausura-colombia',
        129: 'russian-premier-liga',
        367: 'primera-division-uruguay-apertura',
        588: 'primera-division-uruguay-clausura',
        370: 'apertura-cile',
        113: 'superleague-ellada',
        14: 'scottish-premier-league',
        116: 'prva-nhl',
        '6C': 'F1',
        1277: 'coppa-mondo-club',
        335: 'coppa-mondo-club-2023',
        34: 'amichevole',
        1166: 'finale-conmebol-uefa'
      },
      raceCompetitionLink: {
        1: 'f1',
        2: 'superbike',
        3: 'motogp',
        4: 'moto2',
        5: 'moto3'
      },
      basketCompetitionLink: {
        1: 'serie-a-maschile',
        2: 'serie-a-femminile',
        3: 'nba',
        4: 'lituania',
        5: 'spagna',
        6: 'mondiali',
        7: 'europei'
      },
      skiCompetitionLink: {
        1: 'coppa-mondo-sci-maschile',
        2: 'coppa-mondo-sci-femminile'
      },
      rugbyCompetitionLink: {
        209: '6-nazioni',
        212: 'top12'
      },
      volleyCompetitionLink: {
        2: 'superlega',
        3: 'serie-a1-femminile'
      },
      cyclingCompetitionLink: {
        7100: 'tour-de-france',
        7101: 'giro-d-italia',
        7102: 'vuelta',
        7107: 'world-cup',
        90014: 'santos-tour-down-under',
        90030: 'paris-roubaix',
        90031: 'criterium-du-dauphine',
        90032: 'paris-nice',
        90033: 'tour-de-california',
        90035: 'clasica-de-san-sebastian',
        90036: 'tour-de-polonia',
        90050: 'cadel-evans-great-ocean-road-race',
        90051: 'uae-tour',
        90053: 'strade-bianche',
        90052: 'omloop-het-nieuwsblad',
        90054: 'tirreno-adriatico',
        90055: 'milan-sanremo',
        90056: 'volta-ciclista-a-catalunya',
        90057: 'e3-harelbeke',
        90058: 'gent-wevelgem',
        90059: 'dwars-door-vlaanderen',
        90060: 'tour-de-flandes',
        90061: 'vuelta-al-pais-vasco',
        90062: 'amstel-gold-race',
        90063: 'la-fleche-wallonne',
        90064: 'liege-bastogne-liege',
        90065: 'tour-de-romandie',
        90066: 'eschborn-frankfurt',
        90067: 'tour-de-suiza',
        90068: 'ridelondon-surrey-classic',
        90069: 'binck-bank-tour',
        90070: 'euroeyes-cyclassics-hamburg',
        90071: 'bretagne-classic-ouest-france',
        90072: 'grand-prix-cycliste-de-quebec',
        90073: 'grand-prix-cycliste-de-montreal',
        90074: 'presidential-cycling-tour-of-turkey',
        90075: 'giro-di-lombardia',
        90076: 'tour-of-guangxi',
        90115: 'driedaagse-brugge-de-panne'
      },
      cyclingCompetitionLabel: {
        7100: 'Tour de France',
        7101: "Giro d'Italia",
        7102: 'Vuelta',
        7107: 'Mundial Yorkshire',
        90014: 'Santos Tour Down Under',
        90030: 'Parigi-Roubaix',
        90031: 'Critérium du Dauphiné',
        90032: 'Parigi-Nizza',
        90033: 'Tour of California',
        90035: 'Clásica San Sebastián',
        90036: 'Giro di Polonia',
        90050: 'Cadel Evans Great Ocean Road Race',
        90051: 'UAE Tour',
        90052: 'Omloop Het Nieuwsblad',
        90053: 'Strade Bianche',
        90054: 'Tirreno-Adriatico',
        90055: 'Milano-Sanremo',
        90056: 'Volta Ciclista a Catalunya',
        90057: 'E3 Harelbeke',
        90058: 'Gand-Wevelgem',
        90059: 'Dwars door Vlaanderen',
        90060: 'Giro delle Fiandre',
        90061: 'Vuelta al País Vasco',
        90062: 'Amstel Gold Race',
        90063: 'Freccia Vallone',
        90064: 'Liegi-Bastogne-Liegi',
        90065: 'Tour de Romandia',
        90066: 'Eschborn-Frankfurt',
        90067: 'Tour of Suisse',
        90068: 'RideLondon-Surrey Classic',
        90069: 'Binck Bank Tour',
        90070: 'EuroEyes Cyclassics Hamburg',
        90071: 'Bretagne Classic Ouest-France',
        90072: 'Grand Prix Cycliste de Québec',
        90073: 'Grand Prix Cycliste de Montréal',
        90074: 'Presidential Cycling Tour of Turkey',
        90075: 'Giro di Lombardia',
        90076: 'Tour of Guangxi',
        90115: 'Driedaagse Brugge-De Panne'
      },
      sportsName: {
        1: 'calcio',
        '6C': 'automobilismo',
        '6M': 'motociclismo',
        8: 'tennis',
        3: 'basket'
      },
      raceSolrName: {
        1: 'f1',
        2: 'superbike',
        3: 'moto-gp',
        4: 'moto-2',
        5: 'moto-3'
      },
      widgets: {
        cols: {
          competitionTeams: {
            teamName: '',
            teamId: '',
            drawn: 'N',
            englishMean: 'MI',
            form: 'Forma',
            goalsConceded: 'Gs',
            goalsMade: 'Gf',
            lost: 'P',
            played: 'G',
            points: 'Pt.',
            position: '',
            startingPosition: '',
            won: 'V',
            titleLabel: function titleLabel() {
              return 'Squadra';
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              drawn: 'Pareggi',
              englishMean: 'Media Inglese',
              goalsConceded: 'Goal subiti',
              goalsMade: 'Goal fatti',
              lost: 'Perse',
              played: 'Giocate',
              points: 'Punti',
              position: '',
              won: 'Vittorie'
            }
          },
          competitionMarkers: {
            goals: 'G',
            penalties: 'R',
            playerId: '',
            playerName: '',
            playerRole: 'Ruolo',
            playerCountry: '',
            teamId: '',
            teamName: 'Squadra',
            titleLabel: function titleLabel() {
              return 'Giocatore';
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              goals: 'Goal',
              penalties: 'Rigori'
            }
          },
          rugbyStandings: {
            teamName: '',
            teamId: '',
            drawn: 'N',
            losingBonus: 'LB',
            triesBonus: 'TB',
            triesFor: 'Mf',
            triesAgainst: 'Ms',
            lost: 'P',
            played: 'G',
            points: 'Pt.',
            rank: '',
            won: 'V',
            pointsDiff: '+/-',
            titleLabel: function titleLabel() {
              return 'GiocSquadraSquadraatore';
            },
            toolTip: {
              titleLabel: function titleLabel() {
                return '';
              },
              drawn: 'Pareggi',
              losingBonus: 'Losing Bonus',
              triesBonus: 'Tries Bonus',
              lost: 'Perse',
              played: 'Giocate',
              points: 'Punti',
              won: 'Vittorie',
              pointsDiff: 'Differenza punti'
            }
          }
        },
        worldCupCorriere: {
          standingLink: 'https://www.corriere.it/sport/calcio/mondiali/classifica/',
          calendarLink: 'https://www.corriere.it/sport/calcio/mondiali/calendario-risultati/',
          timing: {
            'Full Time': 'Finita',
            FINISHED: 'Finita',
            'First Half': 'I Tempo',
            'Half Time': 'Fine I Tempo',
            'Second Half': 'II Tempo',
            'Pre Match': 'Ore',
            FullTime: 'Finita',
            FullTime90: 'Fine II Tempo',
            FullTimePens: 'Fine II TS',
            ShootOut: 'Rigori',
            FirstHalf: 'I Tempo',
            HalfTime: 'Fine I Tempo',
            SecondHalf: 'II Tempo',
            PreMatch: 'Ore',
            ExtraFirstHalf: 'I Tempo suppl.',
            ExtraHalfTime: 'Fine I TS',
            ExtraSecondHalf: 'II Tempo suppl.',
            Abandoned: 'Abbandonato',
            Postponed: 'Rinviata',
            Notplayed: 'non disputata',
            Delayed: 'Posticipato',
            Suspended: 'Sospeso',
            Cancelled: 'Cancellato'
          },
          phases: {
            groups: 'Gironi',
            'round-of-16': 'Ottavi',
            'quarter-finals': 'Quarti',
            'semi-finals': 'Semifin.',
            '3rd-and-4th-place': '3°/4° posto',
            final: 'Finale'
          }
        }
      },
      synthesis: {
        desktop: {
          'Full Time': 'Fine',
          FINISHED: 'Fine',
          'First Half': '1°T',
          'Half Time': 'Fine 1°T',
          'Second Half': '2°T',
          'Pre Match': '',
          FullTime: 'Fine',
          FullTime90: 'Fine 2° Tempo',
          FullTimePens: 'Fine 2° TS',
          FirstHalf: 'Primo Tempo',
          HalfTime: 'Finisce il 1°T',
          SecondHalf: 'Secondo Tempo',
          PreMatch: '',
          ExtraFirstHalf: '1° TS',
          ExtraHalfTime: 'Fine 1°TS',
          ExtraSecondHalf: '2° TS',
          ShootOut: 'Calci di rigore',
          Abandoned: 'Abbandonato',
          Postponed: 'Rinviata',
          NOTPLAYED: 'non disputata',
          Delayed: 'Posticipato',
          Suspended: 'Sospeso',
          Cancelled: 'Cancellato',
          Live: 'Live',
          start: 'Inizia il',
          lineups: 'Formazioni',
          yellow_card: 'Ammonito',
          red_card: 'Espulso',
          second_yellow_red_card: 'Espulso per doppio giallo',
          goal: 'Gol',
          end: 'Finisce',
          postGame: 'partita',
          player_on: 'Entra',
          player_off: 'Esce',
          post_right: 'sul Palo',
          post_left: 'sul Palo',
          post: 'sul Palo',
          post_high: 'sulla Traversa',
          own_goal: 'Autorete',
          penalty_scored: 'Gol su rigore',
          penalty_saved: 'Parata',
          hit_woodwork: 'Rigore sbagliato',
          penalty_missed: 'Rigore fuori',
          close_left: 'sfiora il palo',
          close_right: 'sfiora il palo',
          close_high: 'sfiora la traversa',
          close_high_left: "sfiora l'incrocio",
          close_high_right: "sfiora l'incrocio",
          'hit_woodwork post_right': 'Rigore sul palo',
          'hit_woodwork post_left': 'Rigore sul palo',
          'hit_woodwork post_high': 'Rigore sulla traversa',
          //'penalty_missed close_high': 'Rigore sfiora la traversa',
          'start FirstHalf': 'Inizia il Primo Tempo',
          'end postGame': 'Finisce la Partita'
        },
        mobile: {
          second_yellow_red_card: 'Espulso'
        }
      }
    }
  },
  routes: {
    hublive: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        return '/risultati-live/';
      },
      production: function production() {
        return '/risultati-live/';
      }
    },
    favourites: {
      local: function local() {
        return '/favourites';
      },
      development: function development() {
        return '/favourites';
      },
      stag: function stag() {
        return '/risultati-live/preferiti/';
      },
      production: function production() {
        return '/risultati-live/preferiti/';
      }
    },
    hubliveCorriere: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        return '/sport/risultati-live/';
      },
      production: function production() {
        return '/sport/risultati-live/';
      }
    },
    favouritesCorriere: {
      local: function local() {
        return '/favourites';
      },
      development: function development() {
        return '/favourites';
      },
      stag: function stag() {
        return '/sport/risultati-live/preferiti/';
      },
      production: function production() {
        return '/sport/risultati-live/preferiti/';
      }
    },
    hubliveGazzanet: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        return '/competizioni-calcio/risultati-live/';
      },
      production: function production() {
        return '/competizioni-calcio/risultati-live/';
      }
    },
    favouritesGazzanet: {
      local: function local() {
        return '/favourites';
      },
      development: function development() {
        return '/favourites';
      },
      stag: function stag() {
        return '/competizioni-calcio/risultati-live/preferiti/';
      },
      production: function production() {
        return '/competizioni-calcio/risultati-live/preferiti/';
      }
    },
    calendar: {
      local: function local() {
        return '/calendar';
      },
      development: function development() {
        return '/calendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    cupcalendar: {
      local: function local() {
        return '/cupcalendar';
      },
      development: function development() {
        return '/cupcalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    motorsportcalendar: {
      local: function local() {
        return '/motorsportcalendar';
      },
      development: function development() {
        return '/motorsportcalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    tenniscalendar: {
      local: function local() {
        return '/tenniscalendar';
      },
      development: function development() {
        return '/tenniscalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    cyclecalendar: {
      local: function local() {
        return '/cyclecalendar';
      },
      development: function development() {
        return '/cyclecalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    volleycalendar: {
      local: function local() {
        return '/volleycalendar';
      },
      development: function development() {
        return '/volleycalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    volleycalendarchampionship: {
      local: function local() {
        return '/volleycalendarchampionship';
      },
      development: function development() {
        return '/volleycalendarchampionship';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    nbacalendar: {
      local: function local() {
        return '/nbacalendar';
      },
      development: function development() {
        return '/nbacalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    basketcalendarchampionship: {
      local: function local() {
        return '/basketcalendarchampionship';
      },
      development: function development() {
        return '/basketcalendarchampionship';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    rugbycalendar: {
      local: function local() {
        return '/rugbycalendar';
      },
      development: function development() {
        return '/rugbycalendar';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    topscorers: {
      local: function local() {
        return '/topscorers';
      },
      development: function development() {
        return '/topscorers';
      },
      stag: function stag() {
        return '/MatchCenter/topscorers/';
      },
      production: function production() {
        return '/test/matchcenter/topscorers/';
      }
    },
    standings: {
      local: function local() {
        return '/standings';
      },
      development: function development() {
        return '/standings';
      },
      stag: function stag() {
        return '/MatchCenter/standings/';
      },
      production: function production() {
        return '/test/matchcenter/standings/';
      }
    },
    cupstandings: {
      local: function local() {
        return '/cupstandings';
      },
      development: function development() {
        return '/cupstandings';
      },
      stag: function stag() {
        return '/MatchCenter/cupStandings/';
      },
      production: function production() {
        return '/test/matchcenter/cupStandings/';
      }
    },
    driverstandings: {
      local: function local() {
        return '/driverstandings';
      },
      development: function development() {
        return '/driverstandings';
      },
      stag: function stag() {
        return '/MatchCenter/driverstandings/';
      },
      production: function production() {
        return '/test/matchcenter/driverstandings/';
      }
    },
    constructorstandings: {
      local: function local() {
        return '/constructorstandings';
      },
      development: function development() {
        return '/constructorstandings';
      },
      stag: function stag() {
        return '/MatchCenter/constructorstandings/';
      },
      production: function production() {
        return '/test/matchcenter/constructorstandings/';
      }
    },
    halloffame: {
      local: function local() {
        return '/halloffame';
      },
      development: function development() {
        return '/halloffame';
      },
      stag: function stag() {
        return '/MatchCenter/halloffame/';
      },
      production: function production() {
        return '/test/matchcenter/halloffame/';
      }
    },
    cyclinghalloffame: {
      local: function local() {
        return '/cyclinghalloffame';
      },
      development: function development() {
        return '/cyclinghalloffame';
      },
      stag: function stag() {
        return '/MatchCenter/cyclinghalloffame/';
      },
      production: function production() {
        return '/test/matchcenter/cyclinghalloffame/';
      }
    },
    tennisranking: {
      local: function local() {
        return '/tennisranking';
      },
      development: function development() {
        return '/tennisranking';
      },
      stag: function stag() {
        return '/MatchCenter/tennisranking/';
      },
      production: function production() {
        return '/test/matchcenter/tennisranking/';
      }
    },
    cyclingstandings: {
      local: function local() {
        return '/cyclingstandings';
      },
      development: function development() {
        return '/cyclingstandings';
      },
      stag: function stag() {
        return '/MatchCenter/cyclingstandings/';
      },
      production: function production() {
        return '/test/matchcenter/cyclingstandings/';
      }
    },
    cyclingstage: {
      local: function local() {
        return '/cyclingstage';
      },
      development: function development() {
        return '/cyclingstage';
      },
      stag: function stag() {
        return '/MatchCenter/cyclingstage/';
      },
      production: function production() {
        return '/test/matchcenter/cyclingstage/';
      }
    },
    skistandings: {
      local: function local() {
        return '/skistandings';
      },
      development: function development() {
        return '/skistandings';
      },
      stag: function stag() {
        return '/MatchCenter/skistandings/';
      },
      production: function production() {
        return '/test/matchcenter/skistandings/';
      }
    },
    skistage: {
      local: function local() {
        return '/skistage';
      },
      development: function development() {
        return '/skistage';
      },
      stag: function stag() {
        return '/MatchCenter/skistage/';
      },
      production: function production() {
        return '/test/matchcenter/skistage/';
      }
    },
    skicalendar: {
      local: function local() {
        return '/skicalendar';
      },
      development: function development() {
        return '/skicalendar';
      },
      stag: function stag() {
        return '/MatchCenter/skicalendar/';
      },
      production: function production() {
        return '/test/matchcenter/skicalendar/';
      }
    },
    ucicalendar: {
      local: function local() {
        return '/ucicalendar';
      },
      development: function development() {
        return '/ucicalendar';
      },
      stag: function stag() {
        return '/MatchCenter/ucicalendar/';
      },
      production: function production() {
        return '/test/matchcenter/ucicalendar/';
      }
    },
    matchPage: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    teamPage: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    playerPage: {
      local: function local() {
        return '/';
      },
      development: function development() {
        return '/';
      },
      stag: function stag() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      },
      production: function production() {
        if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
          return document.location.pathname;
        }
        return '';
      }
    },
    volleystandings: {
      local: function local() {
        return '/volleystandings';
      },
      development: function development() {
        return '/volleystandings';
      },
      stag: function stag() {
        return '/MatchCenter/volleystandings/';
      },
      production: function production() {
        return '/test/matchcenter/volleystandings/';
      }
    },
    basketstandings: {
      local: function local() {
        return '/basketstandings';
      },
      development: function development() {
        return '/basketstandings';
      },
      stag: function stag() {
        return '/MatchCenter/basketstandings/';
      },
      production: function production() {
        return '/test/matchcenter/basketstandings/';
      }
    },
    rugbystandings: {
      local: function local() {
        return '/rugbystandings';
      },
      development: function development() {
        return '/rugbystandings';
      },
      stag: function stag() {
        return '/MatchCenter/rugbystandings/';
      },
      production: function production() {
        return '/test/matchcenter/rugbystandings/';
      }
    },
    uefastandings: {
      local: function local() {
        return '/uefastandings';
      },
      development: function development() {
        return '/uefastandings';
      },
      stag: function stag() {
        return '/MatchCenter/uefastandings/';
      },
      production: function production() {
        return '/test/matchcenter/uefastandings/';
      }
    },
    uefaplayoff: {
      local: function local() {
        return '/uefaplayoff';
      },
      development: function development() {
        return '/uefaplayoff';
      },
      stag: function stag() {
        return '/MatchCenter/uefaplayoff/';
      },
      production: function production() {
        return '/test/matchcenter/uefaplayoff/';
      }
    }
  },
  tables: {
    colsPosition: {
      competitionTeams: {
        teamName: 3,
        drawn: 8,
        englishMean: 12,
        form: 13,
        goalsConceded: 11,
        goalsMade: 10,
        lost: 9,
        played: 6,
        points: 5,
        position: 1,
        startingPosition: 4,
        won: 7,
        teamId: 2,
        title: 0
      },
      statsInCompetition: {
        won: 0,
        lost: 1,
        drawn: 2,
        goalsMade: 3,
        goalsConceded: 4,
        played: 5
      },
      squad: {
        playerJersey: 1,
        playerId: 0,
        playerName: 2,
        playerRole: 3
      },
      competitionMarkers: {
        goals: 7,
        penalties: 8,
        playerId: 1,
        playerName: 3,
        playerRole: 6,
        playerCountry: 2,
        teamId: 4,
        teamName: 5
      },
      competitionRoundMatches: {
        secondLeg: 4,
        firstLeg: 3,
        team2: 2,
        team1: 1,
        title: 0
      },
      hallOfFame: {
        teamName: 2,
        teamId: 1,
        year: 0,
        point: 3
      },
      drivers: {
        points: 6,
        team: 5,
        teamId: 4,
        driver: 2,
        driverNat: 1,
        driverLastName: 3,
        position: 0
      },
      players: {
        nationality: 1,
        displayName: 4,
        firstName: 3,
        lastName: 2,
        points: 5,
        rank: 0
      },
      constructors: {
        points: 3,
        builder: 2,
        constructorId: 1,
        position: 0
      },
      freePractice: {
        time: 5,
        tid: 3,
        team: 4,
        driver: 2,
        nat: 1,
        pos: 0
      },
      superpole: {
        time: 5,
        tid: 3,
        team: 4,
        driver: 2,
        nat: 1,
        pos: 0
      },
      warmup: {
        time: 5,
        tid: 3,
        team: 4,
        driverLastName: 2,
        driver: 2,
        nat: 1,
        pos: 0
      },
      qualification: {
        Q3: 6,
        Q2: 7,
        Q1: 8,
        driverLastName: 5,
        team: 4,
        tid: 3,
        driver: 2,
        nat: 1,
        pos: 0
      },
      qualification2: {
        time: 6,
        driverLastName: 5,
        team: 4,
        tid: 3,
        driver: 2,
        nat: 1,
        pos: 0
      },
      raceLive: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      sprintraceLive: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      race1Live: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      race_superpoleLive: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      race2Live: {
        pitstops: 9,
        laps: 8,
        status: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1,
        title: 0
      },
      raceEnded: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      sprintraceEnded: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      sprintqualiEnded: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      race1Ended: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      race_superpoleEnded: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      race2Ended: {
        points: 9,
        pitstops: 8,
        time: 7,
        driverLastName: 6,
        team: 5,
        tid: 4,
        driver: 3,
        nat: 2,
        pos: 1
      },
      teams: {
        points: 3,
        team: 2,
        teamId: 1,
        position: 0
      },
      standingTeams: {
        teamOfficialName: 3,
        drawn: 7,
        setsAgainst: 10,
        setsPro: 9,
        matchesLost: 8,
        matchesTotal: 5,
        points: 4,
        rank: 1,
        matchesWon: 6,
        teamId: 2,
        title: 0
      },
      basketStandings: {
        lost: 7,
        pointsConceded: 9,
        pointsScored: 8,
        pointsStanding: 4,
        rank: 1,
        teamId: 2,
        teamName: 3,
        total: 5,
        winPercentage: 10,
        won: 6,
        title: 0
      }
    },
    joinedCols: {
      standingTeams: {
        leftCol: 'setsPro',
        rightCol: 'setsAgainst'
      },
      competitionTeams: {
        leftCol: 'goalsMade',
        rightCol: 'goalsConceded'
      },
      competitionMarkers: {
        leftCol: '',
        rightCol: ''
      },
      squad: {},
      drivers: {},
      constructors: {},
      freePractice: {},
      superpole: {},
      warmup: {},
      qualification: {},
      qualification2: {},
      raceLive: {},
      sprintraceLive: {},
      sprintqualiLive: {},
      race1Live: {},
      race_superpoleLive: {},
      race2Live: {},
      raceEnded: {},
      sprintraceEnded: {},
      sprintqualiEnded: {},
      race1Ended: {},
      race_superpoleEnded: {},
      race2Ended: {},
      players: {},
      basketStandings: {}
    },
    positionMarker: {
      Europa_Cup: {
        League_Position: 'lightRed',
        League_Position_Q1: 'lightPink',
        League_Position_Q2: 'lightPink',
        League_Position_Q3: 'lightPink'
      },
      Champions_League: {
        League_Winners: 'mediumBlue',
        League_Winners_Q1: 'lightBlue',
        League_Winners_Q2: 'lightBlue',
        League_Winners_Q3: 'lightBlue',
        League_Position: 'mediumBlue',
        League_Position_Q1: 'lightBlue',
        League_Position_Q2: 'lightBlue',
        League_Position_Q3: 'lightBlue'
      },
      Relegation: {
        League_Position: 'lightYellow',
        Play_Off: 'mediumGreen',
        Playoff_Relegation: 'mediumGreen'
      },
      Promotion: {
        League_Winners: 'mediumBlue',
        League_Position: 'mediumBlue',
        Play_Off: 'lightRed'
      },
      Champions_League_Qualifying: {
        League_Winners: 'mediumBlue',
        League_Winners_Q1: 'lightBlue',
        League_Winners_Q2: 'lightBlue',
        League_Winners_Q3: 'lightBlue',
        League_Position: 'mediumBlue',
        League_Position_Q1: 'lightBlue',
        League_Position_Q2: 'lightBlue',
        League_Position_Q3: 'lightBlue'
      },
      Conference_League: {
        League_Position: 'lightGreen'
      },
      Conference_League_Qualifying: {
        League_Position: 'lightGreen'
      },
      '8th Finals': {
        League_Position: 'mediumBlue'
      },
      'Play-off': {
        League_Position: 'lightRed'
      }
    },
    skipCols: {
      competitionTeams: {
        colName: ['qualification', 'englishMean', 'form'],
        isMobile: ['qualification', 'englishMean', 'form']
      },
      standingTeams: {
        colName: ['rankTotal', 'lastRank', 'countrycode', 'area', 'team', 'matchesPlayed', 'areaId', 'countryCode', 'zoneStart', 'zoneEnd', 'clubName'],
        isMobile: ['rankTotal', 'lastRank', 'countrycode', 'area', 'team', 'matchesPlayed', 'areaId', 'countryCode', 'zoneStart', 'zoneEnd', 'clubName']
      },
      competitionMarkers: {
        colName: ['playerFirstName', 'playerSecondName', 'playerBirthDate', 'playerKnowName'],
        isMobile: ['teamId', 'playerCountry', 'playerRole', 'playerFirstName', 'playerSecondName', 'playerBirthDate', 'playerKnowName']
      },
      statsInCompetition: {
        colName: ['qualification', 'englishMean', 'form', 'points', 'position', 'startingPosition', 'teamName', 'teamId'],
        isMobile: ['qualification', 'englishMean', 'form', 'points', 'position', 'startingPosition', 'teamName', 'teamId']
      },
      lastMatches: {
        colName: [''],
        isMobile: ['form']
      },
      lastFive: {},
      squad: {
        colName: ['teamId', 'playerBirthDate', 'playerKnownName'],
        isMobile: ['teamId', 'playerBirthDate', 'playerKnownName']
      },
      competitionRoundMatches: {
        colName: ['matchId', 'date', 'liveUpdated', 'status', 'timing'],
        isMobile: ['matchId', 'date', 'liveUpdated', 'status', 'timing']
      },
      hallOfFame: {
        colName: ['sportId', 'competitionId', 'seasonId'],
        isMobile: ['sportId', 'competitionId', 'seasonId']
      },
      drivers: {
        colName: ['driverId', 'driverFirstName', 'shortTeamName', 'victories', 'teamCarBike', 'teamEngine', 'driverLastName', 'driverNumber', 'driverCode', 'teamNat'],
        isMobile: ['driverId', 'driver', 'driverFirstName', 'teamNat', 'team', 'victories', 'teamCarBike', 'teamEngine', 'teamId', 'driverNumber', 'driverCode']
      },
      teams: {
        colName: ['victories', 'teamCarBike', 'teamEngine'],
        isMobile: ['victories', 'teamCarBike', 'teamEngine']
      },
      constructors: {
        colName: ['victories'],
        isMobile: ['victories', 'builder']
      },
      freePractice: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'driverCode', 'cid', 'builder', 'fastInLap', 'fastTime'],
        isMobile: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'driverCode', 'team', 'tid', 'cid', 'builder', 'fastInLap', 'fastTime']
      },
      superpole: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'driverCode', 'cid', 'builder'],
        isMobile: ['didx', 'driverFirstName', 'driver', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'time', 'driverCode', 'tid', 'cid', 'builder']
      },
      warmup: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'driverCode', 'cid', 'builder', 'fastInLap', 'fastTime'],
        isMobile: ['didx', 'driverFirstName', 'driver', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'tid', 'pitstops', 'status', 'driverCode', 'team', 'cid', 'builder', 'fastInLap', 'fastTime']
      },
      qualification: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'time', 'driverCode', 'cid', 'builder', 'fastInLap', 'fastTime'],
        isMobile: ['didx', 'driverFirstName', 'driver', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'time', 'driverCode', 'tid', 'team', 'cid', 'builder', 'fastInLap', 'fastTime']
      },
      qualification2: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'Q1', 'Q2', 'driverCode', 'cid', 'builder', 'fastInLap', 'fastTime'],
        isMobile: ['didx', 'driverFirstName', 'driver', 'stn', 'teamCarbike', 'teamEngine', 'laps', 'pitstops', 'status', 'Q1', 'Q2', 'driverCode', 'tid', 'team', 'cid', 'builder', 'fastInLap', 'fastTime']
      },
      raceLive: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      sprintraceLive: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      sprintqualiLive: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      race1Live: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      race_superpoleLive: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      race2Live: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'lapsGap', 'cid', 'builder'],
        isMobile: ['didx', 'nat', 'driver', 'driverFirstName', 'team', 'time', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'driverCode', 'points', 'tid', 'lapsGap', 'cid', 'builder']
      },
      raceEnded: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      sprintraceEnded: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      sprintqualiEnded: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      race1Ended: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      race_superpoleEnded: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      race2Ended: {
        colName: ['didx', 'driverFirstName', 'driverLastName', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'lapsLed', 'cid', 'builder'],
        isMobile: ['didx', 'driver', 'driverFirstName', 'team', 'stn', 'driverCode', 'teamCarbike', 'teamEngine', 'status', 'lapsGap', 'fastInLap', 'fastTime', 'laps', 'driverCode', 'tid', 'lapsLed', 'cid', 'builder']
      },
      players: {
        colName: ['id', 'initials', 'firstName', 'lastName'],
        isMobile: ['id', 'initials', 'firstName', 'displayName']
      },
      basketStandings: {
        colName: ['gamesBack', 'teamOfficialName', 'teamCode', 'team', 'conferenceWon', 'conferenceLost', 'divisionWon', 'divisionLost'],
        isMobile: ['gamesBack', 'won', 'lost', 'winPercentage', 'teamOfficialName', 'teamCode', 'team', 'conferenceWon', 'conferenceLost', 'divisionWon', 'divisionLost'],
        colName_6: ['gamesBack', 'teamOfficialName', 'teamCode', 'team', 'winPercentage']
      }
    },
    tableTabbar: {
      teamPagePreMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Probabili Formazioni',
        id: 1,
        url: 'probabili-formazioni',
        hide: true
      }, {
        label: 'Formazioni',
        id: 2,
        url: 'formazioni',
        hide: false
      }, {
        label: 'Quote',
        id: 3,
        url: 'quote',
        hide: false
      }, {
        label: 'Statistiche',
        id: 4,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 5,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 6,
        url: 'commenti'
      }],
      teamPage: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'cronaca'
      }, {
        label: 'Sintesi',
        id: 2,
        url: 'sintesi'
      }, {
        label: 'Tabellino',
        id: 3,
        url: 'tabellino'
      }, {
        label: 'Quote',
        id: 4,
        url: 'quote',
        hide: false
      }, {
        label: 'Statistiche',
        id: 5,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 6,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 7,
        url: 'commenti'
      }],
      teamPageFull: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'cronaca'
      }, {
        label: 'Sintesi',
        id: 2,
        url: 'sintesi'
      }, {
        label: 'Vota',
        id: 3,
        url: 'vota'
      }, {
        label: 'Tabellino',
        id: 4,
        url: 'tabellino'
      }, {
        label: 'Quote',
        id: 5,
        url: 'quote',
        hide: false
      }, {
        label: 'Statistiche',
        id: 6,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 7,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 8,
        url: 'commenti'
      }],
      competitionTeams: [{
        label: 'Generale',
        id: 'generalRanking'
      }, {
        label: 'Casa',
        id: 'homeRanking'
      }, {
        label: 'Trasferta',
        id: 'awayRanking'
      }],
      cupstandings: [{
        label: 'Qualificazioni',
        name: 'preliminaries',
        id: 0,
        url: '/qualification'
      }, {
        label: 'Stagione regolare',
        name: 'regularSeason',
        id: 0,
        url: '/regularSeason'
      }, {
        label: 'Fase a gironi',
        name: 'groups',
        id: 1,
        url: '/gironi'
      }, {
        label: 'Girone Unico',
        name: 'championship',
        id: 3,
        url: '/championship'
      }, {
        label: 'Play off',
        name: 'playoffs',
        id: 2,
        url: '/playoff'
      }, {
        label: 'Play out',
        name: 'playout',
        id: 3,
        url: '/playout'
      }],
      4: [{
        label: 'Preliminari',
        name: 'preliminaries',
        id: 0,
        url: '/qualification'
      }, {
        label: 'Gironi',
        name: 'groups',
        id: 1,
        url: '/gironi'
      }, {
        label: 'Fase finale',
        name: 'playoffs',
        id: 2,
        url: '/playoff'
      }],
      standingTeams: [{
        label: 'Generale',
        id: 'generalRanking'
      }, {
        label: 'Casa',
        id: 'homeRanking'
      }, {
        label: 'Trasferta',
        id: 'awayRanking'
      }],
      35: [{
        label: 'Generale',
        id: 'generalRanking'
      }],
      34: [{
        label: 'Generale',
        id: 'generalRanking'
      }],
      realteamPage: [{
        label: 'Notizie',
        id: 'news',
        url: 'news'
      }, {
        label: 'Probabili',
        id: 'lineup',
        url: 'lineup',
        hide: true
      }, {
        label: 'Statistiche',
        id: 'stats',
        url: 'stats'
      }, {
        label: 'Rosa',
        id: 'squad',
        url: 'squad'
      }, {
        label: 'Società',
        id: 'club',
        url: 'club'
      }],
      raceNotStarted: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: false
      }, {
        label: 'Risultati',
        id: 3,
        url: 'risultati'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      raceOnTrack: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: false
      }, {
        label: 'Risultati',
        id: 3,
        url: 'risultati'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      raceFinished: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: false
      }, {
        label: 'Risultati',
        id: 3,
        url: 'risultati'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      racePhases: [{
        label: 'Prove libere',
        id: 0,
        url: '/freePractice'
      }, {
        label: 'Qualifiche',
        id: 1,
        url: '/qualification'
      }, {
        label: 'Gara',
        id: 2,
        url: '/race'
      }],
      raceStandings: [{
        label: 'Piloti',
        id: 0,
        url: '/drivers'
      }, {
        label: 'Costruttori',
        id: 1,
        url: '/constructors'
      }],
      tennisPreMatch: [{
        label: 'Quote',
        id: 0,
        url: 'quote',
        hide: false
      }, {
        label: 'Precedenti',
        id: 1,
        url: 'statistiche'
      }, {
        label: 'Commenta',
        id: 2,
        url: 'commenti'
      }],
      tennisLive: [{
        label: 'Sintesi',
        id: 0,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 1,
        url: 'quote',
        hide: true
      }, {
        label: 'Precedenti',
        id: 2,
        url: 'statistiche'
      }, {
        label: 'Commenta',
        id: 3,
        url: 'commenti'
      }],
      basketLiveMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Classifica',
        id: 2,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 3,
        url: 'commenti'
      }],
      nbaLiveMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Formazioni',
        id: 1,
        url: 'formazioni'
      }, {
        label: 'Tabellino',
        id: 2,
        url: 'tabellino'
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      basketPreMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Classifica',
        id: 1,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 2,
        url: 'commenti'
      }],
      nbaPreMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Formazioni',
        id: 1,
        url: 'formazioni'
      }, {
        label: 'Classifica',
        id: 2,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 3,
        url: 'commenti'
      }],
      basketPostMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Tabellino',
        id: 2,
        url: 'tabellino'
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      nbaPostMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Formazioni',
        id: 1,
        url: 'formazioni'
      }, {
        label: 'Tabellino',
        id: 2,
        url: 'tabellino'
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }]
    },
    tableTabbarCorriere: {
      teamPagePreMatch: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Quote',
        id: 1,
        url: 'quote',
        hide: true
      }, {
        label: 'Formazioni',
        id: 2,
        url: 'formazioni',
        hide: true
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      teamPage: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'cronaca'
      }, {
        label: 'Sintesi',
        id: 2,
        url: 'sintesi'
      }, {
        label: 'Tabellino',
        id: 3,
        url: 'tabellino'
      }, {
        label: 'Quote',
        id: 4,
        url: 'quote',
        hide: true
      }, {
        label: 'Statistiche',
        id: 5,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 6,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 7,
        url: 'commenti'
      }],
      teamPageFull: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'cronaca'
      }, {
        label: 'Sintesi',
        id: 2,
        url: 'sintesi'
      }, {
        label: 'Tabellino',
        id: 3,
        url: 'tabellino'
      }, {
        label: 'Statistiche',
        id: 4,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 5,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 6,
        url: 'commenti'
      }],
      competitionTeams: [{
        label: 'Generale',
        id: 'generalRanking'
      }, {
        label: 'Casa',
        id: 'homeRanking'
      }, {
        label: 'Trasferta',
        id: 'awayRanking'
      }],
      cupstandings: [{
        label: 'Qualificazioni',
        id: 0,
        url: '/qualification'
      }, {
        label: 'Fase a gironi',
        id: 1,
        url: '/gironi'
      }, {
        label: 'Fase a eliminazione diretta',
        id: 2,
        url: '/playoff'
      }],
      4: [{
        label: 'Gironi',
        id: 1,
        url: '/gironi'
      }, {
        label: 'Fase finale',
        id: 2,
        url: '/playoff'
      }],
      realteamPage: [{
        label: 'Notizie',
        id: 'news',
        url: 'news'
      }, {
        label: 'Probabili',
        id: 'lineup',
        url: 'lineup',
        hide: true
      }, {
        label: 'Statistiche',
        id: 'stats',
        url: 'stats'
      }, {
        label: 'Rosa',
        id: 'squad',
        url: 'squad'
      }, {
        label: 'Società',
        id: 'club',
        url: 'club'
      }],
      raceNotStarted: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: true
      }, {
        label: 'Qualifiche',
        id: 3,
        url: 'qualificazioni'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      raceOnTrack: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Quote',
        id: 2,
        url: 'quote',
        hide: true
      }, {
        label: 'Statistiche',
        id: 3,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 4,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 5,
        url: 'commenti'
      }],
      raceFinished: [{
        label: 'Notizie',
        id: 0,
        url: 'notizie'
      }, {
        label: 'Cronaca',
        id: 1,
        url: 'sintesi'
      }, {
        label: 'Statistiche',
        id: 2,
        url: 'statistiche'
      }, {
        label: 'Classifica',
        id: 3,
        url: 'classifica'
      }, {
        label: 'Commenta',
        id: 4,
        url: 'commenti'
      }],
      racePhases: [{
        label: 'Prove libere',
        id: 0,
        url: '/freePractice'
      }, {
        label: 'Qualifiche',
        id: 1,
        url: '/qualification'
      }, {
        label: 'Gara',
        id: 2,
        url: '/race'
      }],
      raceStandings: [{
        label: 'Piloti',
        id: 0,
        url: '/drivers'
      }, {
        label: 'Costruttori',
        id: 1,
        url: '/constructors'
      }]
    }
  },
  widgets: {
    colsPosition: {
      competitionTeams: {
        teamName: 3,
        drawn: 8,
        englishMean: 12,
        form: 13,
        goalsConceded: 11,
        goalsMade: 10,
        lost: 9,
        played: 6,
        points: 5,
        position: 1,
        startingPosition: 4,
        won: 7,
        teamId: 2
      },
      competitionMarkers: {
        goals: 7,
        penalties: 8,
        playerId: 1,
        playerName: 3,
        playerRole: 6,
        playerCountry: 2,
        teamId: 4,
        teamName: 5
      },
      rugbyStandings: {
        teamName: 3,
        drawn: 7,
        lost: 8,
        pointsDiff: 9,
        played: 5,
        points: 4,
        rank: 1,
        won: 6,
        teamId: 2
      }
    },
    joinedCols: {
      competitionTeams: {
        leftCol: 'goalsMade',
        rightCol: 'goalsConceded'
      },
      competitionMarkers: {
        leftCol: '',
        rightCol: ''
      },
      rugbyStandings: [{ leftCol: 'triesBonus', rightCol: 'losingBonus' }, { leftCol: 'triesFor', rightCol: 'triesAgainst' }]
    },
    skipCols: {
      competitionTeams: {
        colName: ['qualification', 'englishMean', 'form', 'goalsMade', 'goalsConceded'],
        isMobile: ['qualification', 'englishMean', 'form', 'goalsMade', 'goalsConceded']
      },
      competitionMarkers: {
        colName: ['teamId', 'playerCountry', 'playerRole', 'playerFirstName', 'playerSecondName', 'playerBirthDate', 'playerKnowName'],
        isMobile: ['teamId', 'playerCountry', 'playerRole', 'playerFirstName', 'playerSecondName', 'playerBirthDate', 'playerKnowName']
      },
      rugbyStandings: {
        colName: ['against', 'bonus', 'for', 'losingBonus', 'triesBonus', 'triesAgainst', 'triesFor'],
        isMobile: ['against', 'bonus', 'for', 'losingBonus', 'triesBonus', 'triesAgainst', 'triesFor']
      }
    },
    positionMarker: {
      Europa_Cup: {
        League_Position: 'lightRed',
        League_Position_Q1: 'lightPink',
        League_Position_Q2: 'lightPink',
        League_Position_Q3: 'lightPink'
      },
      Champions_League: {
        League_Winners: 'mediumBlue',
        League_Winners_Q1: 'lightBlue',
        League_Winners_Q2: 'lightBlue',
        League_Winners_Q3: 'lightBlue',
        League_Position: 'mediumBlue',
        League_Position_Q1: 'lightBlue',
        League_Position_Q2: 'lightBlue',
        League_Position_Q3: 'lightBlue'
      },
      Relegation: {
        League_Position: 'lightYellow',
        Play_Off: 'lightYellow',
        Playoff_Relegation: 'lightYellow'
      },
      Promotion: {
        League_Winners: 'mediumBlue',
        League_Position: 'mediumBlue',
        Play_Off: 'lightRed'
      },
      Champions_League_Qualifying: {
        League_Winners: 'mediumBlue',
        League_Winners_Q1: 'lightBlue',
        League_Winners_Q2: 'lightBlue',
        League_Winners_Q3: 'lightBlue',
        League_Position: 'mediumBlue',
        League_Position_Q1: 'lightBlue',
        League_Position_Q2: 'lightBlue',
        League_Position_Q3: 'lightBlue'
      }
    }
  },
  imageUrls: {
    football: {
      teams: {
        min: 'https://images2.gazzettaobjects.it/assets-mc/calcio/squadre/min/',
        med: 'https://images2.gazzettaobjects.it/assets-mc/calcio/squadre/med/',
        high: 'https://images2.gazzettaobjects.it/assets-mc/calcio/squadre/high/'
      },
      players: 'https://images2.gazzettaobjects.it/assets-mc/calcio/giocatori/'
    },
    volley: {
      teams: {
        min: 'https://images2.gazzettaobjects.it/assets-mc/volley/squadre/min/'
      }
    },
    teams: 'https://images2.gazzettaobjects.it/assets-mc/motori/teams/',
    circuits: 'https://images2.gazzettaobjects.it/assets-mc/motori/circuiti/',
    countriesFlag: 'https://images2.gazzettaobjects.it/assets-mc/countries/med/',
    tennisPlayer: 'https://images2.gazzettaobjects.it/assets-mc/tennis/giocatori/',
    tennisPlayers: {
      min: 'https://images2.gazzettaobjects.it/assets-mc/tennis/giocatori/min/',
      high: 'https://images2.gazzettaobjects.it/assets-mc/tennis/giocatori/high/'
    },
    basket: {
      teams: {
        min: 'https://images2.gazzettaobjects.it/assets-mc/basket/squadre/min/',
        med: 'https://images2.gazzettaobjects.it/assets-mc/basket/squadre/med/',
        high: 'https://images2.gazzettaobjects.it/assets-mc/basket/squadre/high/'
      },
      players: 'https://images2.gazzettaobjects.it/assets-mc/basket/giocatori/'
    },
    rugby: {
      teams: {
        min: 'https://images2.gazzettaobjects.it/assets-mc/rugby/squadre/min/',
        med: 'https://images2.gazzettaobjects.it/assets-mc/rugby/squadre/med/',
        high: 'https://images2.gazzettaobjects.it/assets-mc/rugby/squadre/high/'
      }
    }
  },
  cyclingCustomUrl: {
    /*7101: 'https://www.giroditalia.it/it/',
    90054: 'http://www.tirrenoadriatico.it/',
    90055: 'http://www.milanosanremo.it/',
    90075: 'http://www.ilombardia.it/', */
  }
};

var prettyCyclingCompetitionId = function prettyCyclingCompetitionId() {
  var competizione = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (competizione) {
    var valueKeys = Object.values(configJson.dictionary.it.cyclingCompetitionLink);
    var keys = Object.keys(configJson.dictionary.it.cyclingCompetitionLink);
    if (valueKeys.indexOf(competizione) > -1) {
      var index = valueKeys.indexOf(competizione);
      return keys[index];
    }
  }
  return false;
};

var prettyCyclingCompetitionLabel = function prettyCyclingCompetitionLabel() {
  var competitionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (competitionId && configJson.dictionary.it.cyclingCompetitionLabel[competitionId]) {
    return configJson.dictionary.it.cyclingCompetitionLabel[competitionId];
  }
  return '';
};

var cleanTeamOrNameUrl = function cleanTeamOrNameUrl() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#';
  var joinChar = arguments[1];
  var sportId = arguments[2];

  name = name.toLowerCase().replace(/\s\(-[0-9]{1,3}\)/g, '').replace(/`/g, '').replace(/\//g, '').replace(/\./g, '').replace(/¡/g, 'i').replace(/\(/g, '').replace(/\)/g, '').replace(/\|/g, '').replace(/¢/g, '').replace(/£/g, '').replace(/¤/g, '').replace(/¥/g, '').replace(/¦/g, '').replace(/§/g, '').replace(/¨/g, '').replace(/©/g, '').replace(/ª/g, '').replace(/«/g, '').replace(/¬/g, '').replace(/­/g, '').replace(/¯/g, '').replace(/°/g, '').replace(/²/g, '').replace(/³/g, '').replace(/´/g, '').replace(/µ/g, '').replace(/¶/g, '').replace(/·/g, '').replace(/¸/g, '').replace(/¹/g, '').replace(/º/g, '').replace(/»/g, '').replace(/¼/g, '').replace(/½/g, '').replace(/¾/g, '').replace(/¿/g, '').replace(/À/g, 'a').replace(/Á/g, 'a').replace(/Â/g, 'a').replace(/Ã/g, 'a').replace(/Ä/g, 'a').replace(/Å/g, 'a').replace(/Æ/g, 'a').replace(/Ç/g, 'c').replace(/È/g, 'e').replace(/É/g, 'e').replace(/Ê/g, 'e').replace(/Ë/g, 'e').replace(/Ì/g, 'i').replace(/Í/g, 'i').replace(/Î/g, 'i').replace(/Ï/g, 'i').replace(/Ð/g, 'd').replace(/Ñ/g, 'n').replace(/Ò/g, 'o').replace(/Ó/g, 'o').replace(/Ô/g, 'o').replace(/Õ/g, 'o').replace(/Ö/g, 'o').replace(/×/g, 'x').replace(/Ø/g, '0').replace(/Ù/g, 'u').replace(/Ú/g, 'u').replace(/Û/g, 'u').replace(/Ü/g, 'u').replace(/Ý/g, 'y').replace(/Þ/g, 'p').replace(/ß/g, 'b').replace(/à/g, 'a').replace(/á/g, 'a').replace(/â/g, 'a').replace(/ã/g, 'a').replace(/ä/g, 'a').replace(/å/g, 'a').replace(/æ/g, 'a').replace(/ç/g, 'c').replace(/è/g, 'e').replace(/é/g, 'e').replace(/ê/g, 'e').replace(/ë/g, 'e').replace(/ì/g, 'i').replace(/í/g, 'i').replace(/î/g, 'i').replace(/ï/g, 'i').replace(/ð/g, 'o').replace(/ñ/g, 'n').replace(/ò/g, 'o').replace(/ó/g, 'o').replace(/ô/g, 'o').replace(/õ/g, 'o').replace(/ö/g, 'o').replace(/÷/g, '').replace(/ø/g, 'o').replace(/ù/g, 'u').replace(/ú/g, 'u').replace(/û/g, 'u').replace(/ü/g, 'u').replace(/ý/g, 'y').replace(/þ/g, 'b').replace(/ÿ/g, 'y').replace(/š/g, 's').replace(/ž/g, 'z').replace(/ė/g, 'z').replace(/ū/g, 'u').replace(/'/g, '').split(' ').filter(function (c) {
    return c !== '-' && c !== '';
  }).join(joinChar);

  if (sportId === '12') {
    name = name.replace(/'/g, '-');
  }

  return name;
};

var prettySitePath = function prettySitePath(site) {
  //let pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'dev';
  //const pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var pahtprefix = configJson.urlToUse === 'development' || configJson.urlToUse === 'stag' ? 'dev' : 'www';
  var path = '';
  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }
  return path;
};

var prettyMatchUrl = function prettyMatchUrl(teamHome, teamAway, matchId, sportId, competitionId, site, tennisTournament, seasonLink) {
  var fallbackUrl = false;

  var competitionLink = '';
  var path = prettySitePath(site);
  var prefix = '';
  var postfix = '';
  var url = '';

  if (teamHome) {
    teamHome = cleanTeamOrNameUrl(teamHome, '');
  }

  if (teamAway) {
    teamAway = cleanTeamOrNameUrl(teamAway, '');
  }

  sportId = String(sportId);
  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'partita';
      competitionLink = configJson.dictionary.it.competitionLink[Number(competitionId)];
      if (site === 'corriere' && '' + competitionId === '1277') competitionLink = 'mondiale-per-club-fifa';
      // seasonLink es. "2017-18/"
      if (seasonLink) {
        url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + seasonLink + teamHome + '-' + teamAway + '/' + matchId + '/';
      } else {
        url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + teamHome + '-' + teamAway + '/' + matchId + '/';
      }
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'gran-premio';
      competitionLink = configJson.dictionary.it.raceCompetitionLink[Number(competitionId)];
      if (!teamAway && !teamHome) {
        fallbackUrl = true;
      }
      url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + teamHome + '/' + matchId + '/';
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'partita';
      if (tennisTournament) {
        tennisTournament = cleanTeamOrNameUrl(tennisTournament, '-');
      } else {
        fallbackUrl = true;
      }
      url = '' + path + prefix + '/' + tennisTournament + '/' + postfix + '/' + teamHome + '-' + teamAway + '/' + matchId + '/';
      break;
    case '3':
      prefix = '/basket';
      postfix = 'partita';
      competitionLink = configJson.dictionary.it.basketCompetitionLink[Number(competitionId)];
      url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + teamHome + '-' + teamAway + '/' + matchId + '/';
      break;
    case '5':
      prefix = '/volley';
      postfix = 'partita';
      competitionLink = configJson.dictionary.it.volleyCompetitionLink[Number(competitionId)];
      url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/' + teamHome + '-' + teamAway + '/' + matchId + '/';
      break;
    case '2':
      fallbackUrl = true;
      break;
    default:
      fallbackUrl = true;
      break;
  }
  return !fallbackUrl ? url : '#';
};

var prettyPlayerUrl = function prettyPlayerUrl(playerName, playerId, sportId, site) {
  playerName = cleanTeamOrNameUrl(playerName, '-');

  var competitionLink = '';
  var path = '';
  //let pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'dev';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';
  var url = '';

  sportId = String(sportId);

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'giocatori';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'giocatori';
      break;
    case '18':
      prefix = '/ciclismo';
      postfix = 'ciclisti';
      break;
    case '12':
      prefix = '/sport-invernali';
      postfix = 'atleti';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
    case '8':
    case '12':
      url = '' + path + prefix + '/' + postfix + '/' + playerName + '/' + playerId + '/';
      break;
    case '6M':
    case '6C':
      url = '' + path + prefix + '/' + postfix + '/' + playerName + '-' + sportId + '/' + playerId + '/';
      break;
    default:
      break;
  }

  return url;
};

var prettyTopScorersUrl = function prettyTopScorersUrl(sportId, competitionId, site) {
  var competitionLink = '';
  var path = '';
  //let pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'dev';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';
  var url = '';

  sportId = String(sportId);
  competitionLink = configJson.dictionary.it.competitionLink[Number(competitionId)];
  if (site === 'corriere' && '' + competitionId === '1277') competitionLink = 'mondiale-per-club-fifa';

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'marcatori';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'giocatori';
      break;
    default:
      break;
  }

  url = '' + path + prefix + '/' + competitionLink + '/' + postfix + '/';

  return url;
};

var prettyStandingsUrl = function prettyStandingsUrl(sportId, competitionId, site, isStage) {
  var path = prettySitePath(site);

  var competitionLink = configJson.dictionary.it.competitionLink[Number(competitionId)];
  if (site === 'corriere' && '' + competitionId === '1277') competitionLink = 'mondiale-per-club-fifa';
  var prefix = '';
  var postfix = '';

  sportId = String(sportId);
  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'classifica';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'classifiche';
      competitionLink = configJson.dictionary.it.raceCompetitionLink[competitionId];
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'giocatori';
      break;
    case '18':
      prefix = '/ciclismo';
      postfix = 'classifiche';
      if (isStage) {
        postfix = 'classifica';
      }
      competitionLink = configJson.dictionary.it.cyclingCompetitionLink[Number(competitionId)];
      break;
    case '3':
      prefix = '/basket';
      postfix = 'classifica';
      competitionLink = configJson.dictionary.it.basketCompetitionLink[Number(competitionId)];
      break;
    case '5':
      prefix = '/volley';
      postfix = 'classifiche';
      competitionLink = configJson.dictionary.it.volleyCompetitionLink[Number(competitionId)];
      break;
    case '2':
      prefix = '/rugby';
      postfix = 'classifica';
      competitionLink = configJson.dictionary.it.rugbyCompetitionLink[Number(competitionId)];
      break;
    case '12':
      prefix = '/sport-invernali/sci-alpino';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.skiCompetitionLink[Number(competitionId)];
      break;
    default:
      break;
  }

  return '' + path + prefix + '/' + competitionLink + '/' + postfix + '/';
};

var prettyCalendarUrl = function prettyCalendarUrl(sportId, competitionId, site) {
  if (sportId === '18') {
    var cyclingIds = Object.keys(configJson.cyclingCustomUrl);
    if (cyclingIds.indexOf(competitionId) !== -1) {
      return configJson.cyclingCustomUrl[competitionId];
    }
  }

  var path = prettySitePath(site);
  var competitionLink = configJson.dictionary.it.competitionLink[Number(competitionId)];
  if (site === 'corriere' && '' + competitionId === '1277') competitionLink = 'mondiale-per-club-fifa';
  var prefix = '';
  var postfix = '';

  sportId = String(sportId);
  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'calendario-risultati';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = 'giocatori';
      break;
    case '2':
      prefix = '/rugby';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.rugbyCompetitionLink[Number(competitionId)];
      break;
    case '3':
      prefix = '/basket';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.basketCompetitionLink[Number(competitionId)];
      break;
    case '5':
      prefix = '/volley';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.volleyCompetitionLink[Number(competitionId)];
      break;
    case '12':
      prefix = '/sport-invernali/sci-alpino';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.skiCompetitionLink[Number(competitionId)];
      break;
    case '18':
      prefix = '/ciclismo';
      postfix = 'calendario-risultati';
      competitionLink = configJson.dictionary.it.cyclingCompetitionLink[Number(competitionId)];
      break;
    default:
      break;
  }

  return '' + path + prefix + '/' + competitionLink + '/' + postfix + '/';
};

var prettyTeamUrl = function prettyTeamUrl(sportId, competitionId, site, team) {
  var path = prettySitePath(site);
  var prefix = '';
  var postfix = '';
  var url = '';
  sportId = String(sportId);
  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
        url = '' + path + prefix + '/serie-a/';
      } else {
        prefix = '/calcio';
        postfix = 'squadre';
        var teamClean = cleanTeamOrNameUrl(team, '-');
        url = '' + path + prefix + '/' + postfix + '/' + teamClean.toLowerCase() + '/';
      }
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'scuderie';
      var raceCompetitionLink = configJson.dictionary.it.raceCompetitionLink[Number(competitionId)];
      var teamDashed = cleanTeamOrNameUrl(team, '-');
      url = '' + path + prefix + '/' + postfix + '/' + raceCompetitionLink + '/' + teamDashed + '/';
      break;
    case '8':
      prefix = '/tennis';
      postfix = '';
      var tennisTeam = cleanTeamOrNameUrl(team, '');
      url = '' + path + prefix + '/' + postfix + '/' + tennisTeam.toLowerCase() + '/';
      break;
    default:
      break;
  }
  return url;
};

var prettyLiveHubUrl = function prettyLiveHubUrl(site) {
  var path = '';
  var url = '';
  //let pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'dev';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it/risultati-live/';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport/risultati-live/';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it/competizioni-calcio/risultati-live/';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info/competizioni-calcio/risultati-live/';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it/competizioni-calcio/risultati-live/';
      break;
    default:
      break;
  }

  url = '' + path;

  return url;
};

var prettyCalendarTennisUrl = function prettyCalendarTennisUrl(sportId, competitionId, competitionName, tournamentType, tournamentName, isTable, site) {
  var tournamentTypeLink = '';
  var tournamentLinkName = '';
  var url = '';
  var path = '';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';
  var fallbackUrl = false;

  sportId = String(sportId);
  competitionId = String(competitionId);

  if (tournamentType) {
    tournamentTypeLink = '' + cleanTeamOrNameUrl(configJson.dictionary.it.competitionTable.tennisTournamentType[tournamentType], '-');
  } else {
    fallbackUrl = true;
  }

  if (tournamentName) {
    tournamentLinkName += cleanTeamOrNameUrl(tournamentName, '-') + '-';
  }

  if (competitionName) {
    var competitionReplaceName = competitionName;
    if (configJson.dictionary.it.competitionTable.tennisCompetitionName[competitionName]) {
      competitionReplaceName = configJson.dictionary.it.competitionTable.tennisCompetitionName[competitionName];
    }
    tournamentLinkName += cleanTeamOrNameUrl(competitionReplaceName, '-') + '-';
  }

  if (tournamentLinkName !== '') {
    tournamentLinkName += '' + competitionId;
  } else {
    fallbackUrl = true;
  }

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'calendario-risultati';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = isTable ? 'tabellone' : 'calendario-risultati';
      break;
    default:
      break;
  }

  url = '' + path + prefix + '/' + tournamentTypeLink + '/' + tournamentLinkName + '/' + postfix + '/';

  return !fallbackUrl ? url : '#';
};

var prettySeasonTennisUrl = function prettySeasonTennisUrl(sportId, competitionName, isStanding, site) {
  var competitionId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var standingLink = '';
  var url = '';
  var path = '';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';

  sportId = String(sportId);
  if (!competitionName && competitionId) {
    switch (competitionId) {
      case 12324:
        competitionName = 'Mixed Doubles';break;
      case 12323:
        competitionName = 'Womens Doubles';break;
      case 12321:
        competitionName = 'Mens Doubles';break;
      case 12320:
        competitionName = 'Mens Singles';break;
      case 11047:
        competitionName = 'Womens Singles';break;
      default:
        competitionName = 'Mens Singles';
    }
  }

  switch (competitionName) {
    case 'Mens Singles':
    case 'Mens Doubles':
    case 'Mixed Doubles':
    case 'Mixed Singles':
      standingLink = 'atp';
      break;
    case 'Womens Singles':
    case 'Womens Doubles':
      standingLink = 'wta';
      break;
    case 'davis-cup':
    case 'fed-cup':
      standingLink = competitionName;
      break;
    default:
      standingLink = '';
      break;
  }

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '1':
      if (site === 'fcinter' || site === 'fcinter1908' || site === 'forzaroma' || site === 'calcionapoli1926') {
        prefix = '/competizioni-calcio';
      } else {
        prefix = '/calcio';
      }
      postfix = 'calendario-risultati';
      break;
    case '6C':
    case '6M':
      prefix = '/motori';
      postfix = 'piloti';
      break;
    case '8':
      prefix = '/tennis';
      postfix = isStanding ? 'classifica-singolare' : 'calendario';
      break;
    default:
      break;
  }

  url = '' + path + prefix + '/' + standingLink + '/' + postfix + '/';

  return url;
};

var prettySeasonSkiUrl = function prettySeasonSkiUrl(sportId, competitionSex, eventId, place, competitionType, site) {
  var competitionSexLink = '';
  var competitionTypeLink = '';
  var placeLink = '';
  var url = '';
  var path = '';
  var pahtprefix = configJson.urlToUse === 'production' ? 'www' : 'www';
  var prefix = '';
  var postfix = '';

  sportId = String(sportId);

  placeLink = '' + cleanTeamOrNameUrl(place, '-', sportId);
  competitionTypeLink = '' + cleanTeamOrNameUrl(competitionType, '-');

  switch (site) {
    case 'gazzetta':
      path = 'https://' + pahtprefix + '.gazzetta.it';
      break;
    case 'corriere':
      path = 'https://' + pahtprefix + '.corriere.it/sport';
      break;
    case 'fcinter':
    case 'fcinter1908':
      path = 'https://' + pahtprefix + '.fcinter1908.it';
      break;
    case 'forzaroma':
      path = 'https://' + pahtprefix + '.forzaroma.info';
      break;
    case 'calcionapoli1926':
      path = 'https://' + pahtprefix + '.calcionapoli1926.it';
      break;
    default:
      break;
  }

  switch (sportId) {
    case '12':
      if (site === 'gazzetta') {
        prefix = '/sport-invernali/sci-alpino';
        postfix = 'gara';
      } else {
        postfix = 'gara';
      }
      break;
    default:
      break;
  }

  switch (competitionSex) {
    case 'man':
      if (site === 'gazzetta') {
        if (place === 'Cortina dAmpezzo') {
          competitionSexLink = 'mondiali-sci-maschile';
        } else {
          competitionSexLink = 'coppa-mondo-sci-maschile';
        }
      } else if (site === 'corriere') {
        if (place === 'Cortina dAmpezzo') {
          competitionSexLink = 'mondiali-sci-cortina-2021/classifica-maschile';
        } else {
          competitionSexLink = 'coppa-mondo-sci-maschile';
        }
      }
      break;
    case 'woman':
      if (site === 'gazzetta') {
        if (place === 'Cortina dAmpezzo') {
          competitionSexLink = 'mondiali-sci-femminile';
        } else {
          competitionSexLink = 'coppa-mondo-sci-femminile';
        }
      } else if (site === 'corriere') {
        if (place === 'Cortina dAmpezzo') {
          competitionSexLink = 'mondiali-sci-cortina-2021/classifica-femminile';
        } else {
          competitionSexLink = 'coppa-mondo-sci-femminile';
        }
      }
      break;
    default:
      break;
  }

  url = '' + path + prefix + '/' + competitionSexLink + '/' + postfix + '/' + competitionTypeLink + '-' + eventId + '/' + placeLink + '/';

  return url;
};

var prettyMotorCalendarUrl = function prettyMotorCalendarUrl(sportId, competitionId, site) {
  var path = prettySitePath(site);
  var competitionLink = '';
  var prefix = '/motori';
  var postfix = 'calendario-risultati';

  switch (sportId) {
    case '6C':
    case '6M':
      competitionLink = configJson.dictionary.it.raceCompetitionLink[competitionId];
      break;
    default:
      break;
  }
  return '' + path + prefix + '/' + competitionLink + '/' + postfix + '/';
};

var configFlags = {
  ALB: 'albania',
  AND: 'andorra',
  ARG: 'argentina',
  ARM: 'armenia',
  AUS: 'australia',
  AUT: 'austria',
  AZE: 'azerbaigian',
  BEL: 'belgio',
  BIH: 'bosnia-erzegovina',
  BLR: 'bielorussia',
  BOL: 'bolivia',
  BRA: 'brasile',
  BUL: 'bulgaria',
  CAN: 'canada',
  CHL: 'cile',
  CHN: 'cina',
  CIP: 'cipro',
  CMR: 'camerun',
  COK: 'nuova-zelanda',
  COL: 'colombia',
  COR: 'corea-del-sud',
  CRO: 'croazia',
  CUB: 'cuba',
  CZE: 'repubblica-ceca',
  DNK: 'danimarca',
  ECU: 'ecuador',
  EGI: 'egitto',
  ESP: 'spagna',
  EST: 'estonia',
  FAR: 'isole-far-oer',
  FIN: 'finlandia',
  FRA: 'francia',
  GAL: 'galles',
  GBR: 'inghilterra',
  'GB-ENG': 'inghilterra',
  'GB-SCT': 'scozia',
  GEO: 'georgia',
  GER: 'germania',
  GIB: 'gibilterra',
  GRC: 'grecia',
  HRV: 'croazia',
  HUN: 'ungheria',
  IRL: 'irlanda',
  IRN: 'iran',
  ISL: 'islanda',
  ISR: 'israele',
  ITA: 'italia',
  JAM: 'giamaica',
  JPN: 'giappone',
  KAZ: 'kazakistan',
  KEN: 'kenya',
  KOR: 'sud-corea',
  KOS: 'kosovo',
  LAT: 'lettonia',
  LIE: 'liechtenstein',
  LTU: 'lituania',
  LUX: 'lussemburgo',
  MDA: 'moldavia',
  MKD: 'north-macedonia',
  MLT: 'malta',
  MES: 'messico',
  MNE: 'montenegro',
  NED: 'olanda',
  NGA: 'nigeria',
  NIR: 'irlanda-del-nord',
  NOFLAG: 'no-flag',
  NOR: 'norvegia',
  PER: 'peru',
  POL: 'polonia',
  POR: 'portogallo',
  PRY: 'paraguay',
  QAT: 'qatar',
  ROU: 'romania',
  SPA: 'spagna',
  SRB: 'serbia',
  THL: 'tailandia',
  TUN: 'tunisia',
  PRC: 'porto-rico',
  RUS: 'russia',
  SUI: 'svizzera',
  SVK: 'slovacchia',
  SLO: 'slovenia',
  SAN: 'san-marino',
  SWE: 'svezia',
  THA: 'tailandia',
  TUR: 'turchia',
  UAE: 'emirati-arabi',
  UKR: 'ucraina',
  URY: 'uruguay',
  USA: 'stati-uniti',
  VEN: 'venezuela',
  ZAF: 'sud-africa'
};

var countryCode = (_countryCode = {
  albania: 'ALB',
  andorra: 'AND',
  argentina: 'ARG',
  australia: 'AUS',
  austria: 'AUT',
  azerbaigian: 'AZE',
  belgio: 'BEL',
  belgium: 'BEL',
  'bosnia-erzegovina': 'BIH',
  bielorussia: 'BLR',
  brazil: 'BRA',
  bahrain: 'BRN',
  bulgaria: 'BUL',
  canada: 'CAN',
  croazia: 'CRO',
  'czech-republic': 'CZE',
  cina: 'CHN',
  china: 'CHN',
  cipro: 'CIP',
  spagna: 'ESP',
  spain: 'ESP',
  estonia: 'EST',
  'isole-far-oer': 'FAR',
  finlandia: 'FIN',
  francia: 'FRA',
  france: 'FRA',
  galles: 'GAL',
  georgia: 'GEO',
  inghilterra: 'GBR',
  'united-kingdom': 'GBR',
  'great-britain': 'GBR',
  scozia: 'GB-SCT',
  germania: 'GER',
  germany: 'GER',
  gibilterra: 'GIB',
  grecia: 'GRC',
  ungheria: 'HUN'
}, _defineProperty(_countryCode, 'croazia', 'HVR'), _defineProperty(_countryCode, 'kazakistan', 'KAZ'), _defineProperty(_countryCode, 'irlanda', 'IRL'), _defineProperty(_countryCode, 'islanda', 'ISL'), _defineProperty(_countryCode, 'israele', 'ISR'), _defineProperty(_countryCode, 'italia', 'ITA'), _defineProperty(_countryCode, 'italy', 'ITA'), _defineProperty(_countryCode, 'japan', 'JPN'), _defineProperty(_countryCode, 'kosovo', 'KOS'), _defineProperty(_countryCode, 'lettonia', 'LAT'), _defineProperty(_countryCode, 'liechtenstein', 'LIE'), _defineProperty(_countryCode, 'lituania', 'LTU'), _defineProperty(_countryCode, 'lussemburgo', 'LUX'), _defineProperty(_countryCode, 'moldavia', 'MDA'), _defineProperty(_countryCode, 'malaysia', 'MYS'), _defineProperty(_countryCode, 'mexico', 'MEX'), _defineProperty(_countryCode, 'north-macedonia', 'MKD'), _defineProperty(_countryCode, 'malta', 'MLT'), _defineProperty(_countryCode, 'montenegro', 'MNE'), _defineProperty(_countryCode, 'monaco', 'MON'), _defineProperty(_countryCode, 'netherlands', 'NLD'), _defineProperty(_countryCode, 'olanda', 'NED'), _defineProperty(_countryCode, 'irlanda-del-nord', 'NIR'), _defineProperty(_countryCode, 'polonia', 'POL'), _defineProperty(_countryCode, 'qatar', 'QAT'), _defineProperty(_countryCode, 'russia', 'RUS'), _defineProperty(_countryCode, 'san-marino', 'SAN'), _defineProperty(_countryCode, 'singapore', 'SIN'), _defineProperty(_countryCode, 'svizzera', 'SUI'), _defineProperty(_countryCode, 'slovacchia', 'SVK'), _defineProperty(_countryCode, 'slovenia', 'SLO'), _defineProperty(_countryCode, 'thailand', 'THA'), _defineProperty(_countryCode, 'turchia', 'TUR'), _defineProperty(_countryCode, 'emirati-arabi', 'UAE'), _defineProperty(_countryCode, 'united-arab-emirates', 'UAE'), _defineProperty(_countryCode, 'ucraina', 'UKR'), _defineProperty(_countryCode, 'stati-uniti', 'USA'), _defineProperty(_countryCode, 'usa', 'USA'), _countryCode);

// competitionId impostate 352 - 383 - 408 - 128
var countriesIsoCode = {
  115: 'GB-SCT',
  116: 'IRL',
  117: 'NIR',
  118: 'ESP',
  119: 'ITA',
  357: 'GER',
  358: 'ROU',
  359: 'POR',
  360: 'BEL',
  361: 'SWE',
  362: 'TUR',
  363: 'NOR',
  364: 'SRB',
  365: 'SLO',
  366: 'NED',
  367: 'CZE',
  368: 'FRA',
  495: 'SAN',
  496: 'LUX',
  497: 'SUI',
  498: 'FAR',
  499: 'AND',
  500: 'EST',
  501: 'CIP',
  502: 'BUL',
  503: 'ISL',
  504: 'MKD',
  505: 'AZE',
  506: 'MDA',
  507: 'SVK',
  508: 'GAL',
  509: 'ARM',
  510: 'UKR',
  511: 'POL',
  512: 'BLR',
  513: 'LAT',
  514: 'LIE',
  516: 'ISR',
  517: 'GRC',
  518: 'FIN',
  519: 'LTU',
  520: 'GEO',
  521: 'MLT',
  524: 'GBR',
  534: 'ALB',
  535: 'CRO',
  536: 'RUS',
  537: 'BIH',
  538: 'HUN',
  614: 'BRA',
  632: 'ARG',
  830: 'ECU',
  831: 'CHL',
  832: 'COL',
  833: 'VEN',
  834: 'PER',
  835: 'PRY',
  836: 'BOL',
  837: 'URY',
  1266: 'JPN',
  1846: 'KAZ',
  1873: 'QAT',
  2101: 'POR',
  2104: 'NED',
  2105: 'ITA',
  2106: 'BEL',
  2107: 'CZE',
  2108: 'SRB',
  2109: 'ISR',
  2110: 'SVK',
  2734: 'MNE',
  2821: 'ESP',
  2822: 'CZE',
  3687: 'FIN',
  3688: 'ESP',
  3689: 'GER',
  3690: 'SWE',
  3691: 'BLR',
  4701: 'MNE',
  4779: 'SUI',
  5538: 'GRC',
  6231: 'AUS',
  6232: 'JPN',
  6235: 'NGA',
  6236: 'CAN',
  6238: 'USA',
  6239: 'BRA',
  6241: 'COK',
  6242: 'GBR',
  6243: 'FRA',
  6244: 'GER',
  6245: 'NOR',
  6246: 'SWE',
  6249: 'ISL',
  6250: 'DNK',
  6251: 'UKR',
  6322: 'ARG',
  6324: 'DNK',
  6325: 'CHN',
  6326: 'KOR',
  6330: 'NOR',
  6340: 'NED',
  6328: 'ITA',
  6518: 'AZE',
  6636: 'GB-SCT',
  6637: 'FRA',
  6638: 'LAT',
  6640: 'ROU',
  6641: 'KAZ',
  6812: 'SUI',
  6813: 'FIN',
  6955: 'ZAF',
  6957: 'CMR',
  7206: 'LIE',
  7211: 'IRL',
  7541: 'NIR',
  7648: 'ISL',
  7649: 'ESP',
  7696: 'RUS',
  7699: 'AUT',
  8880: 'GB-SCT',
  9069: 'ALB',
  9070: 'AND',
  9071: 'ARM',
  9072: 'BIH',
  9076: 'BUL',
  9078: 'HRV',
  9080: 'CIP',
  9081: 'EST',
  9082: 'FAR',
  9083: 'MKD',
  9084: 'GEO',
  9086: 'LTU',
  9087: 'LUX',
  9088: 'MLT',
  9089: 'MDA',
  9090: 'POL',
  9091: 'SAN',
  9093: 'TUR',
  9094: 'GAL',
  9180: 'NIR',
  9186: 'AUT',
  9493: 'GIB',
  9196: 'BEL',
  9197: 'POR',
  10330: 'THA',
  10655: 'ITA',
  10862: 'FRA',
  11658: 'KOS',
  11720: 'POR',
  12501: 'NOR',
  12587: 'KOS',
  12592: 'GIB',
  12674: 'CHL',
  14729: 'JAM',
  14774: 'ARM',
  15739: 'IRL'
};

var imageRacingMap = (_imageRacingMap = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  8: 8,
  14: 3,
  15: 15,
  17: 4,
  18: 8,
  19: 19,
  20: 20,
  21: 5,
  22: 22,
  24: 4,
  28: 8,
  29: 5,
  30: 8,
  33: 8,
  36: 5,
  37: 2,
  39: 22,
  46: 15,
  52: 20,
  53: 20,
  61: 61,
  79: 22,
  101: 19,
  102: 781,
  103: 20,
  104: 22,
  161: 5,
  162: 22,
  331: 331,
  501: 501,
  4161: 8,
  9271: 22,
  9321: 8,
  9341: 5,
  9751: 2,
  10021: 5,
  10301: 3,
  10311: 761,
  10371: 331,
  10381: 20,
  10411: 5,
  10421: 8,
  10461: 20,
  10531: 2,
  10541: 2,
  10551: 8,
  10561: 811,
  10571: 5,
  10581: 22,
  10591: 22,
  10761: 20,
  11091: 20,
  11101: 22,
  1781: 2,
  2681: 20,
  2741: 20,
  2751: 20,
  2761: 2,
  2801: 5,
  2911: 20,
  2941: 5,
  2961: 20,
  3821: 5,
  3961: 5,
  4011: 331,
  4141: 22,
  4301: 4,
  4351: 22,
  4791: 6,
  4821: 4,
  4911: 1,
  4921: 5,
  4941: 20,
  4971: 5,
  5001: 22,
  5011: 5,
  5341: 20,
  5511: 20,
  5641: 501,
  5861: 1,
  6241: 22,
  6271: 781,
  6281: 20,
  6311: 5,
  6481: 8,
  6861: 22,
  6881: 5,
  6901: 4,
  7051: 2,
  7061: 2,
  7071: 20,
  7081: 20,
  7121: 5,
  7521: 22,
  7691: 5,
  7931: 5,
  7941: 5,
  8111: 8,
  8121: 5,
  8171: 20,
  8181: 20,
  8191: 22,
  8201: 22,
  8211: 22,
  8351: 4,
  8471: 20,
  8551: 6,
  8561: 4,
  8571: 8,
  8581: 6,
  9191: 8,
  9201: 22,
  9231: 20,
  9241: 22,
  9251: 5,
  9261: 5,
  9281: 5,
  9291: 431,
  9331: 2
}, _defineProperty(_imageRacingMap, '9341', 5), _defineProperty(_imageRacingMap, 9471, 20), _defineProperty(_imageRacingMap, 9481, 2), _defineProperty(_imageRacingMap, 9491, 8), _defineProperty(_imageRacingMap, 9511, 1), _defineProperty(_imageRacingMap, 9781, 8), _defineProperty(_imageRacingMap, 10001, 22), _defineProperty(_imageRacingMap, 10041, 22), _defineProperty(_imageRacingMap, 10161, 22), _defineProperty(_imageRacingMap, 10171, 8), _defineProperty(_imageRacingMap, 10271, 22), _defineProperty(_imageRacingMap, 10281, 22), _defineProperty(_imageRacingMap, 10241, 4), _defineProperty(_imageRacingMap, 10361, 2), _defineProperty(_imageRacingMap, 10751, 2), _defineProperty(_imageRacingMap, 11761, 2), _defineProperty(_imageRacingMap, 11621, 1), _defineProperty(_imageRacingMap, 8931, 5), _defineProperty(_imageRacingMap, 11771, 22), _defineProperty(_imageRacingMap, 11781, 781), _defineProperty(_imageRacingMap, 11631, 781), _defineProperty(_imageRacingMap, 11871, 781), _defineProperty(_imageRacingMap, 7611, 1071), _defineProperty(_imageRacingMap, 11641, 5), _defineProperty(_imageRacingMap, 11921, 5), _imageRacingMap);

var getVolleyTeamImagePath = function getVolleyTeamImagePath(imagesURL, team, competitionId) {
  var path = '' + imagesURL;
  var findLogo = false;
  var localTeamCode = false;
  if (typeof team.toJS === 'function') {
    team = team.toJS();
  }
  if (team.logoTeamId) {
    var _team = team,
        logoTeamId = _team.logoTeamId;

    if (!isVolleyCup(competitionId)) {
      findLogo = logoTeamId;
    }
    if (countriesIsoCode[logoTeamId]) {
      localTeamCode = countriesIsoCode[logoTeamId];
    }
  }
  if (localTeamCode === false && team.teamCode) {
    localTeamCode = team.teamCode;
  }
  if (localTeamCode && configFlags[localTeamCode] && findLogo === false) {
    findLogo = configFlags[localTeamCode];
  }
  if (findLogo) {
    path += findLogo + '.png';
  } else {
    return false;
  }
  return path;
};

var getFootballTeamImagePath = function getFootballTeamImagePath(imagesURL, team) {
  var path = '' + imagesURL;
  if (typeof team.toJS === 'function') {
    team = team.toJS();
  }
  if (!teamHasLink(team.teamName)) {
    return '';
  }
  var _team2 = team,
      teamId = _team2.teamId;

  if (String(teamId) === '000000' && team.teamName) {
    var teamName = cleanTeamOrNameUrl(team.teamName, '-');
    path += teamName + '.png';
  } else if (countriesIsoCode[team.teamId]) {
    var teamCode = countriesIsoCode[team.teamId];
    if (configFlags[teamCode]) {
      path += configFlags[teamCode] + '.png';
    }
  } else {
    path += team.teamId + '.png';
  }
  return path;
};

var configCompetitions = {
  1: {
    3: {
      showSmallStandings: true, isSingleMatch: true, competitionRoundLink: true, teamsLink: true, footballCup: true, onlyFirstLeg: true, showMatchQuote: true
    },
    4: {
      teamsLink: true, footballCup: true, isSingleMatch: true, showMatchQuote: true
    },
    5: {
      showSmallStandings: true, isSingleMatch: true, teamsLink: true, footballCup: true, showMatchQuote: true, hidePlayOffTabStanding: false
    },
    6: {
      showSmallStandings: true, isSingleMatch: true, teamsLink: true, footballCup: true, showMatchQuote: true, hidePlayOffTabStanding: false, onlyFirstLeg: false
    },
    1125: {
      showSmallStandings: true, isSingleMatch: true, teamsLink: true, footballCup: true, showMatchQuote: false, hidePlayOffTabStanding: false
    },
    8: {
      teamsLink: true, showMatchQuote: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    21: {
      showSmallStandings: true, isSingleMatch: true, teamsLink: true, showMatchQuote: true, showMatchVotation: false
    },
    22: {
      teamsLink: true, showMatchQuote: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    23: {
      teamsLink: true, showMatchQuote: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    24: {
      teamsLink: true, showMatchQuote: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    105: { showSmallStandings: true, isSingleMatch: true, teamsLink: true },
    112: { teamsLink: true },
    128: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true
    },
    173: { teamsLink: true, onlyFirstLeg: true, footballCup: true },
    174: { teamsLink: true },
    259: {
      competitionRoundLink: true, teamsLink: true, footballCup: true, hideStandingLink: true
    },
    335: {
      showSmallStandings: false, isSingleMatch: true, onlyFirstLeg: true, footballCup: true, hideStandingLink: true
    },
    1277: {
      teamsLink: true, showSmallStandings: false, isSingleMatch: true, onlyFirstLeg: true, footballCup: true, hideMatchStatistics: true
    },
    352: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true
    },
    383: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true
    },
    408: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true
    },
    616: {
      showSmallStandings: true, isSingleMatch: true, onlyFirstLeg: true, competitionRoundLink: true, footballCup: true, hideLiveLink: true
    },
    941: {
      competitionRoundLink: true, teamsLink: true, footballCup: true, onlyFirstLeg: true, isSingleMatch: true, showSmallStandings: true
    }
  },
  3: {
    1: {
      teamsLink: true, hideMatchStatistics: true, hideMatchCommentary: true, hideMatchSynthesis: true
    },
    2: { teamsLink: false },
    3: { teamsLink: true },
    6: { basketCup: true, teamsLink: true, hideStandingSwitchHomeAway: true },
    7: { basketCup: true, teamsLink: true, hideStandingSwitchHomeAway: true }
  },
  5: {
    34: { volleyCup: true },
    35: { volleyCup: true },
    53: { volleyCup: true },
    54: { volleyCup: true }
  },
  '6C': {
    1: { showMatchQuote: true }
  },
  '6M': {
    2: { showMatchQuote: true },
    3: { showMatchQuote: true },
    4: { showMatchQuote: true },
    5: { showMatchQuote: true }
  },
  8: {
    3: { showMatchQuote: true },
    10148: { showMatchQuote: true },
    10025: { showMatchQuote: true },
    10149: { showMatchQuote: true },
    10026: { showMatchQuote: true },
    10147: { showMatchQuote: true },
    10199: { showMatchQuote: true },
    10069: { showMatchQuote: true },
    10200: { showMatchQuote: true },
    10070: { showMatchQuote: true },
    10198: { showMatchQuote: true },
    10214: { showMatchQuote: true },
    10089: { showMatchQuote: true },
    10215: { showMatchQuote: true },
    10090: { showMatchQuote: true },
    10213: { showMatchQuote: true },
    10243: { showMatchQuote: true },
    10135: { showMatchQuote: true },
    10244: { showMatchQuote: true },
    10136: { showMatchQuote: true },
    10242: { showMatchQuote: true },
    10222: { showMatchQuote: true },
    10228: { showMatchQuote: true },
    10117: { showMatchQuote: true }
  }
};

var lowerCaseFirstLetter = function lowerCaseFirstLetter(value) {
  return '' + value.charAt(0).toLowerCase() + value.slice(1);
};

var hasParam = function hasParam(sportId, competitionId, param) {
  if (configCompetitions[sportId] && configCompetitions[String(sportId)][String(competitionId)]) {
    if (param.indexOf('is') === 0) {
      param = param.substring(2, param.length);
    }
    param = lowerCaseFirstLetter(param);
    var configCompetition = configCompetitions[String(sportId)][String(competitionId)];
    if (configCompetition[param] && configCompetition[param] === true) {
      return true;
    }
  }
  return false;
};

var isHideStandingSwitchHomeAway = function isHideStandingSwitchHomeAway(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isHideStandingSwitchHomeAway');
};

var isFootballCup = function isFootballCup(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isFootballCup');
};

var isBasketCup = function isBasketCup(competitionId) {
  return hasParam('3', competitionId, 'isBasketCup');
};

var isVolleyCup = function isVolleyCup(competitionId) {
  return hasParam('5', competitionId, 'isVolleyCup');
};

var isOnlyFirstLeg = function isOnlyFirstLeg(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isOnlyFirstLeg');
};

var isCompetitionRoundLink = function isCompetitionRoundLink(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isCompetitionRoundLink');
};

var isHideStandingLink = function isHideStandingLink(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isHideStandingLink');
};

var isHideLiveLink = function isHideLiveLink(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'isHideLiveLink');
};

var showMatchQuote = function showMatchQuote(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'showMatchQuote');
};

var hidePlayOffTabStanding = function hidePlayOffTabStanding(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'hidePlayOffTabStanding');
};

var showMatchVotation = function showMatchVotation(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'showMatchVotation');
};

var hideMatchStatistics = function hideMatchStatistics(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'hideMatchStatistics');
};

var hideMatchCommentary = function hideMatchCommentary(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'hideMatchCommentary');
};

var hideMatchSynthesis = function hideMatchSynthesis(sportId, competitionId) {
  return hasParam(sportId, competitionId, 'hideMatchSynthesis');
};

var teamHasLink = function teamHasLink(teamName, sportId, competitionId) {
  if (!sportId || !competitionId) return true;
  if (sportId && competitionId && !hasParam(sportId, competitionId, 'isTeamsLink')) {
    return false;
  }
  var excludeTeam = ['TBC', 'Perdente 2° Turno 1', 'Perdente 2° Turno 2', 'Perdente Semifinale 1', 'Perdente Semifinale 2', 'Vincitrice Semifinale 1', 'Vincitrice Semifinale 2'];
  if (!teamName || excludeTeam.includes(teamName) || teamName.toLowerCase().indexOf('group') > -1 || teamName.toLowerCase().indexOf('finalist') > -1 || teamName.toLowerCase().indexOf('vincit') > -1 || teamName.toLowerCase().indexOf('vincent') > -1 || teamName.toLowerCase().indexOf('vincent') > -1 || teamName.toLowerCase().indexOf('classificat') > -1 || teamName.toLowerCase().indexOf('girone') > -1 || teamName.toLowerCase().indexOf('gironi') > -1 || teamName.toLowerCase().indexOf('winner') > -1 || teamName.toLowerCase().indexOf('assegnat') > -1 || teamName.toLowerCase().indexOf('loser') > -1) {
    return false;
  }
  return true;
};

var teamNameLabel = function teamNameLabel(teamName) {
  if (teamHasLink(teamName)) {
    return teamName;
  }
  return '- -';
};

var subPhaseLabel = function subPhaseLabel(index, dictionary, sportId, competitionId) {
  var isFrontend = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var newIndex = index + '_' + sportId + '_' + competitionId;
  if (!dictionary[newIndex]) {
    newIndex = index + '_' + sportId;
  }
  if (!dictionary[newIndex]) {
    newIndex = '' + index;
  }

  var label = index;
  if (dictionary[newIndex]) {
    label = dictionary[newIndex];
  }

  if (isFrontend) {
    label = label.replace('&deg;', '°');
  }

  return label;
};

var parseCompetitionName = function parseCompetitionName(competitionName, competitionId, dictionary) {
  var isFrontend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var label = '';
  if (dictionary[competitionId]) {
    label = dictionary[competitionId];
  }

  if (isFrontend) {
    label = label.replace('&deg;', '°');
  }

  return label;
};

var isPlayoffs = function isPlayoffs(phase) {
  if (phase && phase.toLowerCase().indexOf('playoff') > -1) {
    return true;
  }
  return false;
};

var getLegendaElements = function getLegendaElements(sportId, competitionId) {
  var isEuropeanCup = String(sportId) === '1' && (String(competitionId) === '5' || String(competitionId) === '6' || String(competitionId) === '1125');
  var elements = [{ bgColor: 'mediumBlue', label: 'Champions League' }, { bgColor: 'lightBlue', label: 'Preliminari C. League' }, { bgColor: 'lightRed', label: 'Europa League' }, { bgColor: 'lightPink', label: 'Preliminari E. League' }, { bgColor: 'lightGreen', label: 'Conference League' }, { bgColor: 'lightYellow', label: 'Retrocesse' }];
  if (String(sportId) === '1' && String(competitionId) === '105') {
    elements = [{ bgColor: 'mediumBlue', label: 'Promosse' }, { bgColor: 'lightRed', label: 'Playoff' }, { bgColor: 'mediumGreen', label: 'Playout' }, { bgColor: 'lightYellow', label: 'Retrocesse' }];
  }
  if (String(sportId) === '3' && String(competitionId) === '3') {
    elements = [{ bgColor: 'mediumBlue', label: 'Prime' }, { bgColor: 'lightRed', label: 'Prime' }, { bgColor: 'lightBlue', label: 'Qualificata ai Playoff' }, { bgColor: 'lightYellow', label: 'Eliminata dai Playoff' }];
  }
  if (isEuropeanCup) {
    elements = [{ bgColor: 'mediumBlue', label: 'Agli ottavi' }, { bgColor: 'lightRed', label: 'Ai playoff' }];
  }
  return elements;
};

var getClinchStatusColor = function getClinchStatusColor(clinchStatus) {
  var clinches = {
    3: 'mediumBlue',
    2: 'lightRed',
    1: 'lightBlue',
    0: '',
    '-1': 'lightYellow'
  };
  if (clinchStatus) {
    if (clinchStatus === 'ALL') {
      return clinches;
    } else if (clinches[clinchStatus]) {
      return clinches[clinchStatus];
    }
  }
  return '';
};

var buildBasketData = function buildBasketData(data, phase) {
  var findBasketKey = function findBasketKey(value, outerGroups) {
    var ret = [];
    outerGroups.forEach(function (arr, j) {
      arr.forEach(function (v, k) {
        if (Array.isArray(v)) {
          v.forEach(function (val, y) {
            if (val === value) {
              ret = [j, k, y];
            }
          });
        } else if (v === value) {
          ret = [j, k];
        }
      });
    });
    return ret;
  };
  data.phaseRequest = phase;
  var isNba = String(data.competitionId) === '3';
  if (!data.competitionId) {
    return data;
  }
  if (String(data.competitionId) === '6' && String(phase) === '1' || String(data.competitionId) === '7' && String(phase) === '1' || String(data.competitionId) === '1' && String(phase) !== '2' || String(data.competitionId) === '2' && String(phase) !== '2' || String(data.competitionId) === '3' && String(phase) !== '3') {
    return data;
  }

  var phases = [];
  var firstPhase = { western: [[1, 8], [4, 5], [3, 6], [2, 7]], eastern: [[1, 8], [4, 5], [3, 6], [2, 7]] };
  var groupMaps = {
    2: [[1, 4], [5, 8], [3, 2], [7, 6]], //[A1, B2], [C1, D2], [B1, A2], [D1, C2]
    4: [[1, 8], [6, 3], [5, 4], [2, 7]], //[A1, B4], [B2, A3], [B1, A4], [A2, B3]
    8: [[1, 8], [4, 5], [3, 6], [2, 7]] //Playoff Regular Season
  };
  var tabellone = {};
  var tabelloneGroups = [];

  var isGroups = null;

  var prepareGroupTabellone = function prepareGroupTabellone(x) {
    if (tabelloneGroups.length === 0) {
      var t = [];
      var maxRank = x.maxRank,
          groupsCount = x.groupsCount,
          competitionRoundIds = x.competitionRoundIds;

      if (groupsCount) {
        var letters = competitionRoundIds || ['A', 'B', 'C', 'D'];
        var letterIndex = 0;
        var j = 0;
        var innerT = [];
        while (letterIndex < groupsCount) {
          if (j % 8 === 0) {
            innerT = [];
          }
          for (var i = 1; i <= maxRank; i += 1) {
            var label = '' + letters[letterIndex] + i;
            innerT.push(label);
            j += 1;
          }
          letterIndex += 1;
          if (j % 8 === 0) {
            t.push(innerT);
          }
        }
        t.forEach(function (inT) {
          var tab = [];
          inT.forEach(function (v, i) {
            var index = i + 1;
            var tabKey = findBasketKey(index, groupMaps[maxRank]);
            if (tabKey.length > 0) {
              if (typeof tab[tabKey[0]] === 'undefined') {
                tab[tabKey[0]] = [];
              }
              tab[tabKey[0]][tabKey[1]] = v;
            }
          });
          tabelloneGroups.push(tab);
        });
      } else if (maxRank) {
        var tab = [];
        for (var _i = 1; _i <= maxRank; _i += 1) {
          var tabKey = findBasketKey(_i, groupMaps[maxRank]);
          if (tabKey.length > 0) {
            if (typeof tab[tabKey[0]] === 'undefined') {
              tab[tabKey[0]] = [];
            }
            tab[tabKey[0]][tabKey[1]] = _i;
          }
        }
        tabelloneGroups.push(tab);
      }
    }
  };

  var reduceGroups = function reduceGroups() {
    var ret = [];
    var x = 0;
    if (tabelloneGroups.length > 0 && !isNba) {
      tabelloneGroups.forEach(function (k) {
        k.forEach(function (y) {
          if (Array.isArray(y)) {
            y.forEach(function (v) {
              if (typeof ret[x] === 'undefined') {
                ret[x] = [];
              }
              ret[x].push(v);
              if (ret[x].length >= 4) {
                x += 1;
              }
            });
          } else {
            if (typeof ret[x] === 'undefined') {
              ret[x] = [];
            }
            ret[x].push(y);
            if (ret[x].length >= 4) {
              x += 1;
            }
          }
        });
      });
    } else {
      Object.keys(firstPhase).forEach(function (conference) {
        if (tabellone[conference]) {
          tabellone[conference].forEach(function (arr) {
            arr.forEach(function (v) {
              if (typeof ret[x] === 'undefined') {
                ret[x] = [];
              }
              ret[x].push(v);
              if (ret[x].length >= 4) {
                x += 1;
              }
            });
          });
        }
      });
    }
    return ret;
  };

  var outerGroups = [];

  var setKey = function setKey(team, conference) {
    if (conference !== null) {
      var tabKey = findBasketKey(team.rank, firstPhase[conference]);
      if (tabKey.length > 0) {
        if (typeof tabellone[conference] === 'undefined') {
          tabellone[conference] = [];
        }
        if (typeof tabellone[conference][tabKey[0]] === 'undefined') {
          tabellone[conference][tabKey[0]] = [];
        }
        tabellone[conference][tabKey[0]][tabKey[1]] = team.teamId;
      }
    } else {
      var k = isGroups ? '' + team.competitionRoundId + team.rank : team.rank;
      var tabKe = findBasketKey(k, tabelloneGroups);
      if (tabKe.length === 3) {
        tabelloneGroups[tabKe[0]][tabKe[1]][tabKe[2]] = team.teamId;
      } else if (tabKe.length > 0) {
        tabelloneGroups[tabKe[0]][tabKe[1]] = team.teamId;
      }
    }
  };

  var findBasketKeyByRank = function findBasketKeyByRank(team, conference) {
    var ret = 0;
    if (conference !== null) {
      var tabKey = findBasketKey(team.rank, firstPhase[conference]);
      if (tabKey) {
        var _tabKey = _slicedToArray(tabKey, 1);

        ret = _tabKey[0];

        if (Object.keys(firstPhase).indexOf(conference) > 0 && isNba) {
          ret += 4;
        }
      }
    } else {
      var tabKe = findBasketKey(team.teamId, tabelloneGroups);

      var _tabKe = _slicedToArray(tabKe, 2),
          dec = _tabKe[0],
          unit = _tabKe[1];

      ret = dec * 4 + unit;
    }
    return ret;
  };

  var getTotalScore = function getTotalScore(team) {
    if (team.scores && team.scores.total) {
      return team.scores.total;
    }
    return '';
  };

  var excludeSubPhase = function excludeSubPhase(sPh) {
    var excludedSubPhase = ['3rd', '5th', '7th', 'play-in-tournament'];
    var ret = true;
    excludedSubPhase.forEach(function (val) {
      if (sPh.roundName.indexOf(val) > -1) {
        ret = false;
      }
    });
    return ret;
  };
  data.contents.reverse().filter(function (r) {
    return excludeSubPhase(r);
  }).forEach(function (x) {
    if (isNba || tabelloneGroups.length > 0 || x.maxRank && x.maxRank > 0 && groupMaps[x.maxRank]) {
      var partite = [];
      var keys = [];
      var groups = [];
      if (!isNba) {
        prepareGroupTabellone(x);
      }
      if (isGroups === null) {
        isGroups = !!x.isGroups;
      }
      x.games.forEach(function (game) {
        /* ++++++++++++++++++++++++++  GAME  ++++++++++++++++++++++++++ */
        var findTeam = null;
        if (keys.indexOf(game.teamHome.teamId) > -1) {
          findTeam = game.teamHome;
        } else if (keys.indexOf(game.teamAway.teamId) > -1) {
          findTeam = game.teamAway;
        } else {
          keys.push(game.teamHome.teamId);
          findTeam = game.teamHome;
        }
        var key = void 0;

        var westernTeamCodes = ['LAL', // Los Angeles Lakers
        'DEN', // Denver Nuggets
        'HOU', // Houston Rockets
        'LAC', // Los Angeles Clippers,
        'DAL', // Dallas Mavericks
        'UTA', // Utah Jazz
        'OKC', // Oklahoma City Thunder
        'POR', // Portland Trail Blazers
        'GSW', // Golden State Warriors
        'MIN', // Minnesota Timberwolves
        'MEM', // Memphis Grizzlies
        'NOP', // New Orleans Pelicans
        'PHX', // Phoenix Suns
        'SAS', // San Antonio Spurs
        'SAC'];

        var easternTeamCodes = ['MIL', // Milwaukee Bucks
        'BOS', // Boston Celtics
        'IND', // Indiana Pacers
        'TOR', // Toronto Raptors
        'ORL', // Orlando Magic
        'BKN', // Brooklyn Nets
        'PHI', // Philadelphia 76ers
        'MIA', // Miami Heat
        'ATL', // Atlanta Hawks
        'CHI', // Chicago Bulls
        'CHA', // Charlotte Hornets
        'CLE', // Cleveland Cavaliers
        'NYK', // New York Knicks
        'DET', // Detroit Pistons
        'WAS'];

        if (game.competition.subphase.indexOf('western') > -1 || game.competition.coast === 'western' || westernTeamCodes.indexOf(findTeam.teamCode) > -1) {
          game.conference = 'western';
        } else if (game.competition.subphase.indexOf('eastern') > -1 || game.competition.coast === 'eastern' || easternTeamCodes.indexOf(findTeam.teamCode) > -1) {
          game.conference = 'eastern';
        }
        var innerKey = 0;
        var isInverted = void 0;
        var isInvertedGr = void 0;
        if (outerGroups.length > 0) {
          if (findTeam.teamId) {
            var _findBasketKey = findBasketKey(findTeam.teamId, outerGroups);

            var _findBasketKey2 = _slicedToArray(_findBasketKey, 2);

            key = _findBasketKey2[0];
            innerKey = _findBasketKey2[1];

            var k = key % 2 === 0 ? key : key - 1;
            k /= 2;
            isInverted = innerKey >= outerGroups[0].length / 2;
            isInvertedGr = key % 2 !== 0;
            if (typeof groups[k] === 'undefined') {
              groups[k] = [];
            }
            if (groups[k].indexOf(game.teamHome.teamId) < 0 && groups[k].indexOf(game.teamAway.teamId) < 0) {
              var teamA = isInverted ? game.teamAway.teamId : game.teamHome.teamId;
              var teamB = isInverted ? game.teamHome.teamId : game.teamAway.teamId;
              if (isInvertedGr && x.games.length > 1) {
                if (groups[k].length === 0) {
                  groups[k] = [0, 0, teamA, teamB];
                } else {
                  groups[k] = [groups[k][0], groups[k][1], teamA, teamB];
                }
              } else {
                groups[k][0] = teamA;
                groups[k][1] = teamB;
              }
            }
          }
        } else {
          if (groups.indexOf(game.teamHome.teamId) < 0) {
            groups.push(game.teamHome.teamId);
          }
          if (groups.indexOf(game.teamAway.teamId) < 0) {
            groups.push(game.teamAway.teamId);
          }
          if (game.competition.subphase.indexOf('western') > -1 || game.competition.coast === 'western' || westernTeamCodes.indexOf(findTeam.teamCode) > -1) {
            setKey(game.teamHome, 'western');
            setKey(game.teamAway, 'western');
            key = findBasketKeyByRank(findTeam, 'western');
          } else if (game.competition.subphase.indexOf('eastern') > -1 || game.competition.coast === 'eastern' || easternTeamCodes.indexOf(findTeam.teamCode) > -1) {
            setKey(game.teamHome, 'eastern');
            setKey(game.teamAway, 'eastern');
            key = findBasketKeyByRank(findTeam, 'eastern');
          } else {
            setKey(game.teamHome, null);
            setKey(game.teamAway, null);
            key = findBasketKeyByRank(findTeam, null);
          }
        }
        game.homeTeam = Object.assign({}, game.teamHome, { teamName: game.teamHome.name, score: getTotalScore(game.teamHome) });
        delete game.homeTeam.scores;
        delete game.homeTeam.rank;
        game.awayTeam = Object.assign({}, game.teamAway, { teamName: game.teamAway.name, score: getTotalScore(game.teamAway) });
        delete game.awayTeam.scores;
        delete game.awayTeam.rank;
        if (getTotalScore(game.teamHome) && getTotalScore(game.teamAway) && game.status === 'PLAYED') {
          if (Number(getTotalScore(game.teamHome)) > Number(getTotalScore(game.teamAway))) {
            game.matchDetails = { winId: game.teamHome.teamId, lostId: game.teamAway.teamId };
          } else {
            game.matchDetails = { winId: game.teamAway.teamId, lostId: game.teamHome.teamId };
          }
        }
        if (!game.matchDetails || game.status !== 'PLAYED') {
          game.matchDetails = { winId: 0, lostId: 0 };
        }
        if (game.utcDate) {
          game.dateUtc = game.utcDate;
        }
        if (game.status.toLowerCase() === 'played') {
          game.isEnded = true;
        } else {
          game.isEnded = false;
        }
        isInverted = outerGroups.length > 0 && innerKey >= outerGroups[0].length / 2;
        if (typeof key === 'undefined') {
          key = partite.length;
        }
        if (typeof partite[key] === 'undefined') {
          partite[key] = {
            homeTeam: Object.assign({}, isInverted ? game.awayTeam : game.homeTeam, { score: 0 }),
            awayTeam: Object.assign({}, isInverted ? game.homeTeam : game.awayTeam, { score: 0 }),
            matches: [],
            isFiniscedSerie: false
          };
        }
        partite[key].matches.push(game);
        if (game.matchDetails.winId && partite[key].homeTeam.teamId === game.matchDetails.winId) {
          partite[key].homeTeam.score += 1;
        }
        if (game.matchDetails.winId && partite[key].awayTeam.teamId === game.matchDetails.winId) {
          partite[key].awayTeam.score += 1;
        }
      }); /* ++++++++++++++++++++++++++  FINE GAME  ++++++++++++++++++++++++++ */
      for (var i = 0; i < groups.length; i += 1) {
        if (typeof groups[i] === 'undefined') {
          groups[i] = [];
        }
      }
      outerGroups = outerGroups.length === 0 ? reduceGroups() : groups;
      if (outerGroups.length > 0) {
        var len = 0;
        for (var _i2 = 0; _i2 < outerGroups.length; _i2 += 1) {
          if (outerGroups[_i2].length > len) {
            len = outerGroups[_i2].length;
          }
        }
        var limit = outerGroups.length * len / 2;
        for (var _i3 = 0; _i3 < limit; _i3 += 1) {
          if (!partite[_i3]) {
            partite[_i3] = {};
          }
          var match = partite[_i3];
          if (match && match.homeTeam) {
            (function () {
              var filteredMatch = [];
              match.matches.map(function (x) {
                return x.status != 'POSTPONED' ? filteredMatch.push(x) : '';
              });
              var winnerMatches = Math.max(Number(match.homeTeam.score), Number(match.awayTeam.score));
              if (winnerMatches > filteredMatch.length / 2) {
                partite[_i3].isFiniscedSerie = true;
                partite[_i3].matches = partite[_i3].matches.filter(function (m) {
                  return m.status.toLowerCase() === 'played';
                });
              }
            })();
          }
        }
      }
      phases.push({ roundName: x.roundName, partite: partite });
    }
  });
  data.contents = phases;
  return data;
};

var addShootOutScore = function addShootOutScore(match) {
  var addTeamShootOutScore = function addTeamShootOutScore(team) {
    var baseScore = team.score ? parseInt(team.score, 10) : 0;
    var shootOutsScore = team.starData && team.starData.shootOuts && team.starData.shootOuts.score ? parseInt(team.starData.shootOuts.score, 10) : 0;
    team.scoreAfterShootOuts = (baseScore + shootOutsScore).toString();

    return team;
  };
  if (match.homeTeam) addTeamShootOutScore(match.homeTeam);
  if (match.awayTeam) addTeamShootOutScore(match.awayTeam);

  return match;
};

exports.configJson = configJson;
exports.prettyMatchUrl = prettyMatchUrl;
exports.prettyPlayerUrl = prettyPlayerUrl;
exports.prettyTopScorersUrl = prettyTopScorersUrl;
exports.prettyStandingsUrl = prettyStandingsUrl;
exports.prettyCalendarUrl = prettyCalendarUrl;
exports.cleanTeamOrNameUrl = cleanTeamOrNameUrl;
exports.prettyTeamUrl = prettyTeamUrl;
exports.prettyLiveHubUrl = prettyLiveHubUrl;
exports.prettyCalendarTennisUrl = prettyCalendarTennisUrl;
exports.prettySeasonTennisUrl = prettySeasonTennisUrl;
exports.prettySeasonSkiUrl = prettySeasonSkiUrl;
exports.prettyMotorCalendarUrl = prettyMotorCalendarUrl;
exports.configFlags = configFlags;
exports.countryCode = countryCode;
exports.prettyCyclingCompetitionId = prettyCyclingCompetitionId;
exports.prettyCyclingCompetitionLabel = prettyCyclingCompetitionLabel;
exports.teamNameLabel = teamNameLabel;
exports.teamHasLink = teamHasLink;
exports.configCompetitions = configCompetitions;
exports.isFootballCup = isFootballCup;
exports.isVolleyCup = isVolleyCup;
exports.isBasketCup = isBasketCup;
exports.isOnlyFirstLeg = isOnlyFirstLeg;
exports.isCompetitionRoundLink = isCompetitionRoundLink;
exports.isHideStandingSwitchHomeAway = isHideStandingSwitchHomeAway;
exports.isHideStandingLink = isHideStandingLink;
exports.isHideLiveLink = isHideLiveLink;
exports.getFootballTeamImagePath = getFootballTeamImagePath;
exports.getVolleyTeamImagePath = getVolleyTeamImagePath;
exports.subPhaseLabel = subPhaseLabel;
exports.buildBasketData = buildBasketData;
exports.isPlayoffs = isPlayoffs;
exports.parseCompetitionName = parseCompetitionName;
exports.imageRacingMap = imageRacingMap;
exports.showMatchQuote = showMatchQuote;
exports.showMatchVotation = showMatchVotation;
exports.hideMatchCommentary = hideMatchCommentary;
exports.hideMatchSynthesis = hideMatchSynthesis;
exports.hideMatchStatistics = hideMatchStatistics;
exports.hidePlayOffTabStanding = hidePlayOffTabStanding;
exports.getLegendaElements = getLegendaElements;
exports.getClinchStatusColor = getClinchStatusColor;
exports.addShootOutScore = addShootOutScore;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScreenClass = exports.screenClasses = void 0;

var _react = __webpack_require__(0);

var _config = __webpack_require__(11);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getViewPort = function getViewPort(source) {
  if (source && source.current && source.current.clientWidth) {
    return source.current.clientWidth;
  }

  if (typeof window !== 'undefined' && window.innerWidth) {
    return window.innerWidth;
  }

  return null;
};

var screenClasses = ['xs', 'sm', 'md', 'lg', 'xl'];
exports.screenClasses = screenClasses;

var useScreenClass = function useScreenClass(source, fallbackScreenClass) {
  var getScreenClass = function getScreenClass() {
    var _getConfiguration = (0, _config.getConfiguration)(),
        breakpoints = _getConfiguration.breakpoints,
        defaultScreenClass = _getConfiguration.defaultScreenClass;

    var newScreenClass = defaultScreenClass;
    var viewport = getViewPort(source);

    if (viewport) {
      newScreenClass = 'xs';
      if (breakpoints[0] && viewport >= breakpoints[0]) newScreenClass = 'sm';
      if (breakpoints[1] && viewport >= breakpoints[1]) newScreenClass = 'md';
      if (breakpoints[2] && viewport >= breakpoints[2]) newScreenClass = 'lg';
      if (breakpoints[3] && viewport >= breakpoints[3]) newScreenClass = 'xl';
    } else if (fallbackScreenClass) {
      newScreenClass = fallbackScreenClass;
    }

    return newScreenClass;
  };

  var _useState = (0, _react.useState)(getScreenClass()),
      _useState2 = _slicedToArray(_useState, 2),
      screenClass = _useState2[0],
      setScreenClass = _useState2[1];

  (0, _react.useEffect)(function () {
    var handleWindowResized = function handleWindowResized() {
      return setScreenClass(getScreenClass());
    };

    window.addEventListener('resize', handleWindowResized, false);
    return function () {
      window.removeEventListener('resize', handleWindowResized, false);
    };
  }, []);
  return screenClass;
};

exports.useScreenClass = useScreenClass;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(59);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(64);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context__ = __webpack_require__(7);


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  Object(__WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, _excluded);

  if (false) {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_3_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isContextConsumer"])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* createSubscription */])(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(39);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(40);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStoreHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(42);



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = /*#__PURE__*/createStoreHook();

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(7);


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */]);

  if (false) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(88);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



var createSelectors = function createSelectors(structure) {
  var getIn = structure.getIn,
      toJS = structure.toJS;

  var isRouter = function isRouter(value) {
    return value != null && _typeof(value) === 'object' && getIn(value, ['location']) && getIn(value, ['action']);
  };

  var getRouter = function getRouter(state) {
    var router = toJS(getIn(state, ['router']));

    if (!isRouter(router)) {
      throw 'Could not find router reducer in state tree, it must be mounted under "router"';
    }

    return router;
  };

  var getLocation = function getLocation(state) {
    return toJS(getIn(getRouter(state), ['location']));
  };

  var getAction = function getAction(state) {
    return toJS(getIn(getRouter(state), ['action']));
  };

  var getSearch = function getSearch(state) {
    return toJS(getIn(getRouter(state), ['location', 'search']));
  };

  var getHash = function getHash(state) {
    return toJS(getIn(getRouter(state), ['location', 'hash']));
  }; // It only makes sense to recalculate the `matchPath` whenever the pathname
  // of the location changes. That's why `createMatchSelector` memoizes
  // the latest result based on the location's pathname.


  var createMatchSelector = function createMatchSelector(path) {
    var lastPathname = null;
    var lastMatch = null;
    return function (state) {
      var _ref = getLocation(state) || {},
          pathname = _ref.pathname;

      if (pathname === lastPathname) {
        return lastMatch;
      }

      lastPathname = pathname;
      var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* matchPath */])(pathname, path);

      if (!match || !lastMatch || match.url !== lastMatch.url // When URL matched for nested routes, URL is the same but isExact is not.
      || match.isExact !== lastMatch.isExact) {
        lastMatch = match;
      }

      return lastMatch;
    };
  };

  return {
    getLocation: getLocation,
    getAction: getAction,
    getRouter: getRouter,
    getSearch: getSearch,
    getHash: getHash,
    createMatchSelector: createMatchSelector
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createSelectors);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return history; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sagas__ = __webpack_require__(117);
var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["a" /* default */])();var history=Object(__WEBPACK_IMPORTED_MODULE_2_history__["a" /* createBrowserHistory */])();var switchStore=function switchStore(){var store=void 0;if(true){store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(sagaMiddleware),Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(Object(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["d" /* routerMiddleware */])(history)));}else{store=composeWithDevTools(applyMiddleware(sagaMiddleware),applyMiddleware(routerMiddleware(history)));}return store;};var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(Object(__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* default */])(history),switchStore());sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_6__sagas__["a" /* default */]);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export END */
/* unused harmony export channel */
/* unused harmony export eventChannel */
/* unused harmony export isEnd */
/* unused harmony export multicastChannel */
/* unused harmony export runSaga */
/* unused harmony export stdChannel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__ = __webpack_require__(10);
/* unused harmony reexport CANCEL */
/* unused harmony reexport SAGA_LOCATION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_saga_is__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__ = __webpack_require__(18);
/* unused harmony reexport buffers */
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_saga_deferred__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_saga_delay_p__ = __webpack_require__(30);











var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/

var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/

function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/


function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */

function immediately(task) {
  try {
    suspend();
    return task();
  } finally {
    flush();
  }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/

function suspend() {
  semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/


function release() {
  semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/


function flush() {
  release();
  var task;

  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

var array = function array(patterns) {
  return function (input) {
    return patterns.some(function (p) {
      return matcher(p)(input);
    });
  };
};
var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};
var string = function string(pattern) {
  return function (input) {
    return input.type === String(pattern);
  };
};
var symbol = function symbol(pattern) {
  return function (input) {
    return input.type === pattern;
  };
};
var wildcard = function wildcard() {
  return __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["G" /* k */];
};
function matcher(pattern) {
  // prettier-ignore
  var matcherCreator = pattern === '*' ? wildcard : Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["k" /* string */])(pattern) ? string : Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["a" /* array */])(pattern) ? array : Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["l" /* stringableFunc */])(pattern) ? string : Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["d" /* func */])(pattern) ? predicate : Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["m" /* symbol */])(pattern) ? symbol : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern);
  }

  return matcherCreator(pattern);
}

var END = {
  type: __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["b" /* CHANNEL_END_TYPE */]
};
var isEnd = function isEnd(a) {
  return a && a.type === __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["b" /* CHANNEL_END_TYPE */];
};
var CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function channel(buffer$1) {
  if (buffer$1 === void 0) {
    buffer$1 = Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["A" /* e */])();
  }

  var closed = false;
  var takers = [];

  if (false) {
    check(buffer$1, buffer, INVALID_BUFFER);
  }

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["E" /* i */])(CLOSED_CHANNEL_WITH_TAKERS);
    }

    if (takers.length && !buffer$1.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["E" /* i */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    if (false) {
      checkForbiddenStates();
      check(input, notUndef, UNDEFINED_INPUT_ERROR);
    }

    if (closed) {
      return;
    }

    if (takers.length === 0) {
      return buffer$1.put(input);
    }

    var cb = takers.shift();
    cb(input);
  }

  function take(cb) {
    if (false) {
      checkForbiddenStates();
      check(cb, func, "channel.take's callback must be a function");
    }

    if (closed && buffer$1.isEmpty()) {
      cb(END);
    } else if (!buffer$1.isEmpty()) {
      cb(buffer$1.take());
    } else {
      takers.push(cb);

      cb.cancel = function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["N" /* r */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    if (false) {
      checkForbiddenStates();
      check(cb, func, "channel.flush' callback must be a function");
    }

    if (closed && buffer$1.isEmpty()) {
      cb(END);
      return;
    }

    cb(buffer$1.flush());
  }

  function close() {
    if (false) {
      checkForbiddenStates();
    }

    if (closed) {
      return;
    }

    closed = true;
    var arr = takers;
    takers = [];

    for (var i = 0, len = arr.length; i < len; i++) {
      var taker = arr[i];
      taker(END);
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close
  };
}
function eventChannel(subscribe, buffer) {
  if (buffer === void 0) {
    buffer = Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["J" /* n */])();
  }

  var closed = false;
  var unsubscribe;
  var chan = channel(buffer);

  var close = function close() {
    if (closed) {
      return;
    }

    closed = true;

    if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["d" /* func */])(unsubscribe)) {
      unsubscribe();
    }

    chan.close();
  };

  unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }

    chan.put(input);
  });

  if (false) {
    check(unsubscribe, func, 'in eventChannel: subscribe should return a function to unsubscribe');
  }

  unsubscribe = Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["K" /* o */])(unsubscribe);

  if (closed) {
    unsubscribe();
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}
function multicastChannel() {
  var _ref;

  var closed = false;
  var currentTakers = [];
  var nextTakers = currentTakers;

  function checkForbiddenStates() {
    if (closed && nextTakers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["E" /* i */])(CLOSED_CHANNEL_WITH_TAKERS);
    }
  }

  var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
    if (nextTakers !== currentTakers) {
      return;
    }

    nextTakers = currentTakers.slice();
  };

  var close = function close() {
    if (false) {
      checkForbiddenStates();
    }

    closed = true;
    var takers = currentTakers = nextTakers;
    nextTakers = [];
    takers.forEach(function (taker) {
      taker(END);
    });
  };

  return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["e" /* MULTICAST */]] = true, _ref.put = function put(input) {
    if (false) {
      checkForbiddenStates();
      check(input, notUndef, UNDEFINED_INPUT_ERROR);
    }

    if (closed) {
      return;
    }

    if (isEnd(input)) {
      close();
      return;
    }

    var takers = currentTakers = nextTakers;

    for (var i = 0, len = takers.length; i < len; i++) {
      var taker = takers[i];

      if (taker[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["d" /* MATCH */]](input)) {
        taker.cancel();
        taker(input);
      }
    }
  }, _ref.take = function take(cb, matcher) {
    if (matcher === void 0) {
      matcher = wildcard;
    }

    if (false) {
      checkForbiddenStates();
    }

    if (closed) {
      cb(END);
      return;
    }

    cb[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["d" /* MATCH */]] = matcher;
    ensureCanMutateNextTakers();
    nextTakers.push(cb);
    cb.cancel = Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["K" /* o */])(function () {
      ensureCanMutateNextTakers();
      Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["N" /* r */])(nextTakers, cb);
    });
  }, _ref.close = close, _ref;
}
function stdChannel() {
  var chan = multicastChannel();
  var put = chan.put;

  chan.put = function (input) {
    if (input[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["f" /* SAGA_ACTION */]]) {
      put(input);
      return;
    }

    asap(function () {
      put(input);
    });
  };

  return chan;
}

var RUNNING = 0;
var CANCELLED = 1;
var ABORTED = 2;
var DONE = 3;

function resolvePromise(promise, cb) {
  var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["a" /* CANCEL */]];

  if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["d" /* func */])(cancelPromise)) {
    cb.cancel = cancelPromise;
  }

  promise.then(cb, function (error) {
    cb(error, true);
  });
}

var current = 0;
var nextSagaId = (function () {
  return ++current;
});

var _effectRunnerMap;

function getIteratorMetaInfo(iterator, fn) {
  if (iterator.isSagaIterator) {
    return {
      name: iterator.meta.name
    };
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["F" /* j */])(fn);
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  // catch synchronous failures; see #152 and #441
  try {
    var result = fn.apply(context, args); // i.e. a generator function returns an iterator

    if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["e" /* iterator */])(result)) {
      return result;
    }

    var resolved = false;

    var next = function next(arg) {
      if (!resolved) {
        resolved = true; // Only promises returned from fork will be interpreted. See #1573

        return {
          value: result,
          done: !Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["j" /* promise */])(result)
        };
      } else {
        return {
          value: arg,
          done: true
        };
      }
    };

    return Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["M" /* q */])(next);
  } catch (err) {
    // do not bubble up synchronous failures for detached forks
    // instead create a failed task. See #152 and #441
    return Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["M" /* q */])(function () {
      throw err;
    });
  }
}

function runPutEffect(env, _ref2, cb) {
  var channel = _ref2.channel,
      action = _ref2.action,
      resolve = _ref2.resolve;

  /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/
  asap(function () {
    var result;

    try {
      result = (channel ? channel.put : env.dispatch)(action);
    } catch (error) {
      cb(error, true);
      return;
    }

    if (resolve && Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["j" /* promise */])(result)) {
      resolvePromise(result, cb);
    } else {
      cb(result);
    }
  }); // Put effects are non cancellables
}

function runTakeEffect(env, _ref3, cb) {
  var _ref3$channel = _ref3.channel,
      channel = _ref3$channel === void 0 ? env.channel : _ref3$channel,
      pattern = _ref3.pattern,
      maybe = _ref3.maybe;

  var takeCb = function takeCb(input) {
    if (input instanceof Error) {
      cb(input, true);
      return;
    }

    if (isEnd(input) && !maybe) {
      cb(__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["k" /* TERMINATE */]);
      return;
    }

    cb(input);
  };

  try {
    channel.take(takeCb, Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["g" /* notUndef */])(pattern) ? matcher(pattern) : null);
  } catch (err) {
    cb(err, true);
    return;
  }

  cb.cancel = takeCb.cancel;
}

function runCallEffect(env, _ref4, cb, _ref5) {
  var context = _ref4.context,
      fn = _ref4.fn,
      args = _ref4.args;
  var task = _ref5.task;

  // catch synchronous failures; see #152
  try {
    var result = fn.apply(context, args);

    if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["j" /* promise */])(result)) {
      resolvePromise(result, cb);
      return;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["e" /* iterator */])(result)) {
      // resolve iterator
      proc(env, result, task.context, current, Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["F" /* j */])(fn),
      /* isRoot */
      false, cb);
      return;
    }

    cb(result);
  } catch (error) {
    cb(error, true);
  }
}

function runCPSEffect(env, _ref6, cb) {
  var context = _ref6.context,
      fn = _ref6.fn,
      args = _ref6.args;

  // CPS (ie node style functions) can define their own cancellation logic
  // by setting cancel field on the cb
  // catch synchronous failures; see #152
  try {
    var cpsCb = function cpsCb(err, res) {
      if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["n" /* undef */])(err)) {
        cb(res);
      } else {
        cb(err, true);
      }
    };

    fn.apply(context, args.concat(cpsCb));

    if (cpsCb.cancel) {
      cb.cancel = cpsCb.cancel;
    }
  } catch (error) {
    cb(error, true);
  }
}

function runForkEffect(env, _ref7, cb, _ref8) {
  var context = _ref7.context,
      fn = _ref7.fn,
      args = _ref7.args,
      detached = _ref7.detached;
  var parent = _ref8.task;
  var taskIterator = createTaskIterator({
    context: context,
    fn: fn,
    args: args
  });
  var meta = getIteratorMetaInfo(taskIterator, fn);
  immediately(function () {
    var child = proc(env, taskIterator, parent.context, current, meta, detached, undefined);

    if (detached) {
      cb(child);
    } else {
      if (child.isRunning()) {
        parent.queue.addTask(child);
        cb(child);
      } else if (child.isAborted()) {
        parent.queue.abort(child.error());
      } else {
        cb(child);
      }
    }
  }); // Fork effects are non cancellables
}

function runJoinEffect(env, taskOrTasks, cb, _ref9) {
  var task = _ref9.task;

  var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
    if (taskToJoin.isRunning()) {
      var joiner = {
        task: task,
        cb: cb
      };

      cb.cancel = function () {
        if (taskToJoin.isRunning()) Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["N" /* r */])(taskToJoin.joiners, joiner);
      };

      taskToJoin.joiners.push(joiner);
    } else {
      if (taskToJoin.isAborted()) {
        cb(taskToJoin.error(), true);
      } else {
        cb(taskToJoin.result());
      }
    }
  };

  if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["a" /* array */])(taskOrTasks)) {
    if (taskOrTasks.length === 0) {
      cb([]);
      return;
    }

    var childCallbacks = Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["H" /* l */])(taskOrTasks, cb);
    taskOrTasks.forEach(function (t, i) {
      joinSingleTask(t, childCallbacks[i]);
    });
  } else {
    joinSingleTask(taskOrTasks, cb);
  }
}

function cancelSingleTask(taskToCancel) {
  if (taskToCancel.isRunning()) {
    taskToCancel.cancel();
  }
}

function runCancelEffect(env, taskOrTasks, cb, _ref10) {
  var task = _ref10.task;

  if (taskOrTasks === __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["h" /* SELF_CANCELLATION */]) {
    cancelSingleTask(task);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["a" /* array */])(taskOrTasks)) {
    taskOrTasks.forEach(cancelSingleTask);
  } else {
    cancelSingleTask(taskOrTasks);
  }

  cb(); // cancel effects are non cancellables
}

function runAllEffect(env, effects, cb, _ref11) {
  var digestEffect = _ref11.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);

  if (keys.length === 0) {
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["a" /* array */])(effects) ? [] : {});
    return;
  }

  var childCallbacks = Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["H" /* l */])(effects, cb);
  keys.forEach(function (key) {
    digestEffect(effects[key], effectId, childCallbacks[key], key);
  });
}

function runRaceEffect(env, effects, cb, _ref12) {
  var digestEffect = _ref12.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);
  var response = Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["a" /* array */])(effects) ? Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["I" /* m */])(keys.length) : {};
  var childCbs = {};
  var completed = false;
  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["O" /* s */])(res)) {
        // Race Auto cancellation
        cb.cancel();
        cb(res, isErr);
      } else {
        cb.cancel();
        completed = true;
        response[key] = res;
        cb(response);
      }
    };

    chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
    childCbs[key] = chCbAtKey;
  });

  cb.cancel = function () {
    // prevents unnecessary cancellation
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCbs[key].cancel();
      });
    }
  };

  keys.forEach(function (key) {
    if (completed) {
      return;
    }

    digestEffect(effects[key], effectId, childCbs[key], key);
  });
}

function runSelectEffect(env, _ref13, cb) {
  var selector = _ref13.selector,
      args = _ref13.args;

  try {
    var state = selector.apply(void 0, [env.getState()].concat(args));
    cb(state);
  } catch (error) {
    cb(error, true);
  }
}

function runChannelEffect(env, _ref14, cb) {
  var pattern = _ref14.pattern,
      buffer = _ref14.buffer;
  var chan = channel(buffer);
  var match = matcher(pattern);

  var taker = function taker(action) {
    if (!isEnd(action)) {
      env.channel.take(taker, match);
    }

    chan.put(action);
  };

  var close = chan.close;

  chan.close = function () {
    taker.cancel();
    close();
  };

  env.channel.take(taker, match);
  cb(chan);
}

function runCancelledEffect(env, data, cb, _ref15) {
  var task = _ref15.task;
  cb(task.isCancelled());
}

function runFlushEffect(env, channel, cb) {
  channel.flush(cb);
}

function runGetContextEffect(env, prop, cb, _ref16) {
  var task = _ref16.task;
  cb(task.context[prop]);
}

function runSetContextEffect(env, props, cb, _ref17) {
  var task = _ref17.task;
  Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["L" /* p */])(task.context, props);
  cb();
}

var effectRunnerMap = (_effectRunnerMap = {}, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["r" /* T */]] = runTakeEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["n" /* P */]] = runPutEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["a" /* A */]] = runAllEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["p" /* R */]] = runRaceEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["c" /* C */]] = runCallEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["w" /* a */]] = runCPSEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["f" /* F */]] = runForkEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["h" /* J */]] = runJoinEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["x" /* b */]] = runCancelEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["q" /* S */]] = runSelectEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["z" /* d */]] = runChannelEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["B" /* f */]] = runCancelledEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["C" /* g */]] = runFlushEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["g" /* G */]] = runGetContextEffect, _effectRunnerMap[__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["D" /* h */]] = runSetContextEffect, _effectRunnerMap);

/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/

function forkQueue(mainTask, onAbort, cont) {
  var tasks = [];
  var result;
  var completed = false;
  addTask(mainTask);

  var getTasks = function getTasks() {
    return tasks;
  };

  function abort(err) {
    onAbort();
    cancelAll();
    cont(err, true);
  }

  function addTask(task) {
    tasks.push(task);

    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["N" /* r */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];

      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }

        if (!tasks.length) {
          completed = true;
          cont(result);
        }
      }
    };
  }

  function cancelAll() {
    if (completed) {
      return;
    }

    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: getTasks
  };
}

// there can be only a single saga error created at any given moment

function formatLocation(fileName, lineNumber) {
  return fileName + "?" + lineNumber;
}

function effectLocationAsString(effect) {
  var location = Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["R" /* v */])(effect);

  if (location) {
    var code = location.code,
        fileName = location.fileName,
        lineNumber = location.lineNumber;
    var source = code + "  " + formatLocation(fileName, lineNumber);
    return source;
  }

  return '';
}

function sagaLocationAsString(sagaMeta) {
  var name = sagaMeta.name,
      location = sagaMeta.location;

  if (location) {
    return name + "  " + formatLocation(location.fileName, location.lineNumber);
  }

  return name;
}

function cancelledTasksAsString(sagaStack) {
  var cancelledTasks = Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["Q" /* u */])(function (i) {
    return i.cancelledTasks;
  }, sagaStack);

  if (!cancelledTasks.length) {
    return '';
  }

  return ['Tasks cancelled due to error:'].concat(cancelledTasks).join('\n');
}

var crashedEffect = null;
var sagaStack = [];
var addSagaFrame = function addSagaFrame(frame) {
  frame.crashedEffect = crashedEffect;
  sagaStack.push(frame);
};
var clear = function clear() {
  crashedEffect = null;
  sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now

var setCrashedEffect = function setCrashedEffect(effect) {
  crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/

var toString = function toString() {
  var firstSaga = sagaStack[0],
      otherSagas = sagaStack.slice(1);
  var crashedEffectLocation = firstSaga.crashedEffect ? effectLocationAsString(firstSaga.crashedEffect) : null;
  var errorMessage = "The above error occurred in task " + sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
  return [errorMessage].concat(otherSagas.map(function (s) {
    return "    created by " + sagaLocationAsString(s.meta);
  }), [cancelledTasksAsString(sagaStack)]).join('\n');
};

function newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
  var _task;

  if (cont === void 0) {
    cont = __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
  }

  var status = RUNNING;
  var taskResult;
  var taskError;
  var deferredEnd = null;
  var cancelledDueToErrorTasks = [];
  var context = Object.create(parentContext);
  var queue = forkQueue(mainTask, function onAbort() {
    cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function (t) {
      return t.meta.name;
    }));
  }, end);
  /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/

  function cancel() {
    if (status === RUNNING) {
      // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
      // effects in the iterator's finally block will still be executed
      status = CANCELLED;
      queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners

      end(__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["j" /* TASK_CANCEL */], false);
    }
  }

  function end(result, isErr) {
    if (!isErr) {
      // The status here may be RUNNING or CANCELLED
      // If the status is CANCELLED, then we do not need to change it here
      if (result === __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["j" /* TASK_CANCEL */]) {
        status = CANCELLED;
      } else if (status !== CANCELLED) {
        status = DONE;
      }

      taskResult = result;
      deferredEnd && deferredEnd.resolve(result);
    } else {
      status = ABORTED;
      addSagaFrame({
        meta: meta,
        cancelledTasks: cancelledDueToErrorTasks
      });

      if (task.isRoot) {
        var sagaStack = toString(); // we've dumped the saga stack to string and are passing it to user's code
        // we know that it won't be needed anymore and we need to clear it

        clear();
        env.onError(result, {
          sagaStack: sagaStack
        });
      }

      taskError = result;
      deferredEnd && deferredEnd.reject(result);
    }

    task.cont(result, isErr);
    task.joiners.forEach(function (joiner) {
      joiner.cb(result, isErr);
    });
    task.joiners = null;
  }

  function setContext(props) {
    if (false) {
      check(props, object, createSetContextWarning('task', props));
    }

    Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["L" /* p */])(context, props);
  }

  function toPromise() {
    if (deferredEnd) {
      return deferredEnd.promise;
    }

    deferredEnd = Object(__WEBPACK_IMPORTED_MODULE_6__redux_saga_deferred__["a" /* default */])();

    if (status === ABORTED) {
      deferredEnd.reject(taskError);
    } else if (status !== RUNNING) {
      deferredEnd.resolve(taskResult);
    }

    return deferredEnd.promise;
  }

  var task = (_task = {}, _task[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["i" /* TASK */]] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
    return status === RUNNING;
  }, _task.isCancelled = function isCancelled() {
    return status === CANCELLED || status === RUNNING && mainTask.status === CANCELLED;
  }, _task.isAborted = function isAborted() {
    return status === ABORTED;
  }, _task.result = function result() {
    return taskResult;
  }, _task.error = function error() {
    return taskError;
  }, _task);
  return task;
}

function proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
  if (false) {
    throw new Error("redux-saga doesn't support async generators, please use only regular ones");
  }

  var finalRunEffect = env.finalizeRunEffect(runEffect);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/

  next.cancel = __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
  /** Creates a main task to track the main flow */

  var mainTask = {
    meta: meta,
    cancel: cancelMain,
    status: RUNNING
  };
  /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/

  var task = newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
  var executingContext = {
    task: task,
    digestEffect: digestEffect
  };
  /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/

  function cancelMain() {
    if (mainTask.status === RUNNING) {
      mainTask.status = CANCELLED;
      next(__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["j" /* TASK_CANCEL */]);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/


  if (cont) {
    cont.cancel = task.cancel;
  } // kicks up the generator


  next(); // then return the task descriptor to the caller

  return task;
  /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */

  function next(arg, isErr) {
    try {
      var result;

      if (isErr) {
        result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values

        clear();
      } else if (Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["S" /* y */])(arg)) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.status = CANCELLED;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/

        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/

        result = Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["d" /* func */])(iterator$1.return) ? iterator$1.return(__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["j" /* TASK_CANCEL */]) : {
          done: true,
          value: __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["j" /* TASK_CANCEL */]
        };
      } else if (Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["T" /* z */])(arg)) {
        // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["d" /* func */])(iterator$1.return) ? iterator$1.return() : {
          done: true
        };
      } else {
        result = iterator$1.next(arg);
      }

      if (!result.done) {
        digestEffect(result.value, parentEffectId, next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        if (mainTask.status !== CANCELLED) {
          mainTask.status = DONE;
        }

        mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.status === CANCELLED) {
        throw error;
      }

      mainTask.status = ABORTED;
      mainTask.cont(error, true);
    }
  }

  function runEffect(effect, effectId, currCb) {
    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["j" /* promise */])(effect)) {
      resolvePromise(effect, currCb);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_3__redux_saga_is__["e" /* iterator */])(effect)) {
      // resolve iterator
      proc(env, effect, task.context, effectId, meta,
      /* isRoot */
      false, currCb);
    } else if (effect && effect[__WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__["c" /* IO */]]) {
      var effectRunner = effectRunnerMap[effect.type];
      effectRunner(env, effect.payload, currCb, executingContext);
    } else {
      // anything else returned as is
      currCb(effect);
    }
  }

  function digestEffect(effect, parentEffectId, cb, label) {
    if (label === void 0) {
      label = '';
    }

    var effectId = nextSagaId();
    env.sagaMonitor && env.sagaMonitor.effectTriggered({
      effectId: effectId,
      parentEffectId: parentEffectId,
      label: label,
      effect: effect
    });
    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/

    var effectSettled; // Completion callback passed to the appropriate effect runner

    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */]; // defensive measure

      if (env.sagaMonitor) {
        if (isErr) {
          env.sagaMonitor.effectRejected(effectId, res);
        } else {
          env.sagaMonitor.effectResolved(effectId, res);
        }
      }

      if (isErr) {
        setCrashedEffect(effect);
      }

      cb(res, isErr);
    } // tracks down the current cancel


    currCb.cancel = __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */]; // setup cancellation logic on the parent cb

    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      currCb.cancel(); // propagates cancel downward

      currCb.cancel = __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */]; // defensive measure

      env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
    };

    finalRunEffect(effect, effectId, currCb);
  }
}

var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function runSaga(_ref, saga) {
  var _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      dispatch = _ref.dispatch,
      getState = _ref.getState,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      sagaMonitor = _ref.sagaMonitor,
      effectMiddlewares = _ref.effectMiddlewares,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["b" /* B */] : _ref$onError;

  if (false) {
    check(saga, func, NON_GENERATOR_ERR);
  }

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator$1 = saga.apply(void 0, args);

  if (false) {
    check(iterator$1, iterator, NON_GENERATOR_ERR);
  }

  var effectId = nextSagaId();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["P" /* t */];
    sagaMonitor.rootSagaStarted({
      effectId: effectId,
      saga: saga,
      args: args
    });
  }

  if (false) {
    if (notUndef(dispatch)) {
      check(dispatch, func, 'dispatch must be a function');
    }

    if (notUndef(getState)) {
      check(getState, func, 'getState must be a function');
    }

    if (notUndef(effectMiddlewares)) {
      var MIDDLEWARE_TYPE_ERROR = 'effectMiddlewares must be an array of functions';
      check(effectMiddlewares, array$1, MIDDLEWARE_TYPE_ERROR);
      effectMiddlewares.forEach(function (effectMiddleware) {
        return check(effectMiddleware, func, MIDDLEWARE_TYPE_ERROR);
      });
    }

    check(onError, func, 'onError passed to the redux-saga is not a function!');
  }

  var finalizeRunEffect;

  if (effectMiddlewares) {
    var middleware = __WEBPACK_IMPORTED_MODULE_5_redux__["compose"].apply(void 0, effectMiddlewares);

    finalizeRunEffect = function finalizeRunEffect(runEffect) {
      return function (effect, effectId, currCb) {
        var plainRunEffect = function plainRunEffect(eff) {
          return runEffect(eff, effectId, currCb);
        };

        return middleware(plainRunEffect)(effect);
      };
    };
  } else {
    finalizeRunEffect = __WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["e" /* E */];
  }

  var env = {
    channel: channel,
    dispatch: Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["d" /* D */])(dispatch),
    getState: getState,
    sagaMonitor: sagaMonitor,
    onError: onError,
    finalizeRunEffect: finalizeRunEffect
  };
  return immediately(function () {
    var task = proc(env, iterator$1, context, effectId, Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["F" /* j */])(saga),
    /* isRoot */
    true, undefined);

    if (sagaMonitor) {
      sagaMonitor.effectResolved(effectId, task);
    }

    return task;
  });
}

function sagaMiddlewareFactory(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      sagaMonitor = _ref.sagaMonitor,
      options = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["context", "channel", "sagaMonitor"]);

  var boundRunSaga;

  if (false) {
    check(channel, channel$1, 'options.channel passed to the Saga middleware is not a channel');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;
    boundRunSaga = runSaga.bind(null, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      context: context,
      channel: channel,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor
    }));
    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }

        var result = next(action); // hit reducers

        channel.put(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    if (false) {
      throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    }

    return boundRunSaga.apply(void 0, arguments);
  };

  sagaMiddleware.setContext = function (props) {
    if (false) {
      check(props, object, createSetContextWarning('sagaMiddleware', props));
    }

    Object(__WEBPACK_IMPORTED_MODULE_4__io_c3792963_js__["L" /* p */])(context, props);
  };

  return sagaMiddleware;
}

/* harmony default export */ __webpack_exports__["a"] = (sagaMiddlewareFactory);



/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Col", {
  enumerable: true,
  get: function get() {
    return _Col.default;
  }
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function get() {
    return _Container.default;
  }
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _Row.default;
  }
});
Object.defineProperty(exports, "Hidden", {
  enumerable: true,
  get: function get() {
    return _Hidden.default;
  }
});
Object.defineProperty(exports, "Visible", {
  enumerable: true,
  get: function get() {
    return _Visible.default;
  }
});
Object.defineProperty(exports, "ScreenClassRender", {
  enumerable: true,
  get: function get() {
    return _ScreenClassRender.default;
  }
});
Object.defineProperty(exports, "ScreenClassProvider", {
  enumerable: true,
  get: function get() {
    return _ScreenClassProvider.default;
  }
});
Object.defineProperty(exports, "ScreenClassContext", {
  enumerable: true,
  get: function get() {
    return _ScreenClassProvider.ScreenClassContext;
  }
});
Object.defineProperty(exports, "setConfiguration", {
  enumerable: true,
  get: function get() {
    return _config.setConfiguration;
  }
});
Object.defineProperty(exports, "useScreenClass", {
  enumerable: true,
  get: function get() {
    return _utils.useScreenClass;
  }
});

var _Col = _interopRequireDefault(__webpack_require__(146));

var _Container = _interopRequireDefault(__webpack_require__(149));

var _Row = _interopRequireDefault(__webpack_require__(49));

var _Hidden = _interopRequireDefault(__webpack_require__(151));

var _Visible = _interopRequireDefault(__webpack_require__(153));

var _ScreenClassRender = _interopRequireDefault(__webpack_require__(155));

var _ScreenClassProvider = _interopRequireWildcard(__webpack_require__(50));

var _config = __webpack_require__(11);

var _utils = __webpack_require__(32);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GutterWidthContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _config = __webpack_require__(11);

var _style = _interopRequireDefault(__webpack_require__(148));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GutterWidthContext = _react.default.createContext(false);

exports.GutterWidthContext = GutterWidthContext;

var Row = function Row(_ref) {
  var children = _ref.children,
      style = _ref.style,
      align = _ref.align,
      justify = _ref.justify,
      debug = _ref.debug,
      nogutter = _ref.nogutter,
      gutterWidth = _ref.gutterWidth,
      component = _ref.component,
      nowrap = _ref.nowrap,
      otherProps = _objectWithoutProperties(_ref, ["children", "style", "align", "justify", "debug", "nogutter", "gutterWidth", "component", "nowrap"]);

  var theGutterWidth = (0, _config.getConfiguration)().gutterWidth;
  if (nogutter) theGutterWidth = 0;
  if (typeof gutterWidth === 'number') theGutterWidth = gutterWidth;
  var theStyle = (0, _style.default)({
    gutterWidth: theGutterWidth,
    align: align,
    justify: justify,
    debug: debug,
    moreStyle: style,
    nowrap: nowrap
  });
  return _react.default.createElement(component, _objectSpread({
    style: theStyle
  }, otherProps), _react.default.createElement(GutterWidthContext.Provider, {
    value: theGutterWidth
  }, children));
};

Row.propTypes = {
  /**
   * Content of the element
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Vertical column alignment
   */
  align: _propTypes.default.oneOf(['normal', 'start', 'center', 'end', 'stretch']),

  /**
   * Horizontal column alignment
   */
  justify: _propTypes.default.oneOf(['start', 'center', 'end', 'between', 'around', 'initial', 'inherit']),

  /**
   * No gutter for this row
   */
  nogutter: _propTypes.default.bool,

  /**
   * Custom gutter width for this row
   */
  gutterWidth: _propTypes.default.number,

  /**
   * Optional styling
   */
  style: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])),

  /**
   * Set to apply some debug styling
   */
  debug: _propTypes.default.bool,

  /**
   * Use your own component
   */
  component: _propTypes.default.elementType,

  /**
   * Whether the cols should not wrap
   */
  nowrap: _propTypes.default.bool
};
Row.defaultProps = {
  align: 'normal',
  justify: 'start',
  nogutter: false,
  gutterWidth: null,
  style: {},
  debug: false,
  component: 'div',
  nowrap: false
};
var _default = Row;
exports.default = _default;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ScreenClassContext = exports.NO_PROVIDER_FLAG = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _utils = __webpack_require__(32);

var _config = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NO_PROVIDER_FLAG = 'NO_PROVIDER_FLAG';
exports.NO_PROVIDER_FLAG = NO_PROVIDER_FLAG;

var ScreenClassContext = _react.default.createContext(NO_PROVIDER_FLAG);

exports.ScreenClassContext = ScreenClassContext;

var ScreenClassProvider = function ScreenClassProvider(_ref) {
  var useOwnWidth = _ref.useOwnWidth,
      children = _ref.children,
      fallbackScreenClass = _ref.fallbackScreenClass;
  var screenClassRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  var detectedScreenClass = (0, _utils.useScreenClass)(screenClassRef, fallbackScreenClass);

  var _getConfiguration = (0, _config.getConfiguration)(),
      defaultScreenClass = _getConfiguration.defaultScreenClass;

  var screenClass = mounted ? detectedScreenClass : fallbackScreenClass || defaultScreenClass;
  (0, _react.useEffect)(function () {
    return setMounted(true);
  }, []);
  return _react.default.createElement(ScreenClassContext.Provider, {
    value: screenClass
  }, useOwnWidth ? _react.default.createElement("div", {
    ref: useOwnWidth ? screenClassRef : null
  }, children) : _react.default.createElement(_react.default.Fragment, null, children));
};

ScreenClassProvider.propTypes = {
  /**
   * Children of the ScreenClassProvider.
   * This should be all your child React nodes that are using `react-grid-system`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Boolean to determine whether own width should be used as source.
   * When provided, the screen class is derived from own dimensions instead of the window.
   */
  useOwnWidth: _propTypes.default.bool,

  /**
   * Screen class to use when it cannot be determined otherwise.
   * Useful for server side rendering.
   */
  fallbackScreenClass: _propTypes.default.oneOf([null, 'xs', 'sm', 'md', 'lg', 'xl'])
};
ScreenClassProvider.defaultProps = {
  useOwnWidth: false,
  fallbackScreenClass: null
};
var _default = ScreenClassProvider;
exports.default = _default;

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(157);
var TeamBigLogo=function TeamBigLogo(_ref){var size=_ref.size,margin=_ref.margin,withCursor=_ref.withCursor,alignSelf=_ref.alignSelf,image=_ref.image,isDriver=_ref.isDriver;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* LogoWrapper */],{withCursor:withCursor,size:size,margin:margin,alignSelf:alignSelf,src:image,isDriver:isDriver,onError:function onError(e){e.target.src='https://images2.gazzettaobjects.it/assets-mc/countries/med/noflag.svg';}});};TeamBigLogo.propTypes={size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,withCursor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,alignSelf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isDriver:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (TeamBigLogo);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_entities__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(164);
var Label=function Label(_ref){var label=_ref.label,color=_ref.color,display=_ref.display,size=_ref.size,weight=_ref.weight,margin=_ref.margin,withCursor=_ref.withCursor,lineHeight=_ref.lineHeight,alignSelf=_ref.alignSelf,isTitleNarrowMedium=_ref.isTitleNarrowMedium,fontStyle=_ref.fontStyle,textAlignment=_ref.textAlignment,uppercase=_ref.uppercase,preLabel=_ref.preLabel,isHovered=_ref.isHovered;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* LabelWrapper */],{withCursor:withCursor,color:color,display:display,size:size,weight:weight,margin:margin,lineHeight:lineHeight,alignSelf:alignSelf,isTitleNarrowMedium:isTitleNarrowMedium,fontStyle:fontStyle,textAlignment:textAlignment,uppercase:uppercase,isHovered:isHovered},preLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* PreLabelContainer */],null,preLabel),__WEBPACK_IMPORTED_MODULE_2_entities___default.a.decodeHTML(label));};Label.propTypes={preLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,display:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,weight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,withCursor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,lineHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,alignSelf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isTitleNarrowMedium:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,fontStyle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,textAlignment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,uppercase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isHovered:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  font-size: ','px;\n  ','\n  ','\n  ','\n  \n  color: ',';\n  \n  ',';\n  ',';\n  \n  ','\n  \n  ','\n  font-weight: ',';\n  cursor: ',';\n  padding: 0;\n  line-height: ',';\n  \n\n  ','\n  \n  transform: ',';\n  \n  ','\n\n  ','\n\n  &:before {\n    color: ',';\n    ','\n    ','\n    ',';\n    ',';\n  }\n'],['\n  font-size: ','px;\n  ','\n  ','\n  ','\n  \n  color: ',';\n  \n  ',';\n  ',';\n  \n  ','\n  \n  ','\n  font-weight: ',';\n  cursor: ',';\n  padding: 0;\n  line-height: ',';\n  \n\n  ','\n  \n  transform: ',';\n  \n  ','\n\n  ','\n\n  &:before {\n    color: ',';\n    ','\n    ','\n    ',';\n    ',';\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    margin-right: ',';\n  '],['\n    margin-right: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    margin-left: ',';\n  '],['\n    margin-left: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    margin-top: ',';\n  '],['\n    margin-top: ',';\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    color: ',';\n  '],['\n    color: ',';\n  ']),_templateObject6=_taggedTemplateLiteral(['\n     color: ',';\n  '],['\n     color: ',';\n  ']),_templateObject7=_taggedTemplateLiteral(['\n    color: props.theme.colors.selectedColor;\n  '],['\n    color: props.theme.colors.selectedColor;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n    color: white !important;\n  '],['\n    color: white !important;\n  ']),_templateObject9=_taggedTemplateLiteral(['\n    opacity: ',';\n  '],['\n    opacity: ',';\n  ']),_templateObject10=_taggedTemplateLiteral(['\n    padding: 0;\n  '],['\n    padding: 0;\n  ']),_templateObject11=_taggedTemplateLiteral(['\n    border-bottom: 0 none;\n  '],['\n    border-bottom: 0 none;\n  ']),_templateObject12=_taggedTemplateLiteral(['\n      color: ',';\n    '],['\n      color: ',';\n    ']),_templateObject13=_taggedTemplateLiteral(['\n      color: white !important;\n    '],['\n      color: white !important;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IconFont=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].i(_templateObject,function(props){return props.font;},function(props){return props.marginRight&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,props.marginRight!=='auto'?props.marginRight+'em':props.marginRight);},function(props){return props.marginLeft&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject3,props.marginLeft!=='auto'?props.marginLeft+'em':''+props.marginLeft);},function(props){return props.marginTop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4,props.marginTop!=='auto'?props.marginTop+'em':''+props.marginTop);},function(props){return props.isAvailable?'black':'grey';},function(props){return props.color&&props.color.indexOf('#')!==-1&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject5,props.color);},function(props){return props.color&&props.color.indexOf('#')===-1&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject6,props.theme.colors[props.color]);},function(props){return props.isSelected&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject7);},function(props){return props.isSelectedFavourites&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject8);},function(props){return props.weight?props.weight+' !important':'normal';},function(props){return props.withCursor?'pointer':'default';},function(props){return props.lineHeight?props.lineHeight+' !important':1;},function(props){return props.opacity&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject9,props.opacity);},function(props){return props.rotate?'rotate(180deg)':'rotate(0deg)';},function(props){return props.noPadding&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject10);},function(props){return props.noBottom&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject11);},function(props){return props.isAvailable?'black':'grey';},function(props){return props.isSelected&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject12,props.theme.colors.selectedColor);},function(props){return props.isSelectedFavourites&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject13);},function(props){return props.color&&props.color.indexOf('#')!==-1&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject12,props.color);},function(props){return props.color&&props.color.indexOf('#')===-1&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject12,props.theme.colors[props.color]);});/* harmony default export */ __webpack_exports__["a"] = (IconFont);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57);
module.exports = __webpack_require__(62);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(58).enable();
  window.Promise = __webpack_require__(60);
}

// fetch() polyfill for making API calls.
__webpack_require__(61);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(19);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(33);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(33);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_index_css__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__demo_AppHeader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__demo_store_configureStore__ = __webpack_require__(45);
//← Bridge React and Redux
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_5__demo_store_configureStore__["b" /* store */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__demo_AppHeader__["a" /* default */],null)),document.getElementById('root-header'));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(19),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(19),r=__webpack_require__(65);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(66);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_shallowEqual__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* unused harmony reexport useDispatch */
/* unused harmony reexport createDispatchHook */
/* unused harmony reexport useSelector */
/* unused harmony reexport createSelectorHook */
/* unused harmony reexport useStore */
/* unused harmony reexport createStoreHook */
/* unused harmony reexport shallowEqual */










/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useIsomorphicLayoutEffect__ = __webpack_require__(22);






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var subscription = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* createSubscription */])(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return store.getState();
  }, [store]);
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || __WEBPACK_IMPORTED_MODULE_2__Context__["a" /* ReactReduxContext */];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {
  Provider.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(70);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(73);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(80);


var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, _excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_bindActionCreators__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(38);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_bindActionCreators__["a" /* default */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(38);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(39);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(81);

var _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, _excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(40);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createDispatchHook */
/* unused harmony export useDispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Context__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useStore__ = __webpack_require__(41);


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */];
  }

  var useStore = context === __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useStore__["b" /* useStore */] : Object(__WEBPACK_IMPORTED_MODULE_1__useStore__["a" /* createStoreHook */])(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createSelectorHook */
/* unused harmony export useSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useReduxContext__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Context__ = __webpack_require__(7);






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_Subscription__["a" /* createSubscription */])(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestStoreState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {
      if (!selector) {
        throw new Error("You must pass a selector to useSelector");
      }

      if (typeof selector !== 'function') {
        throw new Error("You must pass a function as a selector to useSelector");
      }

      if (typeof equalityFn !== 'function') {
        throw new Error("You must pass a function as an equality function to useSelector");
      }
    }

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useDebugValue"])(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_configureStore__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_styles_fonts_css__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_styles_fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__lib_styles_fonts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_common_configManager_configManager__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_containers_TeamMainHeader__ = __webpack_require__(133);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import TeamPage from './../lib/containers/TeamPage';
var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={};var _window$matchcenterPa=window.matchcenterPage,sportId=_window$matchcenterPa.sportId,competitionId=_window$matchcenterPa.competitionId,teamId=_window$matchcenterPa.teamId;_this.props.actions.getHeaderInfo(sportId,competitionId,teamId);return _this;}_createClass(App,[{key:'render',value:function render(){var _props=this.props,actions=_props.actions,dictionary=_props.dictionary,headerInfo=_props.headerInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["a" /* ConnectedRouter */],{history:__WEBPACK_IMPORTED_MODULE_5__store_configureStore__["a" /* history */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_8__lib_common_configManager_configManager__["a" /* default */].getRoute('teamPage'),render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__lib_containers_TeamMainHeader__["a" /* default */],{actions:actions,dictionary:dictionary,headerInfo:headerInfo});}})));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);App.propTypes={actions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,dictionary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,/*statistics: PropTypes.any,
  squad: PropTypes.any,
  clubInfo: PropTypes.any,*/headerInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* connect */])(function(state){return{location:state.router.location,dictionary:state.dictionaryReducer.dictionary,statistics:state.statisticsReducer,squad:state.squadReducer.squad,clubInfo:state.clubInfoReducer.clubInfo,headerInfo:state.headerInfoReducer.headerInfo};},function(dispatch){return{actions:{push:function push(url){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["c" /* push */])(url));},updateLocalStorage:function updateLocalStorage(){return dispatch({type:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["I" /* UPDATE_LOCAL_STORAGE */]});},getStandings:function getStandings(sportId,competitionId,teamId){return dispatch({type:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["B" /* GET_STANDINGS_REQUEST */],sportId:sportId,competitionId:competitionId,teamId:teamId});},getLastMatches:function getLastMatches(sportId,teamId,competitionId){return dispatch({type:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["h" /* GET_LAST_MATCHES_REQUEST */],sportId:sportId,teamId:teamId,competitionId:competitionId});},getSquad:function getSquad(sportId,competitionId,teamId){return dispatch({type:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["y" /* GET_SQUAD_REQUEST */],sportId:sportId,competitionId:competitionId,teamId:teamId});},getClubInfo:function getClubInfo(teamId,sportId){return dispatch({type:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["b" /* GET_CLUB_INFO_REQUEST */],sportId:sportId,teamId:teamId});},getHeaderInfo:function getHeaderInfo(sportId,competitionId,teamId){return dispatch({type:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["e" /* GET_HEADER_INFO_REQUEST */],sportId:sportId,teamId:teamId,competitionId:competitionId});}}};})(App));

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isequalwith__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isequalwith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isequalwith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__(44);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }









var createConnectedRouter = function createConnectedRouter(structure) {
  var _createSelectors = Object(__WEBPACK_IMPORTED_MODULE_6__selectors__["a" /* default */])(structure),
      getLocation = _createSelectors.getLocation;
  /*
   * ConnectedRouter listens to a history object passed from props.
   * When history is changed, it dispatches action to redux store.
   * Then, store will pass props to component to render.
   * This creates uni-directional flow from history->store->router->components.
   */


  var ConnectedRouter = /*#__PURE__*/function (_PureComponent) {
    _inherits(ConnectedRouter, _PureComponent);

    var _super = _createSuper(ConnectedRouter);

    function ConnectedRouter(props) {
      var _this;

      _classCallCheck(this, ConnectedRouter);

      _this = _super.call(this, props);
      var store = props.store,
          history = props.history,
          onLocationChanged = props.onLocationChanged,
          stateCompareFunction = props.stateCompareFunction;
      _this.inTimeTravelling = false; // Subscribe to store changes to check if we are in time travelling

      _this.unsubscribe = store.subscribe(function () {
        // Allow time travel debugging compatibility to be turned off
        // as the detection for this (below) is error prone in apps where the
        // store may be unmounted, a navigation occurs, and then the store is re-mounted
        // during the app's lifetime. Detection could be much improved if Redux DevTools
        // simply set a global variable like `REDUX_DEVTOOLS_IS_TIME_TRAVELLING=true`.
        var isTimeTravelDebuggingAllowed = !props.noTimeTravelDebugging; // Extract store's location

        var _getLocation = getLocation(store.getState()),
            pathnameInStore = _getLocation.pathname,
            searchInStore = _getLocation.search,
            hashInStore = _getLocation.hash,
            stateInStore = _getLocation.state; // Extract history's location


        var _history$location = history.location,
            pathnameInHistory = _history$location.pathname,
            searchInHistory = _history$location.search,
            hashInHistory = _history$location.hash,
            stateInHistory = _history$location.state; // If we do time travelling, the location in store is changed but location in history is not changed

        if (isTimeTravelDebuggingAllowed && props.history.action === 'PUSH' && (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore || !__WEBPACK_IMPORTED_MODULE_4_lodash_isequalwith___default()(stateInStore, stateInHistory, stateCompareFunction))) {
          _this.inTimeTravelling = true; // Update history's location to match store's location

          history.push({
            pathname: pathnameInStore,
            search: searchInStore,
            hash: hashInStore,
            state: stateInStore
          });
        }
      });

      var handleLocationChange = function handleLocationChange(location, action) {
        var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        // Dispatch onLocationChanged except when we're in time travelling
        if (!_this.inTimeTravelling) {
          onLocationChanged(location, action, isFirstRendering);
        } else {
          _this.inTimeTravelling = false;
        }
      }; // Listen to history changes


      _this.unlisten = history.listen(handleLocationChange);

      if (!props.noInitialPop) {
        // Dispatch a location change action for the initial location.
        // This makes it backward-compatible with react-router-redux.
        // But, we add `isFirstRendering` to `true` to prevent double-rendering.
        handleLocationChange(history.location, history.action, true);
      }

      return _this;
    }

    _createClass(ConnectedRouter, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unlisten();
        this.unsubscribe();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            omitRouter = _this$props.omitRouter,
            history = _this$props.history,
            children = _this$props.children; // The `omitRouter` option is available for applications that must
        // have a Router instance higher in the component tree but still desire
        // to use connected-react-router for its Redux integration.

        if (omitRouter) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, children);
        }

        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Router */], {
          history: history
        }, children);
      }
    }]);

    return ConnectedRouter;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

  ConnectedRouter.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      getState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      listen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
    onLocationChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    noInitialPop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    noTimeTravelDebugging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    stateCompareFunction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    omitRouter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      onLocationChanged: function onLocationChanged(location, action, isFirstRendering) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* onLocationChanged */])(location, action, isFirstRendering));
      }
    };
  };

  var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
    var Context = props.context || __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* ReactReduxContext */];

    if (Context == null) {
      throw 'Please upgrade to react-redux v6';
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Consumer, null, function (_ref) {
      var store = _ref.store;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedRouter, _extends({
        store: store
      }, props));
    });
  };

  ConnectedRouterWithContext.propTypes = {
    context: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* connect */])(null, mapDispatchToProps)(ConnectedRouterWithContext);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedRouter);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(92)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = isEqualWith;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(94)(module)))

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(16);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/**
 * Adds query to location.
 * Utilises the search prop of location to construct query.
 */

var injectQuery = function injectQuery(location) {
  if (location && location.query) {
    // Don't inject query if it already exists in history
    return location;
  }

  var searchQuery = location && location.search;

  if (typeof searchQuery !== 'string' || searchQuery.length === 0) {
    return _objectSpread({}, location, {
      query: {}
    });
  } // Ignore the `?` part of the search string e.g. ?username=codejockie


  var search = searchQuery.substring(1); // Split the query string on `&` e.g. ?username=codejockie&name=Kennedy

  var queries = search.split('&'); // Contruct query

  var query = queries.reduce(function (acc, currentQuery) {
    // Split on `=`, to get key and value
    var _currentQuery$split = currentQuery.split('='),
        _currentQuery$split2 = _slicedToArray(_currentQuery$split, 2),
        queryKey = _currentQuery$split2[0],
        queryValue = _currentQuery$split2[1];

    return _objectSpread({}, acc, _defineProperty({}, queryKey, queryValue));
  }, {});
  return _objectSpread({}, location, {
    query: query
  });
};

var createConnectRouter = function createConnectRouter(structure) {
  var fromJS = structure.fromJS,
      merge = structure.merge;

  var createRouterReducer = function createRouterReducer(history) {
    var initialRouterState = fromJS({
      location: injectQuery(history.location),
      action: history.action
    });
    /*
    * This reducer will update the state with the most recent location history
    * has transitioned to.
    */

    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          type = _ref.type,
          payload = _ref.payload;

      if (type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* LOCATION_CHANGE */]) {
        var location = payload.location,
            action = payload.action,
            isFirstRendering = payload.isFirstRendering; // Don't update the state ref for the first rendering
        // to prevent the double-rendering issue on initilization

        return isFirstRendering ? state : merge(state, {
          location: fromJS(injectQuery(location)),
          action: action
        });
      }

      return state;
    };
  };

  return createRouterReducer;
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectRouter);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getIn__ = __webpack_require__(97);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var structure = {
  fromJS: function fromJS(value) {
    return value;
  },
  getIn: __WEBPACK_IMPORTED_MODULE_0__getIn__["a" /* default */],
  merge: function merge(state, payload) {
    return _objectSpread({}, state, {}, payload);
  },
  toJS: function toJS(value) {
    return value;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Code from github.com/erikras/redux-form by Erik Rasmussen */
var getIn = function getIn(state, path) {
  if (!state) {
    return state;
  }

  var length = path.length;

  if (!length) {
    return undefined;
  }

  var result = state;

  for (var i = 0; i < length && !!result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(16);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */

var routerMiddleware = function routerMiddleware(history) {
  return function (store) {
    return function (next) {
      return function (action) {
        // eslint-disable-line no-unused-vars
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;
        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (routerMiddleware);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserRouter */
/* unused harmony export HashRouter */
/* unused harmony export Link */
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* unused harmony reexport MemoryRouter */
/* unused harmony reexport Prompt */
/* unused harmony reexport Redirect */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* unused harmony reexport Router */
/* unused harmony reexport StaticRouter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });
/* unused harmony reexport generatePath */
/* unused harmony reexport matchPath */
/* unused harmony reexport useHistory */
/* unused harmony reexport useLocation */
/* unused harmony reexport useParams */
/* unused harmony reexport useRouteMatch */
/* unused harmony reexport withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(28);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  /* eslint-disable-next-line jsx-a11y/anchor-has-content */


  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["d" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var isDuplicateNavigation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(context.location) === Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(normalizeToLocation(location));
        var method = replace || isDuplicateNavigation ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["d" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
    var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;

    if (isActive) {
      className = joinClassnames(className, activeClassName);
      style = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, activeStyle);
    }

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true", "false"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(101);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(102);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(103);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(46);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(17).compose;

exports.__esModule = true;
exports.composeWithDevTools =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : function () {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      };

exports.devToolsEnhancer =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : function () {
        return function (noop) {
          return noop;
        };
      };


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_saga_core__ = __webpack_require__(47);
/* unused harmony namespace reexport */





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__redux_saga_core__["a" /* default */]);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export arrayOfDeferred */
function deferred() {
  var def = {};
  def.promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}
function arrayOfDeferred(length) {
  var arr = [];

  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }

  return arr;
}

/* harmony default export */ __webpack_exports__["a"] = (deferred);



/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__localStorage__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dictionary__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__statistics__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__squad__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clubInfo__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__headerInfo__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lineups__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__probabili__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calendar__ = __webpack_require__(116);
var reducers={localStorageReducer:__WEBPACK_IMPORTED_MODULE_2__localStorage__["a" /* default */],dictionaryReducer:__WEBPACK_IMPORTED_MODULE_3__dictionary__["a" /* default */],statisticsReducer:__WEBPACK_IMPORTED_MODULE_4__statistics__["a" /* default */],squadReducer:__WEBPACK_IMPORTED_MODULE_5__squad__["a" /* default */],clubInfoReducer:__WEBPACK_IMPORTED_MODULE_6__clubInfo__["a" /* default */],headerInfoReducer:__WEBPACK_IMPORTED_MODULE_7__headerInfo__["a" /* default */],lineupsReducer:__WEBPACK_IMPORTED_MODULE_8__lineups__["a" /* default */],probabiliReducer:__WEBPACK_IMPORTED_MODULE_9__probabili__["a" /* default */],teamCalendarReducer:__WEBPACK_IMPORTED_MODULE_10__calendar__["a" /* default */]};var rootReducer=function rootReducer(history){return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])(Object.assign({router:Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["b" /* connectRouter */])(history)},reducers));};/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = localStorageReducer;
//import * as types from '../constants';
var initialState={};function localStorageReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){default:return state;}}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dictionaryReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_common_configManager_configManager__ = __webpack_require__(12);
var initialState={dictionary:__WEBPACK_IMPORTED_MODULE_1__lib_common_configManager_configManager__["a" /* default */].getLanguageDictionary()};function dictionaryReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["H" /* INIT_DICTIONARY */]:return initialState;default:return state;}}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = statisticsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants__ = __webpack_require__(2);
var initialState={standing:{},stats:{},lastMatches:{},tableId:'generalRanking'};function getTeamStats(data,teamId){var teamStat=void 0;if(data.competitionId!=='4'&&data.competitionId!=='5'&&data.competitionId!=='1277'){teamStat=data.contents[0].competitionTeams.filter(function(team){return Number(team.teamId)===teamId;});}else{var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=data.contents[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var group=_step.value;teamStat=group.competitionTeams.filter(function(team){return Number(team.teamId)===teamId;});if(teamStat.length){break;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}return teamStat[0].generalRanking;}function setShootoutScore(lastMatches,sportId){if(sportId.toString()==='1'){lastMatches.contents.forEach(function(round){round.lastMatches.forEach(function(matchContainer){if(matchContainer.match.resultType==='PenaltyShootout'){Object(__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["addShootOutScore"])(matchContainer.match);}});});}return lastMatches;}function setCurrentSquad(data,tId){var lastMatches=data&&data.contents&&data.contents.length>0&&data.contents[0].lastMatches?data.contents[0].lastMatches:[];if(lastMatches.length>0&&lastMatches[0].match){var team=null;var matchInfo=lastMatches[0].match;if(matchInfo&&matchInfo.homeTeam&&matchInfo.homeTeam.teamId&&String(matchInfo.homeTeam.teamId)===String(tId)){team=matchInfo.homeTeam;}if(matchInfo&&matchInfo.awayTeam&&matchInfo.awayTeam.teamId&&String(matchInfo.awayTeam.teamId)===String(tId)){team=matchInfo.awayTeam;}if(team){var _team=team,teamId=_team.teamId,teamName=_team.teamName,teamCode=_team.teamCode;data.currentSquad={teamId:teamId,teamName:teamName,teamCode:teamCode};}}return data;}function updateLastMatches(data,sportId,teamId){setShootoutScore(data,sportId);setCurrentSquad(data,teamId);return data;}function statisticsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["C" /* GET_STANDINGS_SUCCESS */]:return Object.assign({},state,{standing:action.data});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["D" /* GET_STATISTICS */]:return Object.assign({},state,{stats:getTeamStats(action.data,action.teamId)});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["i" /* GET_LAST_MATCHES_SUCCESS */]:return Object.assign({},state,{lastMatches:updateLastMatches(action.data,action.sportId,action.teamId)});default:return state;}}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = squadReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_constants__ = __webpack_require__(2);
var initialState={squad:{}};function squadReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["z" /* GET_SQUAD_SUCCESS */]:return Object.assign({},state,{squad:action.data});default:return state;}}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clubInfoReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_constants__ = __webpack_require__(2);
var initialState={clubInfo:{}};function clubInfoReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["c" /* GET_CLUB_INFO_SUCCESS */]:return Object.assign({},state,{clubInfo:action.data});default:return state;}}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = headerInfoReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_constants__ = __webpack_require__(2);
var initialState={headerInfo:{}};function headerInfoReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["f" /* GET_HEADER_INFO_SUCCESS */]:return Object.assign({},state,{headerInfo:action.data});default:return state;}}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineupsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_constants__ = __webpack_require__(2);
var initialState={lineups:{},matchInfo:{}};function reverseAwayTeam(lineups){var reversedLineups=lineups;if(lineups&&lineups.awayTeam&&lineups.awayTeam.formationModule){var reversedSchema=lineups.awayTeam.formationModule.reverse();Object.assign(reversedLineups.awayTeam.formationModule,reversedSchema);}return reversedLineups;}function setCurrentSquad(matchInfo,tId){var team=null;if(matchInfo&&matchInfo.homeTeam&&matchInfo.homeTeam.teamId&&String(matchInfo.homeTeam.teamId)===String(tId)){team=matchInfo.homeTeam;}if(matchInfo&&matchInfo.awayTeam&&matchInfo.awayTeam.teamId&&String(matchInfo.awayTeam.teamId)===String(tId)){team=matchInfo.awayTeam;}if(team){var _team=team,teamId=_team.teamId,teamName=_team.teamName,teamCode=_team.teamCode;matchInfo.currentSquad={teamId:teamId,teamName:teamName,teamCode:teamCode};}return matchInfo;}function lineupsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["o" /* GET_LINEUPS_SUCCESS */]:return Object.assign({},state,{lineups:reverseAwayTeam(action.data)});case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["l" /* GET_LINEUPS_BASKET_SUCCESS */]:return Object.assign({},state,{lineups:action.data});case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["m" /* GET_LINEUPS_ERROR */]:return state;case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["p" /* GET_MATCHINFO_SUCCESS */]:return Object.assign({},state,{matchInfo:setCurrentSquad(action.matchInfo,action.teamId)});default:return state;}}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = probabiliReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_constants__ = __webpack_require__(2);
var initialState={probabiliMethode:{homeTeam:{},awayTeam:{}},isLineupLoaded:false};function reverseAwayTeam(lineups){var reversedLineups=lineups;if(lineups&&lineups.formationModule){var reversedSchema=lineups.formationModule.reverse();Object.assign(reversedLineups.formationModule,reversedSchema);}return reversedLineups;}function probabiliReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["w" /* GET_PROBABILI_SUCCESS */]:return Object.assign({},state,{probabiliMethode:Object.assign({},state.probabiliMethode,{homeTeam:Object.assign({},state.probabiliMethode.homeTeam,{teamId:action.data.squadHomeId}),awayTeam:Object.assign({},state.probabiliMethode.awayTeam,{teamId:action.data.squadAwayId})})});case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["v" /* GET_PROBABILI_HOME_SUCCESS */]:return Object.assign({},state,{probabiliMethode:Object.assign({},state.probabiliMethode,{homeTeam:Object.assign({},state.probabiliMethode.homeTeam,action.data)})});case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["s" /* GET_PROBABILI_AWAY_SUCCESS */]:return Object.assign({},state,{probabiliMethode:Object.assign({},state.probabiliMethode,{awayTeam:Object.assign({},state.probabiliMethode.awayTeam,reverseAwayTeam(action.data))})});case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["t" /* GET_PROBABILI_HOME_ERROR */]:return Object.assign({},state,{probabili:Object.assign({},state.probabili,{MethodeHome:'error'}),isLineupLoaded:true});case __WEBPACK_IMPORTED_MODULE_0__lib_constants__["q" /* GET_PROBABILI_AWAY_ERROR */]:return Object.assign({},state,{probabili:Object.assign({},state.probabili,{MethodeAway:'error'}),isLineupLoaded:true});default:return state;}}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = teamCalendarReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants__ = __webpack_require__(2);
var initialState={teamCalendar:{}};function setShootoutScore(teamCalendar,sportId){if(sportId.toString()==='1'){var matches=teamCalendar.calendar&&teamCalendar.calendar[0]&&teamCalendar.calendar[0].matches?teamCalendar.calendar[0].matches:[];matches.forEach(function(match){if(match.resultType==='PenaltyShootout'){Object(__WEBPACK_IMPORTED_MODULE_0_rcs_gaz_mc_core_FE__["addShootOutScore"])(match);}});}return teamCalendar;}function setSquad(teamCalendar,tId){var matches=teamCalendar.calendar&&teamCalendar.calendar[0]&&teamCalendar.calendar[0].matches?teamCalendar.calendar[0].matches:[];if(matches.length>0){var matchInfo=matches[0];var team=null;if(matchInfo&&matchInfo.homeTeam&&matchInfo.homeTeam.teamId&&String(matchInfo.homeTeam.teamId)===String(tId)){team=matchInfo.homeTeam;}if(matchInfo&&matchInfo.awayTeam&&matchInfo.awayTeam.teamId&&String(matchInfo.awayTeam.teamId)===String(tId)){team=matchInfo.awayTeam;}var _team=team,teamId=_team.teamId,teamName=_team.teamName,teamCode=_team.teamCode;teamCalendar.currentSquad={teamId:teamId,teamName:teamName,teamCode:teamCode};}return teamCalendar;}function updateTeamCalendar(data,sportId,teamId){setShootoutScore(data,sportId);setSquad(data,teamId);return data;}function teamCalendarReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["G" /* GET_TEAM_CALENDAR_SUCCESS */]:return Object.assign({},state,{teamCalendar:updateTeamCalendar(action.data,action.sportId,action.teamId)});default:return state;}}

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mySaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__statistics__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__squad__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clubInfo__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__headerInfo__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lineups__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__probabili__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__calendar__ = __webpack_require__(131);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(mySaga);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var sagas=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__statistics__["a" /* default */]),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__squad__["a" /* default */]),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_4__clubInfo__["a" /* default */]),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5__headerInfo__["a" /* default */]),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__lineups__["a" /* default */]),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__probabili__["a" /* default */]),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__calendar__["a" /* default */]));function mySaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function mySaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])(sagas.map(function(s){return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(s);}));case 2:case'end':return _context.stop();}}},_marked,this);}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(119);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export debounce */
/* unused harmony export retry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return takeEvery$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return takeLatest$1; });
/* unused harmony export takeLeading */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_saga_symbols__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__ = __webpack_require__(18);
/* unused harmony reexport actionChannel */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["v"]; });
/* unused harmony reexport apply */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["l"]; });
/* unused harmony reexport cancel */
/* unused harmony reexport cancelled */
/* unused harmony reexport cps */
/* unused harmony reexport delay */
/* unused harmony reexport effectTypes */
/* unused harmony reexport flush */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j"]; });
/* unused harmony reexport getContext */
/* unused harmony reexport join */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["u"]; });
/* unused harmony reexport putResolve */
/* unused harmony reexport race */
/* unused harmony reexport select */
/* unused harmony reexport setContext */
/* unused harmony reexport spawn */
/* unused harmony reexport take */
/* unused harmony reexport takeMaybe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_saga_delay_p__ = __webpack_require__(30);







var done = function done(value) {
  return {
    done: true,
    value: value
  };
};

var qEnd = {};
function safeName(patternOrChannel) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["b" /* channel */])(patternOrChannel)) {
    return 'channel';
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["l" /* stringableFunc */])(patternOrChannel)) {
    return String(patternOrChannel);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["d" /* func */])(patternOrChannel)) {
    return patternOrChannel.name;
  }

  return String(patternOrChannel);
}
function fsmIterator(fsm, startState, name) {
  var stateUpdater,
      errorState,
      effect,
      nextState = startState;

  function next(arg, error) {
    if (nextState === qEnd) {
      return done(arg);
    }

    if (error && !errorState) {
      nextState = qEnd;
      throw error;
    } else {
      stateUpdater && stateUpdater(arg);
      var currentState = error ? fsm[errorState](error) : fsm[nextState]();
      nextState = currentState.nextState;
      effect = currentState.effect;
      stateUpdater = currentState.stateUpdater;
      errorState = currentState.errorState;
      return nextState === qEnd ? done(arg) : effect;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["M" /* q */])(next, function (error) {
    return next(null, error);
  }, name);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["i" /* K */])(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j" /* L */].apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yFork(action)
      };
    }
  }, 'q1', "takeEvery(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["i" /* K */])(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j" /* L */].apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yCancel = function yCancel(task) {
    return {
      done: false,
      value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["k" /* M */])(task)
    };
  };

  var task, action;

  var setTask = function setTask(t) {
    return task = t;
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return task ? {
        nextState: 'q3',
        effect: yCancel(task)
      } : {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    },
    q3: function q3() {
      return {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    }
  }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLeading(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["i" /* K */])(patternOrChannel)
  };

  var yCall = function yCall(ac) {
    return {
      done: false,
      value: __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["l" /* N */].apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action;

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yCall(action)
      };
    }
  }, 'q1', "takeLeading(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function throttle(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, channel$1;

  var yTake = function yTake() {
    return {
      done: false,
      value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["i" /* K */])(channel$1)
    };
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j" /* L */].apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yDelay = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["m" /* O */])(delayLength)
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setChannel = function setChannel(ch) {
    return channel$1 = ch;
  };

  var needsChannel = !Object(__WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["b" /* channel */])(patternOrChannel);

  if (!needsChannel) {
    setChannel(patternOrChannel);
  }

  return fsmIterator({
    q1: function q1() {
      var yActionChannel = {
        done: false,
        value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["o" /* Q */])(patternOrChannel, Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["s" /* U */])(1))
      };
      return {
        nextState: 'q2',
        effect: yActionChannel,
        stateUpdater: setChannel
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yTake(),
        stateUpdater: setAction
      };
    },
    q3: function q3() {
      return {
        nextState: 'q4',
        effect: yFork(action)
      };
    },
    q4: function q4() {
      return {
        nextState: 'q2',
        effect: yDelay
      };
    }
  }, needsChannel ? 'q1' : 'q2', "throttle(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function retry(maxTries, delayLength, fn) {
  var counter = maxTries;

  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var yCall = {
    done: false,
    value: __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["l" /* N */].apply(void 0, [fn].concat(args))
  };
  var yDelay = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["m" /* O */])(delayLength)
  };
  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yCall,
        errorState: 'q10'
      };
    },
    q2: function q2() {
      return {
        nextState: qEnd
      };
    },
    q10: function q10(error) {
      counter -= 1;

      if (counter <= 0) {
        throw error;
      }

      return {
        nextState: 'q1',
        effect: yDelay
      };
    }
  }, 'q1', "retry(" + fn.name + ")");
}

function debounceHelper(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, raceOutput;
  var yTake = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["i" /* K */])(patternOrChannel)
  };
  var yRace = {
    done: false,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["t" /* V */])({
      action: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["i" /* K */])(patternOrChannel),
      debounce: Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["m" /* O */])(delayLength)
    })
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j" /* L */].apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yNoop = function yNoop(value) {
    return {
      done: false,
      value: value
    };
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setRaceOutput = function setRaceOutput(ro) {
    return raceOutput = ro;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yRace,
        stateUpdater: setRaceOutput
      };
    },
    q3: function q3() {
      return raceOutput.debounce ? {
        nextState: 'q1',
        effect: yFork(action)
      } : {
        nextState: 'q2',
        effect: yNoop(raceOutput.action),
        stateUpdater: setAction
      };
    }
  }, 'q1', "debounce(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

var validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
  Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["y" /* c */])(patternOrChannel, __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["g" /* notUndef */], fn.name + " requires a pattern or channel");
  Object(__WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["y" /* c */])(worker, __WEBPACK_IMPORTED_MODULE_2__redux_saga_is__["g" /* notUndef */], fn.name + " requires a saga parameter");
};

function takeEvery$1(patternOrChannel, worker) {
  if (false) {
    validateTakeEffect(takeEvery$1, patternOrChannel, worker);
  }

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j" /* L */].apply(void 0, [takeEvery, patternOrChannel, worker].concat(args));
}
function takeLatest$1(patternOrChannel, worker) {
  if (false) {
    validateTakeEffect(takeLatest$1, patternOrChannel, worker);
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j" /* L */].apply(void 0, [takeLatest, patternOrChannel, worker].concat(args));
}
function takeLeading$1(patternOrChannel, worker) {
  if (false) {
    validateTakeEffect(takeLeading$1, patternOrChannel, worker);
  }

  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j" /* L */].apply(void 0, [takeLeading, patternOrChannel, worker].concat(args));
}
function throttle$1(ms, patternOrChannel, worker) {
  if (false) {
    check(patternOrChannel, notUndef, "throttle requires a pattern or channel");
    check(worker, notUndef, 'throttle requires a saga parameter');
  }

  for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
    args[_key4 - 3] = arguments[_key4];
  }

  return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j" /* L */].apply(void 0, [throttle, ms, patternOrChannel, worker].concat(args));
}
function retry$1(maxTries, delayLength, worker) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
    args[_key5 - 3] = arguments[_key5];
  }

  return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["l" /* N */].apply(void 0, [retry, maxTries, delayLength, worker].concat(args));
}
function debounce(delayLength, pattern, worker) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
    args[_key6 - 3] = arguments[_key6];
  }

  return __WEBPACK_IMPORTED_MODULE_3__io_c3792963_js__["j" /* L */].apply(void 0, [debounceHelper, delayLength, pattern, worker].concat(args));
}




/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getStandings),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getLastMatches),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetStandings),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetLastMatches);function getStandings(action){var urlParams,_ref,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getStandings$(_context){while(1){switch(_context.prev=_context.next){case 0:urlParams={competitionId:action.competitionId,sportId:action.sportId,teamId:action.teamId};_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["a" /* apiWithUrlParams */],'competitionData','getStandings',urlParams);case 4:_ref=_context.sent;data=_ref.data;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["D" /* GET_STATISTICS */],data:data,teamId:action.teamId});case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["C" /* GET_STANDINGS_SUCCESS */],data:data});case 10:_context.next=16;break;case 12:_context.prev=12;_context.t0=_context['catch'](1);_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["A" /* GET_STANDINGS_ERROR */],error:_context.t0});case 16:case'end':return _context.stop();}}},_marked,this,[[1,12]]);}function getLastMatches(action){var urlParams,_ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getLastMatches$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:urlParams={sportId:action.sportId,teamId:action.teamId,competitionId:action.competitionId};_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["a" /* apiWithUrlParams */],'competitionData','getLastMatches',urlParams);case 4:_ref2=_context2.sent;data=_ref2.data;_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["i" /* GET_LAST_MATCHES_SUCCESS */],data:data,sportId:action.sportId,teamId:action.teamId});case 8:_context2.next=14;break;case 10:_context2.prev=10;_context2.t0=_context2['catch'](1);_context2.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["g" /* GET_LAST_MATCHES_ERROR */],error:_context2.t0});case 14:case'end':return _context2.stop();}}},_marked2,this,[[1,10]]);}function watchGetStandings(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetStandings$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__lib_constants__["B" /* GET_STANDINGS_REQUEST */],getStandings);case 2:case'end':return _context3.stop();}}},_marked3,this);}function watchGetLastMatches(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetLastMatches$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__lib_constants__["h" /* GET_LAST_MATCHES_REQUEST */],getLastMatches);case 2:case'end':return _context4.stop();}}},_marked4,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetStandings,watchGetLastMatches]);

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(123);
module.exports = self.fetch.bind(self);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
/* eslint-disable no-prototype-builtins */
var g =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  // eslint-disable-next-line no-undef
  (typeof global !== 'undefined' && global) ||
  {}

var support = {
  searchParams: 'URLSearchParams' in g,
  iterable: 'Symbol' in g && 'iterator' in Symbol,
  blob:
    'FileReader' in g &&
    'Blob' in g &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in g,
  arrayBuffer: 'ArrayBuffer' in g
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      if (header.length != 2) {
        throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
      }
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body._noBody) return
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type)
  var encoding = match ? match[1] : 'utf-8'
  reader.readAsText(blob, encoding)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    // eslint-disable-next-line no-self-assign
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._noBody = true;
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }
  }

  this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var isConsumed = consumed(this)
      if (isConsumed) {
        return isConsumed
      } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
        return Promise.resolve(
          this._bodyArrayBuffer.buffer.slice(
            this._bodyArrayBuffer.byteOffset,
            this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
          )
        )
      } else {
        return Promise.resolve(this._bodyArrayBuffer)
      }
    } else if (support.blob) {
      return this.blob().then(readBlobAsArrayBuffer)
    } else {
      throw new Error('could not read as ArrayBuffer')
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal || (function () {
    if ('AbortController' in g) {
      var ctrl = new AbortController();
      return ctrl.signal;
    }
  }());
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        try {
          headers.append(key, value)
        } catch (error) {
          console.warn('Response ' + error.message)
        }
      }
    })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  if (this.status < 200 || this.status > 599) {
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
  }
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 200, statusText: ''})
  response.status = 0
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = g.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      // This check if specifically for when a user fetches a file locally from the file system
      // Only if the status is out of a normal range
      if (request.url.startsWith('file://') && (xhr.status < 200 || xhr.status > 599)) {
        options.status = 200;
      } else {
        options.status = xhr.status;
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request timed out'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && g.location.href ? g.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob'
      } else if (
        support.arrayBuffer
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
      var names = [];
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        names.push(normalizeName(name))
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]))
      })
      request.headers.forEach(function(value, name) {
        if (names.indexOf(name) === -1) {
          xhr.setRequestHeader(name, value)
        }
      })
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!g.fetch) {
  g.fetch = fetch
  g.Headers = Headers
  g.Request = Request
  g.Response = Response
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getStandings),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetStandings);function getStandings(action){var urlParams,_ref,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getStandings$(_context){while(1){switch(_context.prev=_context.next){case 0:urlParams={competitionId:action.competitionId,sportId:action.sportId,teamId:action.teamId};_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["a" /* apiWithUrlParams */],'competitionData','getSquad',urlParams);case 4:_ref=_context.sent;data=_ref.data;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["z" /* GET_SQUAD_SUCCESS */],data:data});case 8:_context.next=14;break;case 10:_context.prev=10;_context.t0=_context['catch'](1);_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["x" /* GET_SQUAD_ERROR */],error:_context.t0});case 14:case'end':return _context.stop();}}},_marked,this,[[1,10]]);}function watchGetStandings(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetStandings$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__lib_constants__["y" /* GET_SQUAD_REQUEST */],getStandings);case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetStandings]);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getClubInfo),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetClubInfo);function getClubInfo(action){var urlParams,_ref,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getClubInfo$(_context){while(1){switch(_context.prev=_context.next){case 0:urlParams={teamId:action.teamId,sportId:action.sportId};_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["a" /* apiWithUrlParams */],'teamData','getClubInfo',urlParams);case 4:_ref=_context.sent;data=_ref.data;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["c" /* GET_CLUB_INFO_SUCCESS */],data:data});case 8:_context.next=14;break;case 10:_context.prev=10;_context.t0=_context['catch'](1);_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["a" /* GET_CLUB_INFO_ERROR */],error:_context.t0});case 14:case'end':return _context.stop();}}},_marked,this,[[1,10]]);}function watchGetClubInfo(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetClubInfo$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__lib_constants__["b" /* GET_CLUB_INFO_REQUEST */],getClubInfo);case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetClubInfo]);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getHeaderInfo),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetHeaderInfo);function getHeaderInfo(action){var urlParams,_ref,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getHeaderInfo$(_context){while(1){switch(_context.prev=_context.next){case 0:urlParams={teamId:action.teamId,sportId:action.sportId,competitionId:action.competitionId};_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["a" /* apiWithUrlParams */],'teamData','getHeaderInfo',urlParams);case 4:_ref=_context.sent;data=_ref.data;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["f" /* GET_HEADER_INFO_SUCCESS */],data:data});case 8:_context.next=14;break;case 10:_context.prev=10;_context.t0=_context['catch'](1);_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["d" /* GET_HEADER_INFO_ERROR */],error:_context.t0});case 14:case'end':return _context.stop();}}},_marked,this,[[1,10]]);}function watchGetHeaderInfo(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetHeaderInfo$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__lib_constants__["e" /* GET_HEADER_INFO_REQUEST */],getHeaderInfo);case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetHeaderInfo]);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getBasketLineups),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProb),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getLineups),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetLineups),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetBasketLineups);var isCountDown=function isCountDown(date){var start=new Date(date).getTime();var now=Date.now();var timeDiff=start-now;if(timeDiff<0){return-1;}else if(timeDiff<=3600000){return 1;}return 0;};function getBasketLineups(action){var urlParams,_ref,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getBasketLineups$(_context){while(1){switch(_context.prev=_context.next){case 0:urlParams={sportId:action.sportId,competitionId:action.competitionId,matchId:action.matchId};_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["a" /* apiWithUrlParams */],'match','getLineups',urlParams);case 4:_ref=_context.sent;data=_ref.data;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["l" /* GET_LINEUPS_BASKET_SUCCESS */],data:data});case 8:_context.next=14;break;case 10:_context.prev=10;_context.t0=_context['catch'](1);_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["j" /* GET_LINEUPS_BASKET_ERROR */],error:_context.t0});case 14:case'end':return _context.stop();}}},_marked,this,[[1,10]]);}function getProb(action){var competitionId,matchInfo,squadHomeId,squadAwayId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProb$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:competitionId=action.competitionId,matchInfo=action.matchInfo;// squadHome = (matchInfo.homeTeam.teamName).toLowerCase().replace(' ', '-');
//const squadAway = (matchInfo.awayTeam.teamName).toLowerCase().replace(' ', '-');
squadHomeId=matchInfo.homeTeam.teamId;squadAwayId=matchInfo.awayTeam.teamId;_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["u" /* GET_PROBABILI_HOME_REQUEST */],squad:squadHomeId,competitionId:competitionId}),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["r" /* GET_PROBABILI_AWAY_REQUEST */],squad:squadAwayId,competitionId:competitionId}),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["w" /* GET_PROBABILI_SUCCESS */],data:{squadHomeId:squadHomeId,squadAwayId:squadAwayId}})]);case 5:case'end':return _context2.stop();}}},_marked2,this);}function getLineups(action){var urlParams,callXml,matchInfo,matchUrlParams,_ref2,data,competitionId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getLineups$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:urlParams={teamId:action.teamId,sportId:action.sportId,competitionId:action.competitionId,version:'v2'};_context3.prev=1;callXml=true;_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["a" /* apiWithUrlParams */],'widgets','getNextMatch',urlParams);case 5:matchInfo=_context3.sent;matchInfo=matchInfo.data;_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["p" /* GET_MATCHINFO_SUCCESS */],matchInfo:matchInfo,teamId:action.teamId});case 9:if(!(isCountDown(matchInfo.date)!==0)){_context3.next=19;break;}matchUrlParams={sportId:urlParams.sportId,competitionId:urlParams.competitionId,matchId:matchInfo.matchId};_context3.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["a" /* apiWithUrlParams */],'match','getLineups',matchUrlParams);case 13:_ref2=_context3.sent;data=_ref2.data;if(!data.homeTeam){_context3.next=19;break;}callXml=false;_context3.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["o" /* GET_LINEUPS_SUCCESS */],data:data});case 19:if(!callXml){_context3.next=25;break;}competitionId=urlParams.competitionId;_context3.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["o" /* GET_LINEUPS_SUCCESS */],data:{}});case 23:_context3.next=25;return getProb({competitionId:competitionId,matchInfo:matchInfo});case 25:_context3.next=33;break;case 27:_context3.prev=27;_context3.t0=_context3['catch'](1);_context3.next=31;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["m" /* GET_LINEUPS_ERROR */],error:_context3.t0});case 31:_context3.next=33;return getProb(action);case 33:case'end':return _context3.stop();}}},_marked3,this,[[1,27]]);}function watchGetLineups(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetLineups$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__lib_constants__["n" /* GET_LINEUPS_REQUEST */],getLineups);case 2:case'end':return _context4.stop();}}},_marked4,this);}function watchGetBasketLineups(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetBasketLineups$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__lib_constants__["k" /* GET_LINEUPS_BASKET_REQUEST */],getBasketLineups);case 2:case'end':return _context5.stop();}}},_marked5,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetLineups,watchGetBasketLineups]);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_common_formationSchemas_formationSchemas__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_teamMap_teamMap__ = __webpack_require__(130);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProbabiliMethodeHome),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProbabiliMethodeAway),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetProbabiliMethodeHome),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetProbabiliMethodeAway);function buildFormationSchema(lineUpPlayers,formationModule){var formationObject=__WEBPACK_IMPORTED_MODULE_3__lib_common_formationSchemas_formationSchemas__["a" /* default */].find(function(schema){return schema.formation===formationModule;});var newFormationObject=JSON.parse(JSON.stringify(formationObject));var formationSchema='';if(newFormationObject){formationSchema=newFormationObject.formationSchema||'';var indice=0;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=formationSchema.entries()[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ref=_step.value;var _ref2=_slicedToArray(_ref,2);var rowIndex=_ref2[0];var row=_ref2[1];var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=row.entries()[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _ref3=_step2.value;var _ref4=_slicedToArray(_ref3,2);var cellIndex=_ref4[0];var cell=_ref4[1];if(cell.content){var pObj=lineUpPlayers[indice];cell.content=pObj;row[cellIndex]=cell;indice+=1;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}formationSchema[rowIndex]=row;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}return formationSchema;}function iterateAttributes(attributes,obj){for(var j=0;j<attributes.length;j+=1){var attribute=attributes.item(j);var attributeName=attribute.nodeName;if(attributeName==='number'){attributeName='jerseyNumber';}obj[attributeName]=attribute.nodeValue;}return obj;}function iterateItem(item){var obj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!item.hasChildNodes()){return obj;}var itemName=item.nodeName==='calciatore'?'playerName':item.nodeName;// Handle leaf nodes (text content)
if(item.childNodes.length===1&&item.childNodes[0].nodeType===Node.TEXT_NODE){obj[itemName]=item.childNodes[0].nodeValue;return obj;}// Handle nodes with children
var arrNew=[];item.childNodes.forEach(function(itemInner){var objNew={};if(itemInner.attributes&&itemInner.attributes.length>0){objNew=iterateAttributes(itemInner.attributes,objNew);}objNew=iterateItem(itemInner,objNew);// Only push non-empty objects
if(Object.keys(objNew).length>0){arrNew.push(objNew);}});if(arrNew.length>0){obj[itemName]=arrNew;}return obj;}function stringToObj(value){if(typeof value==='string'){return{officialName:value};}return value;}function probabileFormazione(xml){var pf=xml.getElementsByTagName('probabile_formazione');var obj={};var pf_child=pf[0].childNodes;pf_child.forEach(function(item){obj=iterateItem(item,obj);});var modulo=obj.modulo.replace(/-/g,'');var ret_obj={};ret_obj.formationModule=buildFormationSchema(obj.titolari,modulo);ret_obj.formationSchema=modulo;//ret_obj.mainPlayers = obj.titolari;
ret_obj.benchPlayers=obj.panchina;ret_obj.unavailablePlayers=obj.indisponibili;ret_obj.suspendedPlayers=obj.squalificati?obj.squalificati:[{playerName:'nessuno'}];ret_obj.warnedPlayers=obj.diffidati?obj.diffidati:[{playerName:'nessuno'}];ret_obj.otherPlayers=obj.altri?obj.altri:[{playerName:'nessuno'}];ret_obj.ballotPlayers=obj.ballottaggi?obj.ballottaggi:[{playerName:'nessuno'}];ret_obj.otherPlayers=obj.altri?obj.altri:[{playerName:'nessuno'}];ret_obj.official=stringToObj(obj.allenatore);ret_obj.teamName=obj.squadra;return ret_obj;}function getProbabiliMethodeHome(action){var urlParams,data,xmlDOM,parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProbabiliMethodeHome$(_context){while(1){switch(_context.prev=_context.next){case 0:urlParams={squad:action.squad,competitionId:action.competitionId};if(__WEBPACK_IMPORTED_MODULE_5__lib_utils_teamMap_teamMap__["a" /* default */][urlParams.squad])urlParams.squad=__WEBPACK_IMPORTED_MODULE_5__lib_utils_teamMap_teamMap__["a" /* default */][urlParams.squad];_context.prev=2;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["b" /* probabiliApi */],'probabiliMethode','getProbabiliMethode',urlParams);case 5:data=_context.sent;data=data.replace(/(\r\n|\n|\r)/gm,'');xmlDOM=new DOMParser().parseFromString(data,'text/xml');parsed=probabileFormazione(xmlDOM);_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4__lib_constants__["v" /* GET_PROBABILI_HOME_SUCCESS */],data:parsed});case 11:_context.next=17;break;case 13:_context.prev=13;_context.t0=_context['catch'](2);_context.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4__lib_constants__["t" /* GET_PROBABILI_HOME_ERROR */],error:_context.t0});case 17:return _context.abrupt('return',false);case 18:case'end':return _context.stop();}}},_marked,this,[[2,13]]);}function getProbabiliMethodeAway(action){var urlParams,data,xmlDOM,parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProbabiliMethodeAway$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:urlParams={squad:action.squad,competitionId:action.competitionId};_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["b" /* probabiliApi */],'probabiliMethode','getProbabiliMethode',urlParams);case 4:data=_context2.sent;data=data.replace(/(\r\n|\n|\r)/gm,'');xmlDOM=new DOMParser().parseFromString(data,'text/xml');parsed=probabileFormazione(xmlDOM);_context2.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4__lib_constants__["s" /* GET_PROBABILI_AWAY_SUCCESS */],data:parsed});case 10:_context2.next=16;break;case 12:_context2.prev=12;_context2.t0=_context2['catch'](1);_context2.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4__lib_constants__["q" /* GET_PROBABILI_AWAY_ERROR */],error:_context2.t0});case 16:return _context2.abrupt('return',false);case 17:case'end':return _context2.stop();}}},_marked2,this,[[1,12]]);}function watchGetProbabiliMethodeHome(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetProbabiliMethodeHome$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__lib_constants__["u" /* GET_PROBABILI_HOME_REQUEST */],getProbabiliMethodeHome);case 2:case'end':return _context3.stop();}}},_marked3,this);}function watchGetProbabiliMethodeAway(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetProbabiliMethodeAway$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__lib_constants__["r" /* GET_PROBABILI_AWAY_REQUEST */],getProbabiliMethodeAway);case 2:case'end':return _context4.stop();}}},_marked4,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetProbabiliMethodeHome,watchGetProbabiliMethodeAway]);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formationSchemas=[{id:'2',formation:'442',orderSchema:['1','2','5','6','3','7','4','8','11','10','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'3',content:'7'},{span:'2',content:'4'},{span:'2',content:null},{span:'2',content:'8'},{span:'3',content:'11'}],[{span:'4',content:null},{span:'2',content:'10'},{span:'2',content:'9'},{span:'4',content:null}]]},{id:'3',formation:'41212',orderSchema:['1','2','5','6','3','4','7','11','8','10','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'3',content:null},{span:'6',content:'4'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'7'},{span:'2',content:null},{span:'3',content:'11'},{span:'2',content:null}],[{span:'3',content:null},{span:'6',content:'8'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'10'},{span:'2',content:null},{span:'3',content:'9'},{span:'2',content:null}]]},{id:'4',formation:'433',orderSchema:['1','2','5','6','3','7','4','8','10','9','11'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'1',content:null},{span:'4',content:'7'},{span:'2',content:'4'},{span:'4',content:'8'},{span:'1',content:null}],[{span:'2',content:null},{span:'3',content:'10'},{span:'2',content:'9'},{span:'3',content:'11'},{span:'2',content:null}]]},{id:'5',formation:'451',orderSchema:['1','2','5','6','3','4','10','8','7','11','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'2',content:'7'},{span:'3',content:'4'},{span:'2',content:'10'},{span:'3',content:'8'},{span:'2',content:'11'}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'6',formation:'4411',orderSchema:['1','2','5','6','3','7','4','8','11','10','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'1',content:null},{span:'3',content:'7'},{span:'2',content:'4'},{span:'2',content:'8'},{span:'3',content:'11'},{span:'1',content:null}],[{span:'3',content:null},{span:'6',content:'10'},{span:'3',content:null}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'7',formation:'4141',orderSchema:['1','2','5','6','3','4','7','8','10','11','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'3',content:null},{span:'6',content:'4'},{span:'3',content:null}],[{span:'3',content:'7'},{span:'2',content:'8'},{span:'2',content:null},{span:'2',content:'10'},{span:'3',content:'11'}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'8',formation:'4231',orderSchema:['1','2','5','6','3','8','4','7','10','11','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'4',content:null},{span:'2',content:'8'},{span:'2',content:'4'},{span:'4',content:null}],[{span:'2',content:null},{span:'3',content:'7'},{span:'2',content:'10'},{span:'3',content:'11'},{span:'2',content:null}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'9',formation:'4321',orderSchema:['1','2','5','6','3','8','4','7','10','11','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'2',content:null},{span:'3',content:'8'},{span:'2',content:'4'},{span:'3',content:'7'},{span:'2',content:null}],[{span:'4',content:null},{span:'2',content:'10'},{span:'2',content:'11'},{span:'4',content:null}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'10',formation:'532',orderSchema:['1','2','6','5','4','3','7','8','11','10','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:'2'},{span:'3',content:'6'},{span:'2',content:'5'},{span:'3',content:'4'},{span:'2',content:'3'}],[{span:'1',content:null},{span:'4',content:'7'},{span:'2',content:'8'},{span:'4',content:'11'},{span:'1',content:null}],[{span:'2',content:null},{span:'4',content:'10'},{span:'4',content:'9'},{span:'2',content:null}]]},{id:'11',formation:'541',orderSchema:['1','2','6','5','4','3','7','8','10','11','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:'2'},{span:'3',content:'6'},{span:'2',content:'5'},{span:'3',content:'4'},{span:'2',content:'3'}],[{span:'1',content:null},{span:'3',content:'7'},{span:'2',content:'8'},{span:'2',content:'10'},{span:'3',content:'11'},{span:'1',content:null}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'12',formation:'352',orderSchema:['1','6','5','4','7','11','8','2','3','10','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'6'},{span:'2',content:'5'},{span:'3',content:'4'},{span:'2',content:null}],[{span:'2',content:'2'},{span:'3',content:'7'},{span:'2',content:'11'},{span:'3',content:'8'},{span:'2',content:'3'}],[{span:'4',content:null},{span:'2',content:'10'},{span:'2',content:'9'},{span:'4',content:null}]]},{id:'13',formation:'343',orderSchema:['1','6','5','4','2','7','8','3','10','9','11'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'6'},{span:'2',content:'5'},{span:'3',content:'4'},{span:'2',content:null}],[{span:'1',content:null},{span:'3',content:'2'},{span:'2',content:'7'},{span:'2',content:'8'},{span:'3',content:'3'},{span:'1',content:null}],[{span:'2',content:null},{span:'3',content:'10'},{span:'2',content:'9'},{span:'3',content:'11'},{span:'2',content:null}]]},{id:'15',formation:'4222',orderSchema:['1','2','5','6','3','4','8','7','11','10','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'3',content:'5'},{span:'3',content:'6'},{span:'3',content:'3'}],[{span:'2',content:null},{span:'4',content:'4'},{span:'4',content:'8'},{span:'2',content:null}],[{span:'3',content:'7'},{span:'6',content:null},{span:'3',content:'11'}],[{span:'2',content:null},{span:'4',content:'10'},{span:'4',content:'9'},{span:'2',content:null}]]},{id:'16',formation:'3511',orderSchema:['1','6','5','4','7','11','8','2','3','10','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'6'},{span:'2',content:'5'},{span:'3',content:'4'},{span:'2',content:null}],[{span:'2',content:'2'},{span:'3',content:'7'},{span:'2',content:'11'},{span:'3',content:'8'},{span:'2',content:'3'}],[{span:'3',content:null},{span:'6',content:'10'},{span:'3',content:null}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'17',formation:'3421',orderSchema:['1','6','5','4','2','7','8','3','10','11','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'6'},{span:'2',content:'5'},{span:'3',content:'4'},{span:'2',content:null}],[{span:'3',content:'2'},{span:'2',content:'7'},{span:'2',content:null},{span:'2',content:'8'},{span:'3',content:'3'}],[{span:'4',content:null},{span:'2',content:'10'},{span:'2',content:'11'},{span:'4',content:null}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'18',formation:'3412',orderSchema:['1','6','5','4','2','7','8','3','9','10','11'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'6'},{span:'2',content:'5'},{span:'3',content:'4'},{span:'2',content:null}],[{span:'1',content:null},{span:'3',content:'2'},{span:'2',content:'7'},{span:'2',content:'8'},{span:'3',content:'3'},{span:'1',content:null}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}],[{span:'4',content:null},{span:'2',content:'10'},{span:'2',content:'11'},{span:'4',content:null}]]},{id:'19',formation:'3142',orderSchema:['1','5','4','6','8','2','7','11','3','9','10'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'5'},{span:'2',content:'4'},{span:'3',content:'6'},{span:'2',content:null}],[{span:'3',content:null},{span:'6',content:'8'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'7'},{span:'2',content:null},{span:'2',content:'11'},{span:'3',content:'3'}],[{span:'4',content:null},{span:'2',content:'9'},{span:'2',content:'10'},{span:'4',content:null}]]},{id:'20',formation:'343d',orderSchema:['1','6','5','4','8','2','3','7','10','9','11'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'4',content:'6'},{span:'4',content:'5'},{span:'4',content:'4'}],[{span:'3',content:null},{span:'6',content:'8'},{span:'3',content:null}],[{span:'4',content:'2'},{span:'2',content:null},{span:'4',content:'3'}],[{span:'3',content:null},{span:'6',content:'7'},{span:'3',content:null}],[{span:'4',content:'10'},{span:'4',content:'9'},{span:'4',content:'11'}]]},{id:'21',formation:'4132',orderSchema:['1','2','5','6','3','4','7','8','11','9','10'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'3',content:null},{span:'6',content:'4'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'7'},{span:'2',content:'8'},{span:'3',content:'11'},{span:'2',content:null}],[{span:'4',content:null},{span:'2',content:'9'},{span:'2',content:'10'},{span:'4',content:null}]]},{id:'22',formation:'4240',orderSchema:['1','2','5','6','3','4','8','7','9','10','11'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'4',content:null},{span:'2',content:'4'},{span:'2',content:'8'},{span:'4',content:null}],[{span:'1',content:null},{span:'3',content:'7'},{span:'2',content:'9'},{span:'2',content:'10'},{span:'3',content:'11'},{span:'1',content:null}]]},{id:'23',formation:'4312',orderSchema:['1','2','5','6','3','7','4','11','8','9','10'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'2',content:null},{span:'3',content:'7'},{span:'2',content:'4'},{span:'3',content:'11'},{span:'2',content:null}],[{span:'3',content:null},{span:'6',content:'8'},{span:'3',content:null}],[{span:'4',content:null},{span:'2',content:'9'},{span:'2',content:'10'},{span:'4',content:null}]]},{id:'24',formation:'3241',orderSchema:['1','6','5','4','2','3','10','7','8','11','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:null},{span:'3',content:'6'},{span:'2',content:'5'},{span:'3',content:'4'},{span:'2',content:null}],[{span:'4',content:null},{span:'2',content:'2'},{span:'2',content:'3'},{span:'4',content:null}],[{span:'3',content:'10'},{span:'2',content:'7'},{span:'2',content:null},{span:'2',content:'8'},{span:'3',content:'11'}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'25',formation:'3331',orderSchema:['1','6','5','4','2','8','3','10','7','11','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'4',content:'6'},{span:'4',content:'5'},{span:'4',content:'4'}],[{span:'2',content:null},{span:'3',content:'2'},{span:'2',content:'8'},{span:'3',content:'3'},{span:'2',content:null}],[{span:'3',content:'10'},{span:'2',content:null},{span:'2',content:'7'},{span:'2',content:null},{span:'3',content:'11'}],[{span:'3',content:null},{span:'6',content:'9'},{span:'3',content:null}]]},{id:'26',formation:'424',orderSchema:['1','2','5','6','3','4','8','7','9','10','11'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'3',content:'2'},{span:'2',content:'5'},{span:'2',content:null},{span:'2',content:'6'},{span:'3',content:'3'}],[{span:'4',content:null},{span:'2',content:'4'},{span:'2',content:'8'},{span:'4',content:null}],[{span:'1',content:null},{span:'3',content:'7'},{span:'2',content:'9'},{span:'2',content:'10'},{span:'3',content:'11'},{span:'1',content:null}]]},{id:'27',formation:'523',orderSchema:['1','2','6','5','4','3','7','8','11','10','9'],formationSchema:[[{span:'3',content:null},{span:'6',content:'1'},{span:'3',content:null}],[{span:'2',content:'2'},{span:'3',content:'6'},{span:'2',content:'5'},{span:'3',content:'4'},{span:'2',content:'3'}],[{span:'4',content:null},{span:'2',content:'7'},{span:'2',content:'8'},{span:'4',content:null}],[{span:'2',content:null},{span:'3',content:'10'},{span:'2',content:'9'},{span:'3',content:'11'},{span:'2',content:null}]]}];/* harmony default export */ __webpack_exports__["a"] = (formationSchemas);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return teamsNameMapping; });
var teamsNameMapping={'hellas-verona':'verona'};

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getTeamCalendar),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetTeamCalendar);function getTeamCalendar(action){var urlParams,_ref,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getTeamCalendar$(_context){while(1){switch(_context.prev=_context.next){case 0:urlParams={teamId:action.teamId,sportId:action.sportId,seasonId:action.seasonId};_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__lib_apiMiddleware_apiMiddleware__["a" /* apiWithUrlParams */],'teamData','getTeamCalendar',urlParams);case 4:_ref=_context.sent;data=_ref.data;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["G" /* GET_TEAM_CALENDAR_SUCCESS */],data:data,sportId:action.sportId,teamId:action.teamId});case 8:_context.next=14;break;case 10:_context.prev=10;_context.t0=_context['catch'](1);_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["E" /* GET_TEAM_CALENDAR_ERROR */],error:_context.t0});case 14:case'end':return _context.stop();}}},_marked,this,[[1,10]]);}function watchGetTeamCalendar(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetTeamCalendar$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__lib_constants__["F" /* GET_TEAM_CALENDAR_REQUEST */],getTeamCalendar);case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetTeamCalendar]);

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_theme__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MatchWidget_styles__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TeamHeader__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DriverHeader__ = __webpack_require__(165);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//eslint-disable-line
var TeamMainHeader=function(_Component){_inherits(TeamMainHeader,_Component);function TeamMainHeader(props){_classCallCheck(this,TeamMainHeader);var _this=_possibleConstructorReturn(this,(TeamMainHeader.__proto__||Object.getPrototypeOf(TeamMainHeader)).call(this,props));_this.getChildContext=function(){return{breakpoints:_this.dynamicBreakPoint("gazzetta")};};_this.dynamicBreakPoint=function(site){if(site==='gazzetta'){return[320,599,1024,1440];}else if(site==='fcinter'||site==='forzaroma'){return[767,767,980,1440];}else if(site==='corriere'){return[320,767,767,1440];}else{return[320,599,1024,1440];}};_this.resizeCallback=function(){_this.setState({isMobile:window.innerWidth<=_this.dynamicBreakPointWindow("gazzetta")});};_this.dynamicBreakPointWindow=function(site){if(site==='gazzetta'){return 1023;}else if(site==='fcinter'||site==='forzaroma'){return 980;}else if(site==='corriere'){return 767;}else{return 1023;}};_this.state={isMobile:_this.props.device!=='desktop'};_this.theme=Object.assign({},__WEBPACK_IMPORTED_MODULE_3_theme__["a" /* default */]);return _this;}_createClass(TeamMainHeader,[{key:'componentDidMount',value:function componentDidMount(){this.resizeCallback();window.addEventListener('resize',this.resizeCallback);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.resizeCallback);}},{key:'render',value:function render(){var _props=this.props,actions=_props.actions,dictionary=_props.dictionary,headerInfo=_props.headerInfo;var _window$matchcenterPa=window.matchcenterPage,sportId=_window$matchcenterPa.sportId,competitionId=_window$matchcenterPa.competitionId;var isMobile=this.state.isMobile;var showNextMatch=true;var isSoccer=sportId===1||sportId==='1';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeProvider */],{theme:this.theme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,isSoccer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_MatchWidget_styles__["b" /* MainHeaderWrapper */],{className:'TeamHeaderWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_TeamHeader__["a" /* default */],{actions:actions,isMobile:isMobile,headerInfo:headerInfo,dictionary:dictionary.header}),showNextMatch&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_MatchWidget_styles__["a" /* HeaderShadow */],{isMobile:isMobile,className:'HeaderShadow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'matchcenter-widget','data-widgettype':'NextMatchWidget',id:'nextMatch','data-teamid':window.matchcenterPage.teamId,'data-sportid':window.matchcenterPage.sportId}))),(sportId==='6M'||sportId==='6C')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_DriverHeader__["a" /* default */],{isMobile:isMobile,headerInfo:headerInfo,dictionary:dictionary.raceCompetitionLink,competitionId:competitionId,sportId:sportId,newspaper:"gazzetta"})));}}]);return TeamMainHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TeamMainHeader.childContextTypes={breakpoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number)};TeamMainHeader.propTypes={actions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,dictionary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,headerInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,device:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (TeamMainHeader);

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 135 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPropValid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(139);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);




/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return memoize; });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mediaQueries__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fonts__ = __webpack_require__(143);
// Theme (styled-components)




var theme = {
  colors: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */],
  mediaQueries: __WEBPACK_IMPORTED_MODULE_1__mediaQueries__["a" /* default */],
  fontSets: __WEBPACK_IMPORTED_MODULE_2__fonts__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (theme);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var colors = {
  transparent: 'transparent',
  mainColor: 'rgb(253,233,235)',
  mainColorDark: 'rgb(236, 166, 173)',
  white: 'rgb(255,255,255)',
  orange: 'rgb(244, 119, 2)',
  black: 'rgb(0,0,0)',
  gray: 'rgb(128,128,128)',
  gray2: 'rgb(136,136,136)',
  lightGray: 'rgb(199,199,199)',
  darkGray: 'rgb(51,51,51)',
  mediumDarkGray: 'rgb(233,213,214)',
  darkerGray: 'rgb(76,76,76)',
  darkestGray: 'rgb(34,34,34)',
  moreDarkestGray: 'rgb(21,21,21)',
  grayMenu: 'rgb(153,153,153)',
  lighterGray: 'rgb(112,112,112)',
  lightPink: 'rgb(252, 151, 150);',
  lightBlue: 'rgb(166,221,242)',
  lightYellow: 'rgb(251, 220, 149)',
  yellow: 'rgb(255,217,42)',
  red: 'rgb(218,9,12)',
  lightOrange: 'rgb(245,135,51)',
  darkRed: 'rgb(165,6,10)',
  whiteRed: 'rgb(237,77,79)',
  green: 'rgb(0,150,64)',
  blackBrown: 'rgb(27, 16, 4)',
  blue: 'rgb(13, 49 ,174)',
  linkColor: 'rgb(242, 120, 0)',
  mainFontColor: 'rgb(0,0,0)',
  dropDownLiveHub: 'rgb(242, 120, 0)',
  selectedColor: 'rgb(242, 120, 0)',
  liveColor: 'rgb(242, 120, 0)',
  buttonColor: 'rgb(242, 120, 0)',
  statsInCompetitionColor: 'rgb(199,199,199)',
  statsInCompetitionFontColor: 'rgb(128,128,128)',
  teamCalendarLastColor: 'rgb(255, 209, 182)',

  /* Social Colors */
  TwitterColor: 'rgb(0,172,237)',
  TwitterDarkColor: 'rgb(0,138,190)',
  FacebookColor: 'rgb(50,89,152)',
  FacebookDarkColor: 'rgb(47,71,122)',
  GoogleColor: 'rgb(207,62,44)',
  GoogleDarkColor: 'rgb(166,50,35)',
  FlickrColor: 'rgb(238,238,238)',
  FlickrBlueColor: 'rgb(0,99,220)',
  FlickrPinkColor: 'rgb(255,0,132)',
  FlickrDarkColor: 'rgb(190,190,190)',
  RssColor: 'rgb(245,121,0)',
  RssDarkColor: 'rgb(196,97,0)'
};

/* harmony default export */ __webpack_exports__["a"] = (colors);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mediaQueries = {
  small_phone: '@media (max-width: 320px)',
  phone: '@media (max-width: 599px)',
  phone_landscape: '@media (max-width: 767px) and (orientation: landscape)',
  phone_tablet: '@media (max-width: 1023px)',
  tablet: '@media (min-width: 600px) and (max-width: 1023px)',
  tablet_landscape: '@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)',
  tablet_up: '@media (min-width: 768px)',
  tablet_big_up: '@media (min-width: 992px)',
  tablet_big_down: '@media (max-width: 1023px)',
  small_desktop: '@media (min-width: 1025px) and (max-width: 1280px)',
  small_desktop_tablet: '@media (min-width: 992px) and (max-width: 1280px)',
  small_desktop_down: '@media (max-width: 1280px)',
  small_desktop_up: '@media (min-width: 1281px)',
  desktop: '@media (min-width: 1025px)',
  big_desktop: '@media (min-width: 1408px)',
  from_tablet_to_desktop: '@media (min-width: 1024px) and (max-width: 1439px)'
};

/* harmony default export */ __webpack_exports__["a"] = (mediaQueries);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var fontSets = {
  iconFont: 'IconFont',
  condensedMedium: '"RobotoCondensed-Bold", Arial',
  condenseBold: '"RobotoCondensed-Bold", Arial',
  narrow: '"Roboto-Regular", Arial',
  narrowBold: '"Roboto-Bold", Arial',
  narrowMedium: '"Roboto-Bold", Arial',
  narrowRegular: '"Roboto-Regular", Arial'
};

/* harmony default export */ __webpack_exports__["a"] = (fontSets);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MainHeaderWrapper; });
/* unused harmony export MatchWidgetWrapper */
/* unused harmony export NextMatchWrapper */
/* unused harmony export DataMatchWrapper */
/* unused harmony export DataMatchWrapperPoint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderShadow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  margin-bottom: 35px;\n  ','{\n    margin-bottom: 45px;\n  };\n  ','{\n    padding: 0px;\n  };\n'],['\n  position: relative;\n  margin-bottom: 35px;\n  ','{\n    margin-bottom: 45px;\n  };\n  ','{\n    padding: 0px;\n  };\n']),_templateObject2=_taggedTemplateLiteral(['\n  text-align: center;\n  margin-top: -126px;\n  z-index: 900;\n  position: relative;\n  ','{\n    top: 85px;\n  };\n'],['\n  text-align: center;\n  margin-top: -126px;\n  z-index: 900;\n  position: relative;\n  ','{\n    top: 85px;\n  };\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 420px;\n  display: block;\n  text-align: center;\n  margin: auto;\n  //box-shadow: 0 -11px 18px -4px rgba(0,0,0,0.3);\n  border-bottom: 28px solid ',';\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  height: 0;\n  border-radius: 13px 13px 5px 5px;\n'],['\n  width: 100%;\n  max-width: 420px;\n  display: block;\n  text-align: center;\n  margin: auto;\n  //box-shadow: 0 -11px 18px -4px rgba(0,0,0,0.3);\n  border-bottom: 28px solid ',';\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  height: 0;\n  border-radius: 13px 13px 5px 5px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  max-width: 420px;\n  margin: -3px auto 5px auto;\n  border-top: 1px solid ',';\n  padding-top: 5px;\n  font-family: ',';\n  ','{\n    margin: auto;\n    padding: 5px;\n    justify-content: space-around;\n    border: 1px solid ',';\n  };\n'],['\n  display: flex;\n  justify-content: space-between;\n  max-width: 420px;\n  margin: -3px auto 5px auto;\n  border-top: 1px solid ',';\n  padding-top: 5px;\n  font-family: ',';\n  ','{\n    margin: auto;\n    padding: 5px;\n    justify-content: space-around;\n    border: 1px solid ',';\n  };\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  ','{\n    flex-direction: column;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  ','{\n    flex-direction: column;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n    position: absolute;\n    top: ',';\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n'],['\n    position: absolute;\n    top: ',';\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MainHeaderWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.theme.mediaQueries.tablet_big_down;},function(props){return props.theme.mediaQueries.phone;});var MatchWidgetWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.theme.mediaQueries.tablet_big_down;});var NextMatchWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(props){return props.theme.colors.mainColor;});var DataMatchWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.theme.colors.lightGray;},function(props){return props.theme.fontSets.narrowRegular;},function(props){return props.theme.mediaQueries.tablet_big_down;},function(props){return props.theme.colors.lightGray;});var DataMatchWrapperPoint=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,function(props){return props.theme.mediaQueries.tablet_big_down;});var HeaderShadow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject6,function(props){return props.isMobile?'195px':'137px';});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_grid_system__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_grid_system___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_TeamBigLogo__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_Label__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_configManager_configManager__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_IconFont__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Import MyGazzettaFollow from '../../components/MyGazzettaFollow';
var TeamHeader=function(_Component){_inherits(TeamHeader,_Component);function TeamHeader(props){_classCallCheck(this,TeamHeader);var _this=_possibleConstructorReturn(this,(TeamHeader.__proto__||Object.getPrototypeOf(TeamHeader)).call(this,props));_this.state={};return _this;}_createClass(TeamHeader,[{key:'render',value:function render(){var _props=this.props,headerInfo=_props.headerInfo,dictionary=_props.dictionary,isMobile=_props.isMobile;var teamsImageUrl=__WEBPACK_IMPORTED_MODULE_6__common_configManager_configManager__["a" /* default */].getFootballTeams('high');var isGazzetta=function isGazzetta(){return "gazzetta"==='gazzetta';};//const isSerieA = () => (Number(headerInfo.competitionId)) === 21;
var isNewsTab=function isNewsTab(){return window.section_lev3&&window.section_lev3==='notizie';};var mapTeamName=function mapTeamName(teamName){switch(teamName){case'Internazionale':return'Inter';case'Napoli':return'Napoli Calcio';case'Roma':return'AS Roma';case'Los Angeles Football Club':return'Los Angeles FC';default:return teamName;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'flex',justifyContent:'flex-start',margin:'10px 0px 0px 15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-back-arrow',color:'black',font:26,onClick:function onClick(){return window.history.back(-1);},withCursor:true,marginLeft:isMobile?0.3:0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{lg:12,md:12,sm:12,style:{overflow:'visible'}},headerInfo&&headerInfo.teamName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* HeaderWrapper */],{className:''+mapTeamName(headerInfo.teamName).toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_TeamBigLogo__["a" /* default */],{image:''+teamsImageUrl+headerInfo.teamId+'.png'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{lg:6,md:8,sm:12,xs:12,offset:{lg:3,md:2,sm:0,xs:0},style:{justifyContent:'center',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* CentralWrapper */],null,isNewsTab()&&isGazzetta()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* TeamNameH1 */],{isMobile:isMobile},mapTeamName(headerInfo.teamName)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* TeamName */],{isMobile:isMobile},mapTeamName(headerInfo.teamName)),headerInfo&&Number(headerInfo.competitionId)!==4&&Number(headerInfo.competitionId)!==88&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* CentralInternalWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:dictionary[headerInfo.competitionId]+' '+(headerInfo.competitionId==='3'||headerInfo.competitionId==='1277'?'':headerInfo.formatSeason),size:isMobile?1:1.1,color:'white',isTitleNarrowMedium:true,uppercase:true}),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:'|',size:isMobile?0.85:1.1,color:'white',isTitleNarrowRegular:true,margin:isMobile?'0em 0 0':'0em 0 0 0.2em'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:''+dictionary.standings+headerInfo.rankingPosition,size:isMobile?0.85:1.1,color:'white',isTitleNarrowRegular:true,margin:isMobile?'0em 0 0':'0em 0 0 0.2em'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{lg:3,md:2,sm:2,xs:2}))));}}]);return TeamHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TeamHeader.propTypes={headerInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,dictionary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (TeamHeader);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _style = _interopRequireDefault(__webpack_require__(147));

var _config = __webpack_require__(11);

var _Row = __webpack_require__(49);

var _ScreenClassResolver = _interopRequireDefault(__webpack_require__(13));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Col = function Col(_ref) {
  var children = _ref.children,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      offset = _ref.offset,
      pull = _ref.pull,
      push = _ref.push,
      debug = _ref.debug,
      style = _ref.style,
      component = _ref.component,
      width = _ref.width,
      otherProps = _objectWithoutProperties(_ref, ["children", "xs", "sm", "md", "lg", "xl", "offset", "pull", "push", "debug", "style", "component", "width"]);

  return _react.default.createElement(_ScreenClassResolver.default, null, function (screenClass) {
    return _react.default.createElement(_Row.GutterWidthContext.Consumer, null, function (gutterWidth) {
      var theStyle = (0, _style.default)({
        forceWidth: width,
        width: {
          xs: xs,
          sm: sm,
          md: md,
          lg: lg,
          xl: xl
        },
        offset: offset,
        pull: pull,
        push: push,
        debug: debug,
        screenClass: screenClass,
        gutterWidth: gutterWidth,
        gridColumns: (0, _config.getConfiguration)().gridColumns,
        moreStyle: style
      });
      return (0, _react.createElement)(component, _objectSpread({
        style: theStyle
      }, otherProps, {
        children: children
      }));
    });
  });
};

Col.propTypes = {
  /**
   * Content of the column
   */
  children: _propTypes.default.node,

  /**
   * The width of the column for screenclass `xs`, either a number between 0 and 12, or "content"
   */
  xs: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['content'])]),

  /**
   * The width of the column for screenclass `sm`, either a number between 0 and 12, or "content"
   */
  sm: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['content'])]),

  /**
   * The width of the column for screenclass `md`, either a number between 0 and 12, or "content"
   */
  md: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['content'])]),

  /**
   * The width of the column for screenclass `lg`, either a number between 0 and 12, or "content"
   */
  lg: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['content'])]),

  /**
   * The width of the column for screenclass `xl`, either a number between 0 and 12, or "content"
   */
  xl: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['content'])]),

  /**
   * A fixed width of the column for all screenclasses"
   */
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The offset of this column for all screenclasses
   */
  offset: _propTypes.default.shape({
    xs: _propTypes.default.number,
    sm: _propTypes.default.number,
    md: _propTypes.default.number,
    lg: _propTypes.default.number,
    xl: _propTypes.default.number
  }),

  /**
   * The amount this column is pushed to the right for all screenclasses
   */
  push: _propTypes.default.shape({
    xs: _propTypes.default.number,
    sm: _propTypes.default.number,
    md: _propTypes.default.number,
    lg: _propTypes.default.number,
    xl: _propTypes.default.number
  }),

  /**
   * The amount this column is pulled to the left for all screenclasses
   */
  pull: _propTypes.default.shape({
    xs: _propTypes.default.number,
    sm: _propTypes.default.number,
    md: _propTypes.default.number,
    lg: _propTypes.default.number,
    xl: _propTypes.default.number
  }),

  /**
   * Optional styling
   */
  style: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])),

  /**
   * Set to apply some debug styling
   */
  debug: _propTypes.default.bool,

  /**
   * Use your own component
   */
  component: _propTypes.default.elementType
};
Col.defaultProps = {
  children: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  width: null,
  offset: {},
  push: {},
  pull: {},
  style: {},
  debug: false,
  component: 'div'
};
var _default = Col;
exports.default = _default;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = __webpack_require__(32);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var hasWidth = function hasWidth(widths) {
  return Object.keys(widths).reduce(function (acc, cur) {
    return acc || widths[cur];
  }, false);
};

var getWidth = function getWidth(width, gridColumns) {
  if (typeof width !== 'number') return undefined;
  var normalizedWidth = Math.max(0, Math.min(gridColumns, width));
  return "".concat(100 / gridColumns * normalizedWidth, "%");
};

var _default = function _default(_ref) {
  var _ref$forceWidth = _ref.forceWidth,
      forceWidth = _ref$forceWidth === void 0 ? null : _ref$forceWidth,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? {} : _ref$width,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? {} : _ref$offset,
      _ref$pull = _ref.pull,
      pull = _ref$pull === void 0 ? {} : _ref$pull,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? {} : _ref$push,
      debug = _ref.debug,
      screenClass = _ref.screenClass,
      gutterWidth = _ref.gutterWidth,
      moreStyle = _ref.moreStyle,
      gridColumns = _ref.gridColumns;
  var styles = {
    boxSizing: 'border-box',
    minHeight: '1px',
    position: 'relative',
    paddingLeft: "".concat(gutterWidth / 2, "px"),
    paddingRight: "".concat(gutterWidth / 2, "px"),
    width: '100%'
  };

  if (debug) {
    styles.outline = '1px solid silver';
    styles.background = 'rgba(0,0,0,.05)';
    styles.lineHeight = '32px';
  }

  styles.flexBasis = '100%';
  styles.flexGrow = 0;
  styles.flexShrink = 0;
  styles.maxWidth = '100%';
  styles.marginLeft = '0%';
  styles.right = 'auto';
  styles.left = 'auto';

  _utils.screenClasses.forEach(function (size, index) {
    if (_utils.screenClasses.indexOf(screenClass) >= index) {
      var currentWidth = getWidth(width[size], gridColumns);
      var isSizedToContent = width[size] === 'content';
      styles.flexBasis = isSizedToContent ? 'auto' : currentWidth || styles.flexBasis;
      styles.width = styles.flexBasis;
      styles.maxWidth = currentWidth || styles.maxWidth;
      styles.marginLeft = getWidth(offset[size], gridColumns) || styles.marginLeft;
      styles.right = getWidth(pull[size], gridColumns) || styles.right;
      styles.left = getWidth(push[size], gridColumns) || styles.left;
    }
  });

  if (!hasWidth(width)) {
    styles.flexBasis = 0;
    styles.flexGrow = 1;
  }

  if (forceWidth) {
    styles.flex = 'unset';
    styles.width = forceWidth;
  }

  return _objectSpread({}, styles, {}, moreStyle);
};

exports.default = _default;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(_ref) {
  var gutterWidth = _ref.gutterWidth,
      align = _ref.align,
      justify = _ref.justify,
      debug = _ref.debug,
      moreStyle = _ref.moreStyle,
      nowrap = _ref.nowrap;
  // Vertical alignment
  var alignItems = align;
  if (align === 'start') alignItems = 'flex-start';
  if (align === 'end') alignItems = 'flex-end'; // Horizontal alignment

  var justifyContent = justify;
  if (justify === 'start') justifyContent = 'flex-start';
  if (justify === 'end') justifyContent = 'flex-end';
  if (justify === 'between') justifyContent = 'space-between';
  if (justify === 'around') justifyContent = 'space-around';
  if (justify === 'center') justifyContent = 'center';
  if (justify === 'initial') justifyContent = 'initial';
  if (justify === 'inherit') justifyContent = 'inherit';
  var styles = {
    marginLeft: "-".concat(gutterWidth / 2, "px"),
    marginRight: "-".concat(gutterWidth / 2, "px"),
    display: 'flex',
    flexWrap: nowrap ? 'nowrap' : 'wrap',
    flexGrow: 0,
    flexShrink: 0,
    alignItems: alignItems,
    justifyContent: justifyContent
  };

  if (debug) {
    styles.background = 'rgba(128,128,128,.05)';
  }

  return _objectSpread({}, styles, {}, moreStyle);
};

exports.default = _default;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _style = _interopRequireWildcard(__webpack_require__(150));

var _config = __webpack_require__(11);

var _ScreenClassResolver = _interopRequireDefault(__webpack_require__(13));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = function Container(_ref) {
  var children = _ref.children,
      fluid = _ref.fluid,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      style = _ref.style,
      component = _ref.component,
      otherProps = _objectWithoutProperties(_ref, ["children", "fluid", "xs", "sm", "md", "lg", "xl", "style", "component"]);

  return _react.default.createElement(_ScreenClassResolver.default, null, function (screenClass) {
    return (0, _react.createElement)(component, _objectSpread({
      style: (0, _style.default)({
        fluid: fluid,
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,
        screenClass: screenClass,
        containerWidths: (0, _config.getConfiguration)().containerWidths,
        gutterWidth: (0, _config.getConfiguration)().gutterWidth,
        moreStyle: style
      })
    }, otherProps), _react.default.createElement(_react.default.Fragment, null, children, _react.default.createElement("span", {
      style: (0, _style.getAfterStyle)()
    })));
  });
};

Container.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes.default.node.isRequired,

  /**
   * True makes the container full-width, false fixed-width
   */
  fluid: _propTypes.default.bool,

  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in xs, not present means fluid everywhere
   */
  xs: _propTypes.default.bool,

  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in sm, not present means fluid everywhere
   */
  sm: _propTypes.default.bool,

  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in md, not present means fluid everywhere
   */
  md: _propTypes.default.bool,

  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in lg, not present means fluid everywhere
   */
  lg: _propTypes.default.bool,

  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in xl, not present means fluid everywhere
   */
  xl: _propTypes.default.bool,

  /**
   * Optional styling
   */
  style: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])),

  /**
   * Use your own component
   */
  component: _propTypes.default.elementType
};
Container.defaultProps = {
  fluid: false,
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  style: {},
  component: 'div'
};
var _default = Container;
exports.default = _default;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAfterStyle = exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(_ref) {
  var fluid = _ref.fluid,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      screenClass = _ref.screenClass,
      containerWidths = _ref.containerWidths,
      gutterWidth = _ref.gutterWidth,
      moreStyle = _ref.moreStyle;
  var styles = {
    boxSizing: 'border-box',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: "".concat(gutterWidth / 2, "px"),
    paddingRight: "".concat(gutterWidth / 2, "px")
  };

  if (fluid && !sm && !md && !lg && !xl) {
    return _objectSpread({}, styles, {}, moreStyle);
  }

  if (screenClass === 'sm' && containerWidths[0] && !sm && !xs) {
    styles.maxWidth = "".concat(containerWidths[0], "px");
  }

  if (screenClass === 'md' && containerWidths[1] && !md) {
    styles.maxWidth = "".concat(containerWidths[1], "px");
  }

  if (screenClass === 'lg' && containerWidths[2] && !lg) {
    styles.maxWidth = "".concat(containerWidths[2], "px");
  }

  if (screenClass === 'xl' && containerWidths[3] && !xl) {
    styles.maxWidth = "".concat(containerWidths[3], "px");
  }

  return _objectSpread({}, styles, {}, moreStyle);
};

exports.default = _default;

var getAfterStyle = function getAfterStyle() {
  return {
    display: 'table',
    clear: 'both'
  };
};

exports.getAfterStyle = getAfterStyle;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var style = _interopRequireWildcard(__webpack_require__(152));

var _ScreenClassResolver = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hidden = function Hidden(_ref) {
  var children = _ref.children,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;
  return _react.default.createElement(_ScreenClassResolver.default, null, function (screenClass) {
    return style.hidden({
      screenClass: screenClass,
      xs: xs,
      sm: sm,
      md: md,
      lg: lg,
      xl: xl
    }) ? null : children;
  });
};

Hidden.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Hide on extra small devices
   */
  xs: _propTypes.default.bool,

  /**
   * Hide on small devices
   */
  sm: _propTypes.default.bool,

  /**
   * Hide on medium devices
   */
  md: _propTypes.default.bool,

  /**
   * Hide on large devices
   */
  lg: _propTypes.default.bool,

  /**
   * Hide on xlarge devices
   */
  xl: _propTypes.default.bool
};
Hidden.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false
};
var _default = Hidden;
exports.default = _default;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.hidden = void 0;

var hidden = function hidden(_ref) {
  var screenClass = _ref.screenClass,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;
  if (screenClass === 'xl') return xl;
  if (screenClass === 'lg') return lg;
  if (screenClass === 'md') return md;
  if (screenClass === 'sm') return sm;
  return xs;
};

exports.hidden = hidden;
var _default = hidden;
exports.default = _default;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var style = _interopRequireWildcard(__webpack_require__(154));

var _ScreenClassResolver = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Visible = function Visible(_ref) {
  var children = _ref.children,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;
  return _react.default.createElement(_ScreenClassResolver.default, null, function (screenClass) {
    return !style.visible({
      screenClass: screenClass,
      xs: xs,
      sm: sm,
      md: md,
      lg: lg,
      xl: xl
    }) ? null : children;
  });
};

Visible.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Show on extra small devices
   */
  xs: _propTypes.default.bool,

  /**
   * Show on small devices
   */
  sm: _propTypes.default.bool,

  /**
   * Show on medium devices
   */
  md: _propTypes.default.bool,

  /**
   * Show on large devices
   */
  lg: _propTypes.default.bool,

  /**
   * Show on xl devices
   */
  xl: _propTypes.default.bool
};
Visible.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false
};
var _default = Visible;
exports.default = _default;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.visible = void 0;

var visible = function visible(_ref) {
  var screenClass = _ref.screenClass,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;
  if (screenClass === 'xl') return xl;
  if (screenClass === 'lg') return lg;
  if (screenClass === 'md') return md;
  if (screenClass === 'sm') return sm;
  return xs;
};

exports.visible = visible;
var _default = visible;
exports.default = _default;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _ScreenClassResolver = _interopRequireDefault(__webpack_require__(13));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScreenClassRender = function ScreenClassRender(_ref) {
  var render = _ref.render;
  return _react.default.createElement(_ScreenClassResolver.default, null, function (screenClass) {
    return render(screenClass);
  });
};

ScreenClassRender.propTypes = {
  /**
   * The function which return value will be rendered.
   * Will be called with one argument: the screen class.
   */
  render: _propTypes.default.func.isRequired
};
var _default = ScreenClassRender;
exports.default = _default;

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HeaderWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CentralWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CentralInternalWrapper; });
/* unused harmony export BookmarkWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TeamName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TeamNameH1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  min-height: 137px;\n  margin: 20px 0 55px;\n  overflow: visible;\n  background-color: #999999;\n    &.pisa {\n        background-color: #0073BC;\n    }\n    &.cremonese {\n        background-color: #D80900FF;\n    }\n    &.salernitana {\n        background-color: #841716;\n    }\n    &.lecce {\n        background-color: #096086;\n    }\n    &.monza {\n        background-color: #e4022e;\n    }\n    &.torino {\n        background-color: rgb(108,27,21);\n    }\n    &.napoli {\n        background-color: #5097d4;\n    }\n    &.atalanta {\n        background-color: #0071BD;\n    }\n    &.benevento {\n        background-color: #FFF001;\n    }\n    &.bologna {\n        background-color: #282D95;\n    }\n    &.cagliari {\n        background-color: #B30622;\n    }\n    &.chievo {\n        background-color: #1E3C94;\n    }\n    &.crotone {\n        background-color: #CC0001;\n    }\n    &.fiorentina {\n        background-color: #420096;\n    }\n    &.genoa {\n        background-color: #DA2A35;\n    }\n    &.inter {\n        background-color: #0e4d8d;\n    }\n    &.juventus {\n        background-color: #5e5e5e;\n    }\n    &.lazio {\n        background-color: #87D8F7;\n    }\n    &.milan {\n        background-color: #EC0002;\n    }\n    &.roma {\n        background-color: #8C2B1A;\n    }\n    &.sampdoria {\n        background-color: #008ED6;\n    }\n    &.sassuolo {\n        background-color: #107B33;\n    }\n    &.parma{\n        background-color: #e3c804;\n    }\n    &.empoli{\n        background-color: #117ef8;\n    }\n    &.frosinone{\n        background-color: #f8c411;\n    }\n    &.spal {\n        background-color: #0093ED;\n    }\n    &.udinese {\n        background-color: #666666;\n    }\n    &.verona {\n        background-color: #F1D142;\n    }\n    &.arabia {\n        background-color: #73AF00 !important;\n    }\n    &.algeria {\n        background-color: #09a14a !important;\n    }\n    &.argentina {\n        background-color: #9bcde7 !important;\n    }\n    &.australia {\n        background-color: #ffbf00 !important;\n    }\n    &.belgio {\n        background-color: #ff0000 !important;\n    }\n    &.bosnia-erzeg {\n        background-color: #275498 !important;\n    }\n    &.brasile {\n        background-color: #f0c948 !important;\n    }\n    &.camerun {\n        background-color: #004e2f !important;\n    }\n    &.cile {\n        background-color: #ff0000 !important;\n    }\n    &.colombia {\n        background-color: #dfb802 !important;\n    }\n    &.corea-del-sud, &.corea.sud {\n        background-color: #ee1111 !important;\n    }\n    &.costa-davorio {\n        background-color: #ff8a15 !important;\n    }\n    &.costa-rica, &.costa.rica {\n        background-color: #ff0000 !important;\n    }\n    &.croazia {\n        background-color: #c01619 !important;\n    }\n    &.egitto {\n        background-color: #FF4B55 !important;\n    }\n    &.ecuador {\n        background-color: #ffdd00 !important;\n    }\n    &.francia {\n        background-color: #0e428f !important;\n    }\n    &.germania {\n        background-color: #80a272 !important;\n    }\n    &.ghana {\n        background-color: #ffbf00 !important;\n    }\n    &.giappone {\n        background-color: #000040 !important;\n    }\n    &.grecia {\n        background-color: #0000be !important;\n    }\n    &.honduras {\n        background-color: #0073cf !important;\n    }\n    &.inghilterra {\n        background-color: #FF4B55 !important;\n    }\n    &.iran {\n        background-color: #dd0000 !important;\n    }\n    &.italia {\n        background-color: #005dab !important;\n    }\n    &.messico {\n        background-color: #008032 !important;\n    }\n    &.nigeria {\n        background-color: #008000 !important;\n    }\n    &.olanda {\n        background-color: #ff6600 !important;\n    }\n    &.danimarca {\n        background-color: #FF4B55 !important;\n    }\n    &.marocco {\n        background-color: #FF4B55 !important;\n    }\n    &.panama {\n        background-color: #FF4B55 !important;\n    }\n    &.per\xF9 {\n        background-color: #FF4B55 !important;\n    }\n    &.portogallo {\n        background-color: #ff0000 !important;\n    }\n    &.russia {\n        background-color: #ff0000 !important;\n    }\n    &.spagna {\n        background-color: #e3000b !important;\n    }\n    &.senegal {\n        background-color: #FFE15A !important;\n    }\n    &.serbia {\n        background-color: #41479B !important;\n    }\n    &.svizzera {\n        background-color: #ff0000 !important;\n    }\n    &.stati-uniti {\n        background-color: #ff0000 !important;\n    }\n    &.uruguay {\n        background-color: #4b8cc1 !important;\n    }\n    &.romania {\n        background-color: #1F5987 !important;\n    }\n    &.albania {\n        background-color: #1F5987 !important;\n    }\n    &.russia {\n        background-color: #1F5987 !important;\n    }\n    &.slovacchia {\n        background-color: #1F5987 !important;\n    }\n    &.ucraina {\n        background-color: #1F5987 !important;\n    }\n    &.polonia {\n        background-color: #1F5987 !important;\n    }\n    &.irlanda-del-nord {\n        background-color: #1F5987 !important;\n    }\n    &.galles {\n        background-color: #1F5987 !important;\n    }\n    &.rep-ceca {\n        background-color: #1F5987 !important;\n    }\n    &.turchia {\n        background-color: #1F5987 !important;\n    }\n    &.tunisia {\n        background-color: #FF4B55 !important;\n    }\n    &.irlanda {\n        background-color: #1F5987 !important;\n    }\n    &.svezia {\n        background-color: #1F5987 !important;\n    }\n    &.islanda {\n        background-color: #1F5987 !important;\n    }\n    &.austria {\n        background-color: #1F5987 !important;\n    }\n    &.ungheria {\n        background-color: #1F5987 !important;\n    }\n    background-image: url("https://images2.gazzettaobjects.it/assets-mc/bkg/shadow-bg.png");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    image-rendering: auto;\n    image-rendering: crisp-edges;\n    ','{\n        min-height: 170px;\n        margin: 30px 0 30px;\n        background-size: auto;\n        background-position: top;\n    }\n'],['\n  display: flex;\n  flex-direction: row;\n  min-height: 137px;\n  margin: 20px 0 55px;\n  overflow: visible;\n  background-color: #999999;\n    &.pisa {\n        background-color: #0073BC;\n    }\n    &.cremonese {\n        background-color: #D80900FF;\n    }\n    &.salernitana {\n        background-color: #841716;\n    }\n    &.lecce {\n        background-color: #096086;\n    }\n    &.monza {\n        background-color: #e4022e;\n    }\n    &.torino {\n        background-color: rgb(108,27,21);\n    }\n    &.napoli {\n        background-color: #5097d4;\n    }\n    &.atalanta {\n        background-color: #0071BD;\n    }\n    &.benevento {\n        background-color: #FFF001;\n    }\n    &.bologna {\n        background-color: #282D95;\n    }\n    &.cagliari {\n        background-color: #B30622;\n    }\n    &.chievo {\n        background-color: #1E3C94;\n    }\n    &.crotone {\n        background-color: #CC0001;\n    }\n    &.fiorentina {\n        background-color: #420096;\n    }\n    &.genoa {\n        background-color: #DA2A35;\n    }\n    &.inter {\n        background-color: #0e4d8d;\n    }\n    &.juventus {\n        background-color: #5e5e5e;\n    }\n    &.lazio {\n        background-color: #87D8F7;\n    }\n    &.milan {\n        background-color: #EC0002;\n    }\n    &.roma {\n        background-color: #8C2B1A;\n    }\n    &.sampdoria {\n        background-color: #008ED6;\n    }\n    &.sassuolo {\n        background-color: #107B33;\n    }\n    &.parma{\n        background-color: #e3c804;\n    }\n    &.empoli{\n        background-color: #117ef8;\n    }\n    &.frosinone{\n        background-color: #f8c411;\n    }\n    &.spal {\n        background-color: #0093ED;\n    }\n    &.udinese {\n        background-color: #666666;\n    }\n    &.verona {\n        background-color: #F1D142;\n    }\n    &.arabia {\n        background-color: #73AF00 !important;\n    }\n    &.algeria {\n        background-color: #09a14a !important;\n    }\n    &.argentina {\n        background-color: #9bcde7 !important;\n    }\n    &.australia {\n        background-color: #ffbf00 !important;\n    }\n    &.belgio {\n        background-color: #ff0000 !important;\n    }\n    &.bosnia-erzeg {\n        background-color: #275498 !important;\n    }\n    &.brasile {\n        background-color: #f0c948 !important;\n    }\n    &.camerun {\n        background-color: #004e2f !important;\n    }\n    &.cile {\n        background-color: #ff0000 !important;\n    }\n    &.colombia {\n        background-color: #dfb802 !important;\n    }\n    &.corea-del-sud, &.corea.sud {\n        background-color: #ee1111 !important;\n    }\n    &.costa-davorio {\n        background-color: #ff8a15 !important;\n    }\n    &.costa-rica, &.costa.rica {\n        background-color: #ff0000 !important;\n    }\n    &.croazia {\n        background-color: #c01619 !important;\n    }\n    &.egitto {\n        background-color: #FF4B55 !important;\n    }\n    &.ecuador {\n        background-color: #ffdd00 !important;\n    }\n    &.francia {\n        background-color: #0e428f !important;\n    }\n    &.germania {\n        background-color: #80a272 !important;\n    }\n    &.ghana {\n        background-color: #ffbf00 !important;\n    }\n    &.giappone {\n        background-color: #000040 !important;\n    }\n    &.grecia {\n        background-color: #0000be !important;\n    }\n    &.honduras {\n        background-color: #0073cf !important;\n    }\n    &.inghilterra {\n        background-color: #FF4B55 !important;\n    }\n    &.iran {\n        background-color: #dd0000 !important;\n    }\n    &.italia {\n        background-color: #005dab !important;\n    }\n    &.messico {\n        background-color: #008032 !important;\n    }\n    &.nigeria {\n        background-color: #008000 !important;\n    }\n    &.olanda {\n        background-color: #ff6600 !important;\n    }\n    &.danimarca {\n        background-color: #FF4B55 !important;\n    }\n    &.marocco {\n        background-color: #FF4B55 !important;\n    }\n    &.panama {\n        background-color: #FF4B55 !important;\n    }\n    &.per\xF9 {\n        background-color: #FF4B55 !important;\n    }\n    &.portogallo {\n        background-color: #ff0000 !important;\n    }\n    &.russia {\n        background-color: #ff0000 !important;\n    }\n    &.spagna {\n        background-color: #e3000b !important;\n    }\n    &.senegal {\n        background-color: #FFE15A !important;\n    }\n    &.serbia {\n        background-color: #41479B !important;\n    }\n    &.svizzera {\n        background-color: #ff0000 !important;\n    }\n    &.stati-uniti {\n        background-color: #ff0000 !important;\n    }\n    &.uruguay {\n        background-color: #4b8cc1 !important;\n    }\n    &.romania {\n        background-color: #1F5987 !important;\n    }\n    &.albania {\n        background-color: #1F5987 !important;\n    }\n    &.russia {\n        background-color: #1F5987 !important;\n    }\n    &.slovacchia {\n        background-color: #1F5987 !important;\n    }\n    &.ucraina {\n        background-color: #1F5987 !important;\n    }\n    &.polonia {\n        background-color: #1F5987 !important;\n    }\n    &.irlanda-del-nord {\n        background-color: #1F5987 !important;\n    }\n    &.galles {\n        background-color: #1F5987 !important;\n    }\n    &.rep-ceca {\n        background-color: #1F5987 !important;\n    }\n    &.turchia {\n        background-color: #1F5987 !important;\n    }\n    &.tunisia {\n        background-color: #FF4B55 !important;\n    }\n    &.irlanda {\n        background-color: #1F5987 !important;\n    }\n    &.svezia {\n        background-color: #1F5987 !important;\n    }\n    &.islanda {\n        background-color: #1F5987 !important;\n    }\n    &.austria {\n        background-color: #1F5987 !important;\n    }\n    &.ungheria {\n        background-color: #1F5987 !important;\n    }\n    background-image: url("https://images2.gazzettaobjects.it/assets-mc/bkg/shadow-bg.png");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    image-rendering: auto;\n    image-rendering: crisp-edges;\n    ','{\n        min-height: 170px;\n        margin: 30px 0 30px;\n        background-size: auto;\n        background-position: top;\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: baseline;\n  margin-top: 0.8em;\n  ','{\n    margin-top: 4em;\n  };\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: baseline;\n  margin-top: 0.8em;\n  ','{\n    margin-top: 4em;\n  };\n']),_templateObject3=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  margin-top: 0.6em;\n  ','{\n   flex-direction: column;\n  };\n'],['\n  display: flex;\n  flex-direction: row;\n  margin-top: 0.6em;\n  ','{\n   flex-direction: column;\n  };\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 20px;\n  right: 20px;\n\n ','{\n  top: 10px;\n  right: 10px;\n };\n'],['\n  position: absolute;\n  top: 20px;\n  right: 20px;\n\n ','{\n  top: 10px;\n  right: 10px;\n };\n']),_templateObject5=_taggedTemplateLiteral(['\n  color: white;\n  font-size: ',';\n  margin: 0;\n  line-height: 1;\n  text-align: center;\n  font-family: ',';\n  font-weight: 400;\n'],['\n  color: white;\n  font-size: ',';\n  margin: 0;\n  line-height: 1;\n  text-align: center;\n  font-family: ',';\n  font-weight: 400;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}//import shadowBg from '../../utils/assets/shadow-bg.png';
var HeaderWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.theme.mediaQueries.tablet_big_down;});var CentralWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.theme.mediaQueries.tablet_big_down;});var CentralInternalWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(props){return props.theme.mediaQueries.tablet_big_down;});var BookmarkWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.theme.mediaQueries.tablet_big_down;});var TeamName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,function(props){return props.isMobile?'2em':'3.3em';},function(props){return props.theme.fontSets.condensedMedium;});var TeamNameH1=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].h1(_templateObject5,function(props){return props.isMobile?'2em':'3.3em';},function(props){return props.theme.fontSets.condensedMedium;});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogoWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 40px;\n  left: 60px;\n  height: 175px;\n  ',';\n  ',';\n  ','{\n    height: 85px;\n    top: 5px;\n    ',';\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n  }\n'],['\n  position: absolute;\n  top: 40px;\n  left: 60px;\n  height: 175px;\n  ',';\n  ',';\n  ','{\n    height: 85px;\n    top: 5px;\n    ',';\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: auto;\n    width: 180px;\n  '],['\n    height: auto;\n    width: 180px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    margin: ',';\n  '],['\n    margin: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n      height: 50px;\n      top: 40px;\n      width: auto;\n    '],['\n      height: 50px;\n      top: 40px;\n      width: auto;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LogoWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].img(_templateObject,function(props){return props.isDriver&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2);},function(props){return props.margin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject3,props.margin);},function(props){return props.theme.mediaQueries.tablet_big_down;},function(props){return props.isDriver&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4);});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__(159),
    decode = __webpack_require__(160);

exports.decode = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level) {
    return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;

exports.decodeXML = exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__(53)),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__(54)),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function(inverse, name) {
            inverse[obj[name]] = "&" + name + ";";
            return inverse;
        }, {});
}

function getInverseReplacer(inverse) {
    var single = [],
        multiple = [];

    Object.keys(inverse).forEach(function(k) {
        if (k.length === 1) {
            single.push("\\" + k);
        } else {
            multiple.push(k);
        }
    });

    //TODO add ranges
    multiple.unshift("[" + single.join("") + "]");

    return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c) {
    return (
        "&#x" +
        c
            .charCodeAt(0)
            .toString(16)
            .toUpperCase() +
        ";"
    );
}

function astralReplacer(c) {
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    var high = c.charCodeAt(0);
    var low = c.charCodeAt(1);
    var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re) {
    function func(name) {
        return inverse[name];
    }

    return function(data) {
        return data
            .replace(re, func)
            .replace(re_astralSymbols, astralReplacer)
            .replace(re_nonASCII, singleCharReplacer);
    };
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data) {
    return data
        .replace(re_xmlChars, singleCharReplacer)
        .replace(re_astralSymbols, astralReplacer)
        .replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__(54),
    legacyMap = __webpack_require__(161),
    xmlMap = __webpack_require__(53),
    decodeCodePoint = __webpack_require__(162);

var decodeXMLStrict = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map) {
    var keys = Object.keys(map).join("|"),
        replace = getReplacer(map);

    keys += "|#[xX][\\da-fA-F]+|#\\d+";

    var re = new RegExp("&(?:" + keys + ");", "g");

    return function(str) {
        return String(str).replace(re, replace);
    };
}

var decodeHTML = (function() {
    var legacy = Object.keys(legacyMap).sort(sorter);

    var keys = Object.keys(entityMap).sort(sorter);

    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        } else {
            keys[i] += ";";
        }
    }

    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
        replace = getReplacer(entityMap);

    function replacer(str) {
        if (str.substr(-1) !== ";") str += ";";
        return replace(str);
    }

    //TODO consider creating a merged map
    return function(str) {
        return String(str).replace(re, replacer);
    };
})();

function sorter(a, b) {
    return a < b ? 1 : -1;
}

function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            if (str.charAt(2) === "X" || str.charAt(2) === "x") {
                return decodeCodePoint(parseInt(str.substr(3), 16));
            }
            return decodeCodePoint(parseInt(str.substr(2), 10));
        }
        return map[str.slice(1, -1)];
    };
}

module.exports = {
    XML: decodeXMLStrict,
    HTML: decodeHTML,
    HTMLStrict: decodeHTMLStrict
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(163);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }

    if (codePoint in decodeMap) {
        codePoint = decodeMap[codePoint];
    }

    var output = "";

    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
        codePoint = 0xdc00 | (codePoint & 0x3ff);
    }

    output += String.fromCharCode(codePoint);
    return output;
}


/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PreLabelContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 1em;\n  display: inline;\n  font-family: ',';\n  align-self: ',';\n  line-height: ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ::selection{\n    background: none;\n  }\n'],['\n  color: ',';\n  font-size: 1em;\n  display: inline;\n  font-family: ',';\n  align-self: ',';\n  line-height: ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ::selection{\n    background: none;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    display: ',';\n  '],['\n    display: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    color: ',';\n  '],['\n    color: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n  font-size: ','em;\n  '],['\n  font-size: ','em;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    font-weight: ',';\n  '],['\n    font-weight: ',';\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    margin: ',';\n  '],['\n    margin: ',';\n  ']),_templateObject7=_taggedTemplateLiteral(['\n    font-style: ',';\n  '],['\n    font-style: ',';\n  ']),_templateObject8=_taggedTemplateLiteral(['\n    text-align: ','\n  '],['\n    text-align: ','\n  ']),_templateObject9=_taggedTemplateLiteral(['\n    text-transform: uppercase;\n  '],['\n    text-transform: uppercase;\n  ']),_templateObject10=_taggedTemplateLiteral(['\n  font-family: ',';\n'],['\n  font-family: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LabelWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.isHovered?'inherit':''+props.theme.colors.black;},function(props){return props.isTitleNarrowMedium?''+props.theme.fontSets.narrowMedium:''+props.theme.fontSets.narrowRegular;},function(props){return props.alignSelf?''+props.alignSelf:'center';},function(props){return props.lineHeight?''+props.lineHeight:1;},function(props){return props.display&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,props.display);},function(props){return props.color&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject3,props.theme.colors[props.color]);},function(props){return props.size&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4,props.size);},function(props){return props.weight&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject5,props.weight);},function(props){return props.margin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject6,props.margin);},function(props){return props.fontStyle&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject7,props.fontStyle);},function(props){return props.textAlignment&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject8,props.textAlignment);},function(props){return props.uppercase&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject9);});var PreLabelContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject10,function(props){return props.theme.fontSets.narrowMedium;});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_grid_system__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_grid_system___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_configManager_configManager__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_TeamBigLogo__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_TeamLogo__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_Label__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_IconFont__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var imageMap={5861:1,4911:1,1:1,2761:2,1781:2,37:2,33:2,7061:2,7051:2,2:2,10361:2,14:3,3:3,17:4,6901:4,4821:4,4301:4,24:4,8351:4,8561:4,4:4,7691:5,21:5,8121:5,29:5,36:5,6311:5,5011:5,161:5,4971:5,6881:5,7931:5,3961:5,7121:5,3821:5,7941:5,5:5,4011:331,331:331,4791:6,8551:6,8581:6,6:6,6861:22,39:22,4941:22,104:22,8201:22,4351:22,8211:22,5001:22,7521:22,8191:22,79:22,162:22,4141:22,22:22,9201:22,7081:20,52:20,53:20,5511:20,2741:20,2911:20,6281:20,2961:20,8171:20,2751:20,8181:20,103:20,8471:20,20:20,101:19,19:19,5641:501,501:501,46:15,15:15,18:8,6481:8,8111:8,28:8,30:8,8:8,8571:8,9491:8,9191:8,102:61,61:61};var DriverHeader=function(_Component){_inherits(DriverHeader,_Component);function DriverHeader(props){_classCallCheck(this,DriverHeader);var _this=_possibleConstructorReturn(this,(DriverHeader.__proto__||Object.getPrototypeOf(DriverHeader)).call(this,props));_this.getLogo=function(id,compId,teamId){var isSectionScuderie=window.section_lev2==='scuderie';var imageLink='';var motoConstructorUrl=__WEBPACK_IMPORTED_MODULE_3__common_configManager_configManager__["a" /* default */].getMotorSportConstructor();var raceCompetitionName={1:'f1',2:'superbike',3:'motogp',4:'moto3',5:'moto2'};// Added switch to select new logos for Scuderie Section (teamId_n.png)
switch(id){case'6C':if((teamId===2||teamId===3||teamId===4)&&isSectionScuderie){imageLink=''+motoConstructorUrl+raceCompetitionName[compId]+'/'+_this.props.headerInfo.teamId+'_n.png';}else{imageLink=''+motoConstructorUrl+raceCompetitionName[compId]+'/'+_this.props.headerInfo.teamId+'.png';}break;case'6M':imageLink=''+motoConstructorUrl+raceCompetitionName[compId]+'/'+imageMap[_this.props.headerInfo.teamId]+'.png';break;default:imageLink='//images2.gazzettaobjects.it/assets-mc/motori/teams/'+_this.props.dictionary[compId]+'/'+_this.props.headerInfo.teamId+'.png';break;}return imageLink;};_this.teamNameMapping=function(teamId,teamName){switch(teamId){case 4||'4':return'Ferrari';case 2||'2':return'Mercedes F1';case 3||'3':return'Red Bull';default:return teamName;}};_this.state={};return _this;}_createClass(DriverHeader,[{key:'render',value:function render(){var _props=this.props,headerInfo=_props.headerInfo,isMobile=_props.isMobile,competitionId=_props.competitionId,sportId=_props.sportId,newspaper=_props.newspaper;var isGazzetta=newspaper==='gazzetta';var isSectionScuderie=window.section_lev2==='scuderie';if(!isSectionScuderie){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'flex',justifyContent:'flex-start',margin:'10px 0px 0px 15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-back-arrow',color:'black',font:26,onClick:function onClick(){return window.history.back(-1);},withCursor:true,marginLeft:isMobile?0.3:0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{lg:12,md:12,sm:12},headerInfo&&headerInfo.teamId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* HeaderWrapper */],{className:'teamId-'+headerInfo.teamId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_TeamBigLogo__["a" /* default */],{image:this.getLogo(sportId,competitionId,headerInfo.teamId),isDriver:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{lg:12,md:12,sm:12,xs:12,offset:{lg:3,md:2,sm:2,xs:1},style:{justifyContent:'center',display:'flex',paddingLeft:isMobile?'0px':'',paddingRight:isMobile?'0px':'',marginLeft:isMobile?'0px':'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* CentralWrapper */],{justifyContent:sportId==='6C'?'center':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{style:{color:'white',fontSize:isMobile?'2em':'3em',fontFamily:function fontFamily(props){return props.theme.fontSets.narrowMedium;},margin:'0px',lineHeight:'1',textAlign:'center'}},this.teamNameMapping(headerInfo.teamId,headerInfo.team)),sportId!=='6C'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CentralInternalWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Label__["a" /* default */],{label:''+headerInfo.teamEngine,size:isMobile?1:1.1,color:'white',isTitleNarrowRegular:true,uppercase:true,margin:isMobile?'2px 0px':'0px'}),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Label__["a" /* default */],{label:'|',size:isMobile?0.85:1.1,color:'white',isTitleNarrowRegular:true,margin:isMobile?'0em 0 0':'0em 0.2em 0 0.2em'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Label__["a" /* default */],{label:''+headerInfo.teamCarBike,size:isMobile?0.85:1.1,color:'white',isTitleNarrowRegular:true,margin:isMobile?'2px 0px':'0px'})),sportId!=='6M'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CentralInternalWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Label__["a" /* default */],{label:'Punti: '+headerInfo.points,size:isMobile?0.85:1.1,color:'white',isTitleNarrowRegular:true,margin:isMobile?'3px 0px':'0px'}),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Label__["a" /* default */],{label:'|',size:isMobile?0.85:1.1,color:'white',isTitleNarrowRegular:true,margin:isMobile?'0em 0 0':'0em 0.2em 0 0.2em'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Label__["a" /* default */],{label:'Posizione in classifica: '+headerInfo.position,size:isMobile?0.85:1.1,color:'white',isTitleNarrowRegular:true,margin:isMobile?'3px 0px':'0px'}),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Label__["a" /* default */],{label:'|',size:isMobile?0.85:1.1,color:'white',isTitleNarrowRegular:true,margin:isMobile?'0em 0 0':'0em 0.2em 0 0.2em'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Label__["a" /* default */],{label:'Vittorie: '+headerInfo.victories,size:isMobile?0.85:1.1,color:'white',isTitleNarrowRegular:true,margin:isMobile?'3px 0px':'0px'})))),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{lg:3,md:2,sm:2,xs:2}))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'flex',justifyContent:'flex-start',margin:'10px 0px 0px 15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-back-arrow',color:'black',font:26,onClick:function onClick(){return window.history.back(-1);},withCursor:true,marginLeft:isMobile?0.3:0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{lg:12,md:12,sm:12},headerInfo&&headerInfo.teamId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* HeaderWrapper */],{className:'teamId-'+headerInfo.teamId,justifyContent:'unset',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* ContentWrapper */],{flex:'0 0 30%',display:'flex',justifyContent:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_TeamLogo__["a" /* default */],{image:this.getLogo(sportId,competitionId,headerInfo.teamId),isMobile:isMobile,teamId:headerInfo.teamId})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* ContentWrapper */],{flex:'1 1 auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{style:{color:'white',fontSize:isMobile?'2em':'3em',fontFamily:function fontFamily(props){return props.theme.fontSets.narrowMedium;},margin:'0px',lineHeight:'1',textAlign:'center'}},this.teamNameMapping(headerInfo.teamId,headerInfo.team))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* ContentWrapper */],{flex:'0 0 30%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* HeaderShadow */],{isMobile:isMobile,className:'HeaderShadow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'matchcenter-widget','data-widgettype':'NextRaceWidget',id:'nextMatch','data-competitionid':competitionId,'data-sportid':sportId})))));}}}]);return DriverHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DriverHeader.propTypes={headerInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,dictionary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,competitionId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,sportId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,newspaper:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (DriverHeader);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HeaderWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CentralWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CentralInternalWrapper; });
/* unused harmony export BookmarkWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HeaderShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ContentWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  justify-content: ',';\n  align-items: ',';\n  min-height: 137px;\n  margin: 20px 0 40px;\n  background-color: rgb(102, 102, 102);\n  &.teamId-4 {\n    background-color: #FF2800;\n  }\n  &.teamId-3 {\n    background-color: #021b32;\n  }\n  &.teamId-2 {\n    background-color: #5cf1e4;\n  }\n  background-image: url("https://images2.gazzettaobjects.it/assets-mc/bkg/shadow-bg.png");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  image-rendering: auto;\n  image-rendering: crisp-edges;\n  ','{\n      min-height: 170px;\n      margin: 30px 0 30px;\n      background-size: auto;\n      background-position: top;\n  }\n'],['\n  display: flex;\n  flex-direction: row;\n  justify-content: ',';\n  align-items: ',';\n  min-height: 137px;\n  margin: 20px 0 40px;\n  background-color: rgb(102, 102, 102);\n  &.teamId-4 {\n    background-color: #FF2800;\n  }\n  &.teamId-3 {\n    background-color: #021b32;\n  }\n  &.teamId-2 {\n    background-color: #5cf1e4;\n  }\n  background-image: url("https://images2.gazzettaobjects.it/assets-mc/bkg/shadow-bg.png");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  image-rendering: auto;\n  image-rendering: crisp-edges;\n  ','{\n      min-height: 170px;\n      margin: 30px 0 30px;\n      background-size: auto;\n      background-position: top;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: ',';\n  margin-top: 0.8em;\n  margin-bottom: 20px;\n  ','{\n    margin-top: 4em;\n  };\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: ',';\n  margin-top: 0.8em;\n  margin-bottom: 20px;\n  ','{\n    margin-top: 4em;\n  };\n']),_templateObject3=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  margin-top: 0.6em;\n  justify-content: center;\n  margin-bottom: ',';\n  ','{\n   flex-direction: column;\n  };\n'],['\n  display: flex;\n  flex-direction: row;\n  margin-top: 0.6em;\n  justify-content: center;\n  margin-bottom: ',';\n  ','{\n   flex-direction: column;\n  };\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 20px;\n  right: 20px;\n\n ','{\n  top: 10px;\n  right: 10px;\n };\n'],['\n  position: absolute;\n  top: 20px;\n  right: 20px;\n\n ','{\n  top: 10px;\n  right: 10px;\n };\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    top: ',';\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n'],['\n    position: absolute;\n    top: ',';\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n']),_templateObject6=_taggedTemplateLiteral(['\n  flex: ',';\n  display: ',';\n  justify-content: ',';\n'],['\n  flex: ',';\n  display: ',';\n  justify-content: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}//import shadowBg from '../../utils/assets/shadow-bg.png';
var HeaderWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.justifyContent?props.justifyContent:'center';},function(props){return props.alignItems?props.alignItems:'';},function(props){return props.theme.mediaQueries.tablet_big_down;});var CentralWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.justifyContent?props.justifyContent:'baseline';},function(props){return props.theme.mediaQueries.tablet_big_down;});var CentralInternalWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(props){return props.isLast?'20px':'0px';},function(props){return props.theme.mediaQueries.tablet_big_down;});var BookmarkWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.theme.mediaQueries.tablet_big_down;});var HeaderShadow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject5,function(props){return props.isMobile?'145px':'97px';});var ContentWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject6,function(props){return props.flex?props.flex:'';},function(props){return props.display?props.display:'';},function(props){return props.justifyContent?props.justifyContent:'';});/*
 display: flex;
 justify-content: ${props => (props.justifyContent ? props.justifyContent : 'center')};
 align-items: ${props => (props.alignItems ? props.alignItems : 'center')};;
 width: ${props => (props.width ? props.width : '')} */

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(168);
/**
 * Selects a proper dimension for the header image.
 *
 * Some teams images need to be rendered in vertical, others in horizontal format.
 *
 * @param  teamId        String or Integer that identifies the team.
 * @return {Object}      Object that contains the image dimensions both for desktop and mobile.
 */var dimensionSelector=function dimensionSelector(teamId){var dimensionObj=void 0;switch(teamId){case 4||'4':case 2||'2':return dimensionObj={widthMobile:'50px',heightMobile:'100px',widthDesk:'60px',heightDesk:'120px'};case 3||'3':return dimensionObj={widthMobile:'80px',heightMobile:'40px',widthDesk:'160px',heightDesk:'80px'};default:return'';}};var TeamLogo=function TeamLogo(_ref){var image=_ref.image,isMobile=_ref.isMobile,teamId=_ref.teamId;var dimensionObj=dimensionSelector(teamId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* LogoWrapper */],{width:isMobile?dimensionObj.widthMobile:dimensionObj.widthDesk,height:isMobile?dimensionObj.heightMobile:dimensionObj.heightDesk,src:image,onError:function onError(e){e.target.src='https://images2.gazzettaobjects.it/assets-mc/countries/med/noflag.svg';}});};TeamLogo.propTypes={image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,teamId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (TeamLogo);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogoWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n width: ',';\n height: ',';\n'],['\n width: ',';\n height: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LogoWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].img(_templateObject,function(props){return props.width?props.width:'';},function(props){return props.height?props.height:'';});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.min.js